"use strict";
/* ================= CUSTOM LITHIUM 12V RANGE (from customlithium.com.au, Oct 2026) ================= */
const SHOP="https://customlithium.com.au/collections/all/products/";
const RANGES = [
  {id:"ngus",  name:"Next Gen Ultra Slim",    blurb:"Thin enough for behind seats, canopy walls and false floors."},
  {id:"ngxl",  name:"Next Gen Ultra Slim XL", blurb:"Huge capacity in a slim case for big rigs and off-grid builds."},
  {id:"us",    name:"Ultra Slim",             blurb:"The original slim format for tight spaces."},
  {id:"slim",  name:"Slim",                   blurb:"Narrow footprint for 4x4s, caravans and canopies."},
  {id:"ngslim",name:"Next Gen Slim",          blurb:"Updated slim case in aluminium."},
  {id:"compact",name:"Compact",               blurb:"Short, square case for caravan boots and battery boxes."},
  {id:"dual",  name:"Dual Terminal",          blurb:"Terminals at both ends for easy wiring in tight spots."},
  {id:"rv",    name:"Caravan & RV",           blurb:"High-capacity caravan battery with active balancing."}
];
// a = continuous discharge amps and kg where published on the product page
const BATTERIES = [
  {r:"ngus", ah:50,  price:880,  from:false, a:120, kg:13.2, slug:"next-generation-ultra-slim-lithium-battery-50ah", vid:"51687802601784"},
  {r:"ngus", ah:100, price:1480, from:false, a:180, kg:13.2, slug:"next-generation-ultra-slim-lithium-battery-100ah", vid:"49499535409464"},
  {r:"ngus", ah:200, price:2180, from:true,  slug:"next-generation-ultra-slim-lithium-battery-200ah", vid:"51688147812664"},
  {r:"ngus", ah:230, price:2280, from:true,  slug:"next-generation-ultra-slim-lithium-battery-200ah-copy", vid:"51688148074808"},
  {r:"ngus", ah:280, price:2580, from:true,  slug:"next-generation-ultra-slim-lithium-battery-280ah", vid:"51688148336952"},
  {r:"ngus", ah:310, price:2940, from:true,  a:330, kg:26.5, slug:"next-generation-ultra-slim-lithium-battery-310ah", vid:"51688148599096"},
  {r:"ngus", ah:400, price:4080, from:false, slug:"next-generation-ultra-slim-lithium-battery-400ah", vid:"49622305505592"},
  {r:"ngus", ah:460, price:4540, from:false, slug:"next-generation-ultra-slim-lithium-battery-450ah", vid:"49622371107128"},
  {r:"ngus", ah:560, price:5540, from:false, slug:"next-generation-ultra-slim-lithium-battery-550ah", vid:"49622372122936"},
  {r:"ngus", ah:620, price:6140, from:false, slug:"next-generation-ultra-slim-lithium-battery-620ah", vid:"49622376644920"},
  {r:"ngxl", ah:800, price:7899, from:false, a:380, kg:95, slug:"next-generation-ultra-slim-lithium-battery-800ah", vid:"51247695495480"},
  {r:"ngxl", ah:920, price:8599, from:false, slug:"next-generation-ultra-slim-lithium-battery-920ah", vid:"51247703294264"},
  {r:"ngxl", ah:1120,price:10499,from:false, slug:"next-generation-ultra-slim-lithium-battery-1120ah", vid:"51247705653560"},
  {r:"ngxl", ah:1250,price:11999,from:false, slug:"next-generation-ultra-slim-lithium-battery-1250ah", vid:"51247706898744"},
  {r:"us",   ah:100, price:1390, from:false, a:180, kg:13.5, slug:"ultra-slim-lithium-battery-100ah", vid:"49290564567352"},
  {r:"us",   ah:200, price:2090, from:false, a:330, kg:22, slug:"ultra-slim-lithium-battery-200ah", vid:"49290571776312"},
  {r:"us",   ah:230, price:2190, from:false, slug:"ultra-slim-lithium-battery-230ah", vid:"51426239119672"},
  {r:"us",   ah:280, price:2490, from:false, slug:"ultra-slim-lithium-battery-280ah", vid:"49290578362680"},
  {r:"us",   ah:310, price:2850, from:false, slug:"ultra-slim-lithium-battery-310ah", vid:"49290580623672"},
  {r:"slim", ah:100, price:1090, from:false, slug:"slim-lithium-battery-100ah", vid:"49290594320696"},
  {r:"slim", ah:200, price:1990, from:false, a:200, kg:18, slug:"slim-lithium-battery-200ah", vid:"49290595041592"},
  {r:"slim", ah:230, price:2090, from:false, slug:"slim-lithium-battery-230ah", vid:"49934961869112"},
  {r:"slim", ah:310, price:2650, from:false, slug:"slim-lithium-battery-310ah-pre-sale-late-june", vid:"52459757076792"},
  {r:"ngslim",ah:100,price:1090, from:false, slug:"next-generation-slim-lithium-battery-100ah", vid:"50828909281592"},
  {r:"ngslim",ah:200,price:1990, from:false, slug:"next-generation-slim-lithium-battery-200ah", vid:"50211489710392"},
  {r:"ngslim",ah:230,price:2090, from:false, a:200, kg:19, slug:"next-generation-slim-lithium-battery-230ah-presale-june", vid:"50211610034488"},
  {r:"compact",ah:100,price:749, from:false, a:180, kg:11.2, slug:"compact-lithium-battery-100ah", vid:"51987385188664"},
  {r:"compact",ah:200,price:1890,from:false, slug:"compact-lithium-battery-200ah", vid:"49290613555512"},
  {r:"compact",ah:230,price:1995,from:false, slug:"compact-lithium-battery-225ah", vid:"49290614374712"},
  {r:"compact",ah:280,price:2350,from:false, slug:"compact-lithium-battery-280ah", vid:"49290615259448"},
  {r:"compact",ah:310,price:2550,from:false, a:330, kg:25.5, slug:"compact-lithium-battery-310ah", vid:"49290617979192"},
  {r:"dual", ah:200, price:2180, from:false, slug:"duel-terminal-lithium-battery-200ah", vid:"51559279624504"},
  {r:"dual", ah:230, price:2280, from:false, a:330, kg:23, slug:"dual-terminal-lithium-battery-230ah", vid:"51561800827192"},
  {r:"rv",   ah:400, price:3650, from:false, a:380, kg:37.5, slug:"rv-and-caravan-lithium-battery-400ah", vid:"51048115765560"},
  {r:"rv",   ah:460, price:4015, from:false, slug:"rv-and-caravan-lithium-battery-460ah", vid:"49290611097912"},
  {r:"rv",   ah:560, price:4550, from:false, slug:"rv-and-caravan-lithium-battery-560ah", vid:"49290602840376"},
  {r:"rv",   ah:620, price:5100, from:false, a:380, kg:48, slug:"rv-and-caravan-lithium-battery-620ah", vid:"49290608312632"}
].map(b=>({...b, id:b.r+"-"+b.ah, range:RANGES.find(r=>r.id===b.r).name, url:SHOP+b.slug}));
BATTERIES.forEach(b=>b.name=`${b.range} ${b.ah}Ah`);
const batById = id => BATTERIES.find(b=>b.id===id);
const PREFERRED = { caravan:["rv","compact","ngus"], "4wd":["ngus","us","slim","dual","ngslim"], shed:["rv","ngxl","compact","ngus"] };
const MAX_QTY = 4;
// chargers Custom Lithium sells (linked when the size matches)
const DCDC_PRODUCTS = {25:{name:"Redarc BCDC Core 25",slug:"redarc-bcdc-core-25",vid:"49255123353912",price:420},40:{name:"Redarc BCDC Core 40",slug:"redarc-bcdc-core-40",vid:"49255123321144",price:480},50:{name:"Redarc BCDC Alpha50",slug:"redarc-bcdc-alpha50",vid:"50139233812792",price:899}};
// Alpha 75 and Alpha 100 are sold as variants of the Alpha Series + RedVision kit
DCDC_PRODUCTS.alpha75  = {name:"Redarc Alpha 75 + RedVision",  slug:"redarc-alpha-series-charger-with-redvision-monitor", variant:"49255145734456", vid:"49255145734456", price:4899};
DCDC_PRODUCTS.alpha100 = {name:"Redarc Alpha 100 + RedVision", slug:"redarc-alpha-series-charger-with-redvision-monitor", variant:"49255145767224", vid:"49255145767224", price:5899};
const prodUrl = p => SHOP + p.slug + (p.variant ? `?variant=${p.variant}` : "");
DCDC_PRODUCTS.xs50 = {name:"Victron Orion XS 50A",slug:"victron-orion-xs-50a-dc-dc-charger",vid:"49255146455352",price:540};
// DC-DC choices in the "Other charging" dropdown. p = product we sell (links + cart), q = how many in parallel.
const DCDC_OPTIONS = [
  {k:"0",    a:0,   label:"None"},
  {k:"25",   a:25,  label:"25A · Redarc BCDC Core 25", p:25},
  {k:"40",   a:40,  label:"40A · Redarc BCDC Core 40", p:40},
  {k:"50x",  a:50,  label:"50A · Victron Orion XS 50", p:"xs50"},
  {k:"50",   a:50,  label:"50A · Redarc BCDC Alpha 50", p:50},
  {k:"75",   a:75,  label:"75A · Redarc BCDC Alpha 75", p:"alpha75"},
  {k:"80",   a:80,  label:"80A · 2 × Core 40 in parallel", p:40, q:2},
  {k:"100x", a:100, label:"100A · 2 × Orion XS 50 in parallel", p:"xs50", q:2},
  {k:"100",  a:100, label:"100A · Redarc BCDC Alpha 100", p:"alpha100"},
  {k:"150x", a:150, label:"150A · 3 × Orion XS 50 in parallel", p:"xs50", q:3}
];
const dcdcOpt = k => DCDC_OPTIONS.find(o=>o.k===String(k)) || DCDC_OPTIONS.find(o=>o.a===+k) || DCDC_OPTIONS[0];
const REC_DCDC_KEY = {25:"25", 40:"40", 50:"50x", 100:"100x"};   // what we suggest for each recommended size
// Solar controllers. w = Victron's nominal PV power at 12V (100/30: 440W, 100/50: 700W).
const MPPT_OPTIONS = [
  {k:"v30",  a:30,  w:440,  label:"Victron SmartSolar 100/30"},
  {k:"v50",  a:50,  w:700,  label:"Victron SmartSolar 100/50"},
  {k:"2v50", a:100, w:1400, label:"2 × Victron SmartSolar 100/50"},
  {k:"3v50", a:150, w:2100, label:"3 × Victron SmartSolar 100/50"},
  {k:"4v50", a:200, w:2800, label:"4 × Victron SmartSolar 100/50"},
  {k:"5v50", a:250, w:3500, label:"5 × Victron SmartSolar 100/50"},
  {k:"6v50", a:300, w:4200, label:"6 × Victron SmartSolar 100/50"},
  {k:"7v50", a:350, w:4900, label:"7 × Victron SmartSolar 100/50"}
];
// Redarc BCDC Alpha chargers have a built-in solar MPPT. Redarc quotes up to 1000W of panels on the Alpha 50;
// the 75 and 100 are assumed to scale with their rating. Solar and alternator share the charger's output.
const ALPHA_SOLAR = {50:1000, 75:1500, 100:2000};
const CHG_PRODUCTS = {30:{name:"Victron IP22 240V 30A",slug:"victron-ip22-240v-30a-battery-charger",vid:"49255116767544",price:283}};
const MONITOR = {name:"Victron SmartShunt 500A",slug:"victron-smartshunt-500a",vid:"49255123255608",price:159};
const STORE = "https://customlithium.com.au";
function cartLink(items){ return `${STORE}/cart/${items.filter(i=>i.qty>0).map(i=>`${i.vid}:${i.qty}`).join(",")}?storefront=true&ref=12v-battery-simulator`; }
const money = v => "$"+Math.round(v).toLocaleString("en-AU");

/* ================= LOCATIONS + CLIMATE =================
   Approximate long-term monthly averages (Bureau of Meteorology style normals):
   tx = average max °C, tn = average min °C, rd = days with rain (≥1mm). Jan → Dec. */
const LOCS = [
  {id:"darwin",    name:"Darwin & Top End",       state:"NT",  lat:-12.4, tropics:true,
   tx:[32,31.5,32,33,32,31,31,32,33,33.5,33.5,33], tn:[25,25,24.5,24,22.5,21,20,21,23,25,25.5,25.5], rd:[21,20,19,9,2,1,0.5,1,2,7,13,17]},
  {id:"cairns",    name:"Cairns & Far North QLD", state:"QLD", lat:-16.9, tropics:true,
   tx:[31.5,31,30.5,29.5,28,26.5,26,27,28.5,30,31,31.5], tn:[23.5,23.5,23,21.5,19.5,17.5,16.5,17,18.5,20.5,22,23], rd:[17,19,19,15,11,8,6,6,6,7,9,12]},
  {id:"townsville",name:"Townsville",             state:"QLD", lat:-19.3, tropics:true,
   tx:[31.5,31,30.5,29.5,27.5,25.5,25,26,28,29.5,31,31.5], tn:[24,24,23,21,18,15,14,15,18,21,23,24], rd:[13,14,11,6,4,3,2,2,2,4,6,9]},
  {id:"broome",    name:"Broome & Kimberley",     state:"WA",  lat:-17.9, tropics:true,
   tx:[33.5,33,34,34,31,28.5,28.5,30,32,33,33.5,34], tn:[26.5,26,25.5,22.5,18,14.5,13.5,15,19,23,25.5,26.5], rd:[11,12,9,2,2,1,0.5,0.3,0.2,0.3,2,6]},
  {id:"exmouth",   name:"Exmouth & Ningaloo",     state:"WA",  lat:-21.9, tropics:false,
   tx:[37,37,35.5,32,28,25,24.5,26,28,31,33.5,35.5], tn:[22.5,23.5,22,19,15.5,12.5,11,11.5,13,15.5,18,20.5], rd:[2,3,2,1,3,3,2,1,0.3,0.2,0.3,0.5]},
  {id:"alice",     name:"Alice Springs & Red Centre", state:"NT", lat:-23.7, tropics:false,
   tx:[36,35,32.5,28,23,20,20,23,28,31,33.5,35.5], tn:[21.5,21,17.5,12.5,8,5,4,6,10,14.5,17.5,20], rd:[5,5,3,2,3,3,2,2,2,4,5,5]},
  {id:"brisbane",  name:"Brisbane & South East QLD", state:"QLD", lat:-27.5, tropics:false,
   tx:[30,29.5,28.5,27,24.5,22,22,23,25.5,27,28.5,29.5], tn:[21,21,19.5,17,14,11.5,10,11,13.5,16,18.5,20], rd:[12,13,13,10,9,7,6,5,6,8,10,11]},
  {id:"sydney",    name:"Sydney & NSW coast",     state:"NSW", lat:-33.9, tropics:false,
   tx:[26,26,25,23,20,17.5,17,18.5,20.5,22.5,23.5,25.5], tn:[19,19,17.5,15,12,9.5,8.5,9.5,11.5,14,16,18], rd:[12,12,13,11,11,11,9,8,9,10,11,11]},
  {id:"canberra",  name:"Canberra & Southern Tablelands", state:"ACT", lat:-35.3, tropics:false,
   tx:[28.5,27,24,20,15.5,12.5,11.5,13,16.5,19.5,23,26.5], tn:[13.5,13.5,11,6.5,3,1,0,1,3.5,6,9,12], rd:[7,7,7,6,7,8,9,10,9,9,9,8]},
  {id:"highcountry",name:"Victorian High Country", state:"VIC", lat:-36.7, tropics:false,
   tx:[29,28.5,25,20,15,11.5,10.5,12.5,15.5,19,23,26.5], tn:[12,12,9.5,6,3.5,1.5,0.5,1.5,3.5,5.5,8,10.5], rd:[6,6,7,8,11,13,15,15,12,11,9,8]},
  {id:"melbourne", name:"Melbourne & Victorian coast", state:"VIC", lat:-37.8, tropics:false,
   tx:[26,26,24,20,17,14.5,14,15,17,20,22,24], tn:[14.5,15,13.5,11,9,7,6,6.5,8,9.5,11.5,13], rd:[8,7,8,10,12,12,13,13,13,12,10,9]},
  {id:"adelaide",  name:"Adelaide & Flinders Ranges", state:"SA", lat:-34.9, tropics:false,
   tx:[29.5,29.5,26.5,22.5,19,16,15,16.5,19,22,25.5,27.5], tn:[17,17,15,12.5,10,8,7.5,8,9.5,11.5,14,15.5], rd:[4,4,5,8,12,14,16,16,13,10,7,6]},
  {id:"perth",     name:"Perth & South West WA",  state:"WA",  lat:-31.95, tropics:false,
   tx:[31.5,32,30,26.5,23,20,19,19.5,21,24,27,29.5], tn:[18,18.5,16.5,13.5,10.5,9,8,8,9.5,11,14,16], rd:[2,2,3,6,11,15,17,15,12,8,5,3]},
  {id:"hobart",    name:"Hobart & Tasmania",      state:"TAS", lat:-42.9, tropics:false,
   tx:[22,22,20.5,17.5,15,12.5,12,13,15,17,19,20.5], tn:[12,12,11,9,7,5,4.5,5,6,7.5,9,10.5], rd:[10,9,11,12,14,14,15,16,16,15,13,12]}
];
const MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];
const MID_DOY=[15,46,74,105,135,166,196,227,258,288,319,349];
const locById = id => LOCS.find(l=>l.id===id) || LOCS[6];
function clim(){ const L=locById(S.loc), m=S.month; return {tmax:L.tx[m], tmin:L.tn[m], rd:L.rd[m], pWet:Math.min(.9,L.rd[m]/30.4), lat:L.lat, tropics:L.tropics, wetSeason:L.tropics && [10,11,0,1,2,3].includes(m) && L.rd[m]>=8}; }
/** sunrise / sunset and clear-day peak sun hours from latitude and time of year */
const _sunCache={};
function sunFor(lat, m){
  const key=lat+"_"+m; if(_sunCache[key]) return _sunCache[key];
  const doy=MID_DOY[m], phi=lat*Math.PI/180, dec=23.44*Math.PI/180*Math.sin(2*Math.PI*(284+doy)/365);
  const ws=Math.acos(clamp(-Math.tan(phi)*Math.tan(dec),-1,1)), dayLen=24*ws/Math.PI;
  const dr=1+0.033*Math.cos(2*Math.PI*doy/365);
  const H0=(24*60/Math.PI)*0.0820*dr*(ws*Math.sin(phi)*Math.sin(dec)+Math.cos(phi)*Math.cos(dec)*Math.sin(ws)); // MJ/m²/day
  const psh=Math.round(H0/3.6*0.72*10)/10; // clear-sky kWh/m²/day
  return _sunCache[key]={sr:12-dayLen/2+0.15, ss:12+dayLen/2+0.15, psh};
}

/* ================= DATA ================= */
const VNOM = 12.8, CHG_V = 14.2, DERATE = 0.85, INV_EFF = 0.9, INV_IDLE = 12, RESERVE = 0.2, STEP = 1/12;

const WEATHER = {
  sunny:     {name:"Sunny",         f:1.00, icon:"i-sun"},
  partly:    {name:"Partly cloudy", f:0.72, icon:"i-partly"},
  overcast:  {name:"Overcast",      f:0.35, icon:"i-overcast"},
  lightrain: {name:"Light rain",    f:0.22, icon:"i-lightrain"},
  heavyrain: {name:"Heavy rain",    f:0.12, icon:"i-heavyrain"},
  storm:     {name:"Storm",         f:0.07, icon:"i-storm"}
};
const WKEYS = Object.keys(WEATHER);
// clear-day peak sun hours and day length (sunrise/sunset, AEST-ish solar time)
const SUN = {
  north:{summer:{psh:7.0,sr:6.0,ss:19.0}, autumn:{psh:6.5,sr:6.3,ss:18.2}, winter:{psh:6.0,sr:6.8,ss:18.0}, spring:{psh:7.2,sr:6.0,ss:18.6}},
  east: {summer:{psh:7.5,sr:5.2,ss:19.0}, autumn:{psh:5.5,sr:6.1,ss:17.7}, winter:{psh:4.5,sr:6.7,ss:17.2}, spring:{psh:6.8,sr:5.4,ss:18.3}},
  south:{summer:{psh:7.5,sr:5.9,ss:20.6}, autumn:{psh:4.2,sr:6.9,ss:18.1}, winter:{psh:2.8,sr:7.5,ss:17.3}, spring:{psh:6.0,sr:6.2,ss:19.6}}
};
const MPPT_SIZES=[20,30,40,60,100], INV_SIZES=[1000,1500,2000,2500,3000], DCDC_SIZES=[25,40,50,100], CHG_SIZES=[15,25,30,40];

// appliance catalogue: w = running watts, ac = needs 240V inverter, win = start hours, hours = per day, duty = compressor/thermostat cycling
// appliance catalogue
//   w     = rated running watts (what the inverter must be able to supply)
//   avgW  = average draw over a 5-minute step, for gear that only runs for part of it (a coffee shot, a kettle boil)
//   win   = start hour(s), hours = per day, model = temperature- or usage-driven power model (see appW)
// Figures are from manufacturer specs and owner measurements (Dometic, Engel, Bushman, Eberspächer, Webasto,
// Starlink, Apple, ResMed, Truma/Dometic air con), compiled Oct 2026.
const CATALOG = {
  fridge:   {name:"Fridge (12V)", w:45,  ac:false, win:[0],     hours:24, fixed:true, model:"fridge", n:1, count:["fridge","fridges",4], icon:"a-fridge", note:"Works harder in hot weather"},
  freezer:  {name:"Freezer (12V)",        w:45,  ac:false, win:[0],     hours:24, fixed:true, model:"fridge", n:1, count:["freezer","freezers",3], icon:"a-freezer", note:"Freezing uses about 3× a fridge"},
  lights:   {name:"LED lights",           w:20,  ac:false, win:[18],    hours:5,  icon:"a-bulb"},
  pump:     {name:"Water pump",           w:55,  ac:false, win:[7,18.5],hours:.5, step:1/12, icon:"a-drop"},
  usb:      {name:"Phone & USB charging", w:20,  ac:false, win:[20],    hours:2,  icon:"a-phone"},
  kids:     {name:"Charging kids' devices", w:24, ac:false, win:[15,20], hours:1.75, step:.25, model:"kids", n:2, count:["kid","kids",6], icon:"a-tablet", note:"Tablets & phones, plus extra Starlink streaming"},
  fan:      {name:"12V fan",              w:18,  ac:false, win:[13],    hours:5,  icon:"a-fan"},
  heater:   {name:"Diesel heater",        w:34,  ac:false, win:[20],    hours:6,  model:"heater", icon:"a-flame", note:"Draws more the colder it is"},
  cpap:     {name:"CPAP (with humidifier)", w:30, ac:false, win:[22],   hours:8,  icon:"a-moon"},
  compressor:{name:"Air compressor",      w:360, ac:false, win:[16],    hours:.25,step:1/12, icon:"a-gauge"},
  // one Starlink item: about 45W average from the battery covers a Mini or Standard dish in typical use
  starlink: {name:"Starlink",             w:45,  ac:false, win:[8],     hours:8,  model:"starlink", heavy:10, icon:"a-wifi"},
  laptop:   {name:"Laptop",               w:65,  ac:true,  win:[9],     hours:3,  icon:"a-laptop"},
  tv:       {name:"TV (12V, 24–32\")",    w:30,  ac:false, win:[19],    hours:3,  icon:"a-tv"},
  coffee:   {name:"Coffee machine",       w:1300,avgW:600, ac:true,  win:[7],  hours:1/12, step:1/12, icon:"a-coffee", note:"About 2 coffees per 5 min"},
  kettle:   {name:"Electric kettle",      w:2000,avgW:1260,ac:true,  win:[7.5],hours:1/12, step:1/12, icon:"a-kettle", note:"About 1 litre per 5 min"},
  microwave:{name:"Microwave (800W)",     w:1250,ac:true,  win:[12.5,18],hours:.25,step:1/12, icon:"a-microwave"},
  induction:{name:"Induction cooktop",    w:1800,avgW:1100,ac:true, win:[18], hours:1/3, step:1/12, icon:"a-hob"},
  aircon:   {name:"Air conditioner",      w:1250,ac:true,  win:[13],    hours:4,  model:"aircon", icon:"a-snow", note:"Runs harder the hotter it is"},
  hairdryer:{name:"Hair dryer",           w:1200,ac:true,  win:[7.25],  hours:1/12, step:1/12, icon:"a-wind"},
  washer:   {name:"Washing machine",      w:500, avgW:250, ac:true, win:[10], hours:1, icon:"a-washer"},
  tools:    {name:"Power tools",          w:900, ac:true,  win:[9,13],  hours:2,  duty:.5, icon:"a-drill"},
  flood:    {name:"LED floodlights",      w:60,  ac:false, win:[18],    hours:4,  icon:"a-flood"},
  barfridge:{name:"Bar fridge (240V)",    w:90,  ac:true,  win:[0],     hours:24, fixed:true, model:"fridge", n:1, count:["bar fridge","bar fridges",3], icon:"a-fridge", note:"Works harder in hot weather"},
  camera:   {name:"Security camera",      w:8,   ac:false, win:[0],     hours:24, fixed:true, icon:"a-camera"},
  toolchg:  {name:"Tool battery charger", w:120, ac:true,  win:[12],    hours:2,  icon:"a-charger"},
  radio:    {name:"Radio / speaker",      w:15,  ac:false, win:[9],     hours:6,  icon:"a-speaker"}
};
const SCEN = {
  caravan:{name:"Caravan", driveLbl:"Towing hours per day",
    cfg:{batId:"compact-310", qty:1, bat:310, soc:90, panels:2, panelW:200, mppt:30, mpptKey:"v30", dcdc:40, dcdcKey:"40", driveH:0, charger:0, src:"site", genH:2, inverter:2000, portW:0, portH:4},
    apps:{fridge:1,freezer:0,lights:1,pump:1,usb:1,kids:0,tv:1,coffee:1,laptop:0,starlink:0,aircon:0,microwave:0,induction:0,kettle:0,hairdryer:0,washer:0,fan:0,heater:0,cpap:0}},
  "4wd":{name:"4WD", driveLbl:"Driving hours per day",
    cfg:{batId:"ngus-200", qty:1, bat:200, soc:90, panels:1, panelW:200, mppt:30, mpptKey:"v30", dcdc:25, dcdcKey:"25", driveH:3, charger:0, src:"gen", genH:2, inverter:1000, portW:0, portH:4},
    apps:{fridge:1,freezer:0,lights:1,usb:1,kids:0,compressor:1,laptop:0,coffee:0,starlink:0,cpap:0,fan:0,heater:0,pump:0,induction:0}},
  shed:{name:"Off-grid shed", driveLbl:"",
    cfg:{batId:"rv-400", qty:2, bat:800, soc:90, panels:4, panelW:400, mppt:150, mpptKey:"3v50", dcdc:0, dcdcKey:"0", driveH:0, charger:0, src:"gen", genH:2, inverter:3000, portW:0, portH:4},
    apps:{flood:1,tools:1,barfridge:1,freezer:0,radio:1,usb:1,camera:1,toolchg:0,lights:0,pump:0,kettle:0,coffee:0,starlink:0,aircon:0,microwave:0}}
};

/* ================= STATE ================= */
const S = {
  scen:"caravan", loc:"brisbane", month:new Date().getMonth(), weather:"sunny",
  plan:null, planPreset:"live", view:"daily", tripDays:7, auditDay:0,
  climate:{ac:false, acAt:30, heat:false, heatAt:12},
  week:null, weekPattern:"mix",
  cfg:{}, apps:{}
};
/* ---------- temperature + simulation environment ---------- */
const TEMPS = { // typical daily max / min °C
  north:{summer:[34,25],autumn:[32,21],winter:[29,15],spring:[34,22]},
  east: {summer:[30,20],autumn:[26,15],winter:[21,8], spring:[27,15]},
  south:{summer:[27,14],autumn:[21,10],winter:[14,5], spring:[20,9]}
};
const WX_TMAX={sunny:2,partly:0,overcast:-3,lightrain:-4,heavyrain:-5,storm:-3};
const WX_TMIN={sunny:-1.5,partly:0,overcast:1.5,lightrain:1.5,heavyrain:1.5,storm:1};
/** ENV tells the engine which weather + temperatures apply (live view, report plan, or the simulated week) */
const ENV = { wx:(d,t)=>S.weather, week:null };
function withEnv(env, fn){ const p={wx:ENV.wx, week:ENV.week}; Object.assign(ENV,env); try{ return fn(); } finally { Object.assign(ENV,p); } }
function dayTemps(d){
  if(ENV.week){ const w=ENV.week.days[((d%7)+7)%7]; return {tmax:w.tmax, tmin:w.tmin}; }
  const k=clim(), w=ENV.wx(d, d*24+13);
  return {tmax:k.tmax+WX_TMAX[w]*0.7, tmin:k.tmin+WX_TMIN[w]*0.7};
}
function tempAt(t){
  const d=Math.floor(t/24), hod=t-d*24, k=dayTemps(d);
  let f; if(hod>=6&&hod<=15) f=0.5-0.5*Math.cos(Math.PI*(hod-6)/9); else { const h=hod>15?hod-15:hod+9; f=0.5+0.5*Math.cos(Math.PI*h/15); }
  return k.tmin+(k.tmax-k.tmin)*f;
}
function climateWants(a, t){ // kept for older callers: is a climate-controlled appliance drawing power right now?
  if(!isAuto(a)) return null;
  return appW(a, t, false) > 0;
}
const isAuto = a => (a.id==="aircon" && S.climate.ac) || (a.id==="heater" && S.climate.heat);
for (const k in SCEN){
  S.cfg[k] = {...SCEN[k].cfg};
  S.apps[k] = Object.keys(SCEN[k].apps).map((id,i)=>({id, ...CATALOG[id], on:!!SCEN[k].apps[id], hours:CATALOG[id].hours, phase:(i*15)%60}));
}
const cfg = () => S.cfg[S.scen];
function applyBat(c){ const b=batById(c.batId); c.bat=b.ah*c.qty; return b; }
const apps = () => S.apps[S.scen];

/* ================= ENGINE ================= */
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const lerp=(a,b,t)=>a+(b-a)*t;
function sunInfo(){ return sunFor(locById(S.loc).lat, S.month); }
function shape(hod, sr, ss){ if(hod<=sr||hod>=ss) return 0; return Math.pow(Math.sin(Math.PI*(hod-sr)/(ss-sr)),1.25); }
const _peakCache={};
function peakFactor(si){
  const key=si.sr+"_"+si.ss+"_"+si.psh; if(_peakCache[key]) return _peakCache[key];
  let integ=0; for(let h=0;h<24;h+=0.01) integ+=shape(h,si.sr,si.ss)*0.01;
  return _peakCache[key]=si.psh/integ;
}
/** clear-sky solar watts reaching the controller for 1W of panel */
/* Solar: irradiance as a fraction of 1000W/m² (g), then real-world losses.
   PV_BASE covers controller, wiring and dust losses. Panels also lose about 0.4% per °C of cell temperature
   above 25°C, and cells run about 31°C above the air in full sun (NOCT), so hot days cost noticeably more. */
const PV_BASE=0.95, PV_TC=0.004;
function pvTempFactor(Tamb, g){ return 1 - PV_TC*((Tamb + 31*g) - 25); }
function irr(hod){ const si=sunInfo(); return shape(hod,si.sr,si.ss)*peakFactor(si); }
function solarPerW(hod, t, wf=1){ const g=irr(hod)*wf; return g*PV_BASE*pvTempFactor(t===undefined ? clim().tmax : tempAt(t), g); }
/** typical whole-day derating for sizing (midday heat, average sun) */
function pvDayDerate(){ return PV_BASE*pvTempFactor(clim().tmax-2, 0.75); }
function inWindow(hod, start, len){ return ((hod-start+24)%24) < len - 1e-6; }
function appRunning(a, t){
  t=Math.round(t*12000)/12000; // snap away floating-point drift
  const hod=((t%24)+24)%24, n=a.win.length, L=a.hours/n;
  if (a.hours<=0) return false;
  let on=false;
  if (L>=24) on=true; else for(const s of a.win){ if(inWindow(hod,s,L)){on=true;break;} }
  if(!on) return false;
  if(a.duty && a.duty<1){ const m=((t*60 + a.phase)%60+60)%60; return m < Math.round(a.duty*12)*5 - 1e-6; } // on-time snapped to 5-min steps so live view and report agree
  return true;
}
function inSchedule(a, t){ // within the user's daily on-hours (ignores thermostat cycling)
  t=Math.round(t*12000)/12000;
  const hod=((t%24)+24)%24, n=a.win.length, L=a.hours/n;
  if(a.hours<=0) return false; if(L>=24) return true;
  for(const s of a.win){ if(inWindow(hod,s,L)) return true; } return false;
}
/* ---------- appliance power models ---------- */
const minuteOf = (t, phase)=> ((t*60 + (phase||0))%60+60)%60;
const dutyOn = (t, duty, phase)=> minuteOf(t,phase) < Math.round(clamp(duty,0,1)*12)*5 - 1e-6; // on-time in 5-min steps
const hourTemp = t => tempAt(Math.floor(t+1e-9)+0.5); // temperature for this hour, so cycling stays steady within the hour
// Compressor fridges: share of time the compressor runs, by air temperature.
// 12V 45-55L fridge averages about 9W at 25°C, 17W at 32°C and 26W at 40°C (manufacturer Ah/h figures +15% for door openings).
// Freezing (-18°C) uses roughly 2.5-3.5x the energy of fridge mode.
const FRIDGE_MODEL = { fridge:{base:.20, up:.025, dn:.010, min:.08}, freezer:{base:.55, up:.03, dn:.015, min:.25}, barfridge:{base:.35, up:.02, dn:.010, min:.12} };
/** rated watts if everything in this line runs at once (several fridges can all start together) */
const ratedW = a => a.w * (a.count && a.model!=="kids" ? (a.n||1) : 1);
function fridgeDuty(a, t){ const m=FRIDGE_MODEL[a.id]||FRIDGE_MODEL.fridge, T=hourTemp(t); return clamp(m.base + (T>25 ? m.up*(T-25) : -m.dn*(25-T)), m.min, .95); }
// Rooftop air con: compressor duty rises with outside temperature (about 60% at 30°C, 90% at 35°C, flat out above 38°C)
function acDuty(t){ return clamp((hourTemp(t) - 25 + 4)/15, .35, 1); }
// Diesel heater: fan and fuel pump speed up as it gets colder: about 10W idling to 32W flat out.
function heatFrac(t){ return clamp((20 - tempAt(t))/16, .2, 1); }
function heaterOn(a, t){
  if(isAuto(a)){ const T=tempAt(t); if(T>=S.climate.heatAt) return false;
    if(S.climate.heatAt - T < 2) return minuteOf(t, a.phase) < 40 - 1e-6;   // only just cold: thermostat cycles it on and off
    return true; }
  return !!a.on && inSchedule(a, t);
}
// Kids' devices: tablets and phones charging (about 40Wh each per full charge from 12V via USB-C),
// and streaming 3:30pm to 7:30pm, which keeps Starlink busier.
function kidsApp(){ return apps().find(x=>x.id==="kids"); }
function kidsStreaming(t){ const k=kidsApp(); if(!k || !k.on) return 0; const hod=((t%24)+24)%24; return (hod>=15.5 && hod<19.5) ? (k.n||1) : 0; }
/** watts an appliance draws at time t (0 when off). forced = "Run now" in the live view. */
function appW(a, t, forced){
  t=Math.round(t*12000)/12000;
  switch(a.model){
    case "fridge": {
      if(!a.on && !forced) return 0;
      const duty=fridgeDuty(a,t); let w=0;
      for(let i=0;i<(a.n||1);i++) if(dutyOn(t, duty, a.phase + i*25)) w+=a.w;   // several fridges cycle at different times
      return w;
    }
    case "aircon": {
      const want = isAuto(a) ? tempAt(t) > S.climate.acAt : (a.on && inSchedule(a,t));
      if(forced) return a.w;
      return want && dutyOn(t, acDuty(t), a.phase) ? a.w : 0;
    }
    case "heater": {
      const now = heaterOn(a,t) || !!forced, prev = heaterOn(a, t-STEP);
      if(now && !prev) return 110;                // glow plug start: about 100W for 3-5 min
      if(!now && prev) return 45;                 // shutdown purge: fan and glow plug clean-out
      return now ? Math.round(10 + 22*heatFrac(t)) : 0;
    }
    case "starlink": {
      const kids = a.on ? kidsStreaming(t) : 0;
      if(!((a.on && inSchedule(a,t)) || kids || forced)) return 0;
      return a.w + (kids ? Math.min(a.heavy, 3*kids + 3) : 0);   // heavier data use adds a little
    }
    case "kids": {
      if(!((a.on && appRunning(a,t)) || forced)) return 0;
      return a.w * (a.n||1);
    }
    default: {
      if(!((a.on && appRunning(a,t)) || forced)) return 0;
      return a.avgW || a.w;
    }
  }
}
/** portable / deployable panels: set out for portH hours centred on solar noon, with their own controller */
function portableOut(c, hod){ if(!(c.portW>0) || !(c.portH>0)) return false; const si=sunInfo(); return inWindow(hod, (si.sr+si.ss)/2 - c.portH/2, c.portH); }
/* ---------- solar controller ---------- */
function alphaA(c){ if(S.scen==="shed") return 0; const o=dcdcOpt(c.dcdcKey||c.dcdc); return ({50:50, alpha75:75, alpha100:100})[o.p]||0; }
function solarCtrl(c){
  const a=alphaA(c);
  if(c.mpptKey==="alpha" && a) return {k:"alpha", a, w:ALPHA_SOLAR[a], via:true, label:`Built into Redarc Alpha ${a}`};
  const o=MPPT_OPTIONS.find(x=>x.k===c.mpptKey) || MPPT_OPTIONS.find(x=>x.a>=c.mppt) || MPPT_OPTIONS[0];
  return {...o, via:false};
}
/** smallest controller that handles `watts` of fixed panels (prefers the Alpha's built-in MPPT when it can) */
function bestCtrlKey(c, watts){
  const a=alphaA(c); if(a && watts<=ALPHA_SOLAR[a]) return "alpha";
  return (MPPT_OPTIONS.find(x=>x.w>=watts) || MPPT_OPTIONS[MPPT_OPTIONS.length-1]).k;
}
function drivingAt(c, hod){ return S.scen!=="shed" && c.dcdc>0 && c.driveH>0 && inWindow(hod, 9, c.driveH); }
function chargerAt(c, hod){
  if(!c.charger) return false;
  if(c.src==="site") return true;
  return c.genH>0 && inWindow(hod,17,c.genH);
}

/**
 * Instantaneous flows (watts) at absolute time t (hours).
 * wf = weather solar factor. socWh/capWh for full/flat handling. runNow = {id: untilT}
 */
function flowsAt(c, list, t, wf, socWh, capWh, runNow){
  const hod=((t%24)+24)%24;
  const clearW = c.panels*c.panelW*solarPerW(hod, t, wf);
  const dcdcW = drivingAt(c,hod) ? c.dcdc*CHG_V : 0;
  const ct = solarCtrl(c);
  const mpptMax = ct.via ? Math.max(0, ct.a*CHG_V - dcdcW) : ct.a*CHG_V;   // an Alpha shares its output between alternator and solar
  const portW = portableOut(c,hod) ? c.portW*solarPerW(hod, t, wf) : 0;
  const solarAvail = Math.min(clearW, mpptMax) + portW;
  const clipped = clearW > mpptMax + 1;
  const chgW  = chargerAt(c,hod) ? c.charger*CHG_V : 0;
  let dc=0, acServed=0, acPeak=0, acReq=0; const running=[], unpowered=[], runW={};
  let anyAC=false;
  for(const a of list){
    const forced = runNow && runNow[a.id] && runNow[a.id] > t;
    if(a.ac && (a.on || isAuto(a))) anyAC=true;
    const w = appW(a, t, forced);
    if(!(w>0)) continue;
    if(!a.ac){ dc+=w; running.push(a); runW[a.id]=w; continue; }
    anyAC=true; const rw=ratedW(a); acReq+=rw;
    if(c.inverter>0 && acPeak + rw <= c.inverter){ acPeak+=rw; acServed+=w; running.push(a); runW[a.id]=w; }
    else unpowered.push({a, why: c.inverter>0 ? "Inverter too small" : "Needs inverter"});
  }
  const invW = (c.inverter>0 && anyAC) ? acServed/INV_EFF + INV_IDLE : 0;
  let loadW = dc + invW;
  let solarW = solarAvail, dW=dcdcW, cW=chgW;
  let state="normal";
  const net0 = solarW + dW + cW - loadW;
  if(socWh >= capWh - 0.01 && net0 > 0){
    // battery full: chargers throttle back to just carry the loads
    let excess=net0;
    const cut=(v)=>{const r=Math.min(v,excess); excess-=r; return v-r;};
    solarW=cut(solarW); cW=cut(cW); dW=cut(dW);
    state="full";
  }
  let served=1;
  if(socWh <= 0.01 && (solarW+dW+cW-loadW) < 0){
    const avail=solarW+dW+cW; served = loadW>0 ? clamp(avail/loadW,0,1) : 1; loadW=avail; state="flat";
  }
  return {solarW, dcdcW:dW, chgW:cW, dcW:dc*served, invW:invW*served, loadW, acServed:acServed*served, net:solarW+dW+cW-loadW,
          running, runW, unpowered, clipped, state, served, clearW, solarAvail, mpptMax, acReq};
}

/** Run a full simulation from 00:00 for `days` days. weatherOf(d,t) -> weather key. */
function simulate(c, list, days, weatherOf, opts={}){
  return withEnv({wx:weatherOf, week: opts.week!==undefined ? opts.week : (S.planPreset==="week" ? S.week : null)}, ()=>{
  const capWh = c.bat*VNOM;
  let soc = capWh*(c.soc/100);
  const steps = Math.round(days*24/STEP);
  const series = opts.series ? [] : null, audit = opts.audit ? [] : null;
  const perDay = [];
  let minSoc=soc, minAt=0, flatAt=null, peakAC=0, fullAt=null;
  const appWh = {}; list.forEach(a=>appWh[a.id]=0);
  for(let i=0;i<steps;i++){
    const t=i*STEP, d=Math.floor(t/24);
    if(!perDay[d]) perDay[d]={solar:0,dcdc:0,chg:0,used:0,inv:0,min:Infinity,minAt:0,flat:false,tmax:-99,tmin:99};
    const w = weatherOf(d, t);
    const f = flowsAt(c, list, t, WEATHER[w].f, soc, capWh, null);
    if(f.acReq>peakAC) peakAC=f.acReq;
    const pd=perDay[d];
    pd.solar+=f.solarW*STEP; pd.dcdc+=f.dcdcW*STEP; pd.chg+=f.chgW*STEP; pd.used+=f.loadW*STEP;
    for(const a of f.running){ const w=f.runW[a.id]; appWh[a.id]+= (a.ac ? w/INV_EFF : w)*STEP*f.served; }
    if(f.invW>0) pd.inv += (INV_IDLE + f.acServed*(1/INV_EFF-1))*STEP;
    const temp=tempAt(t); if(temp>pd.tmax) pd.tmax=temp; if(temp<pd.tmin) pd.tmin=temp;
    soc = clamp(soc + f.net*STEP, 0, capWh);
    if(f.served<1){ pd.flat=true; if(flatAt===null) flatAt=t; }
    if(soc<minSoc){minSoc=soc;minAt=t+STEP;}
    if(soc<pd.min){pd.min=soc;pd.minAt=t+STEP;}
    if(soc>=capWh-0.01 && fullAt===null && t>0) fullAt=t;
    if(series && i%(opts.every||1)===0) series.push({t:t+STEP, soc:soc/capWh*100, solar:f.solarW, dcdc:f.dcdcW, chg:f.chgW, load:f.loadW});
    if(audit) audit.push({t, w, temp, soc:soc/capWh*100, solar:f.solarW, dcdc:f.dcdcW, chg:f.chgW,
      on:f.running.map(a=>a.id), ow:f.runW, blocked:f.unpowered.map(u=>u.a.id).concat(f.served<0.99?f.running.map(a=>a.id):[]), flat:f.served<0.99});
  }
  return {capWh, perDay, minSoc, minPct:minSoc/capWh*100, minAt, flatAt, series, audit, peakAC, appWh, endSoc:soc, fullAt};
  });
}

/** quick demand total per day (Wh from battery), unconstrained, in today's live weather */
function dailyDemand(c, list){
  let wh=0, peak=0, peakDC=0;
  for(let t=0;t<24;t+=STEP){
    let ac=0, acPk=0, dc=0, anyAC=false;
    for(const a of list){ if(a.ac && (a.on||isAuto(a))) anyAC=true; const w=appW(a,t,false); if(!(w>0)) continue; if(a.ac){ ac+=w; acPk+=ratedW(a); } else dc+=w; }
    const inv = anyAC ? ac/INV_EFF+INV_IDLE : 0;
    wh += (dc+inv)*STEP; if(acPk>peak) peak=acPk; if(dc>peakDC) peakDC=dc;
  }
  return {wh, peakAC:peak, peakDC};
}

/* ================= RECOMMENDATIONS ================= */
function planWeather(d, t){
  if(S.planPreset==="week" && S.week){ const day=S.week.days[d%7]; const hod=t===undefined?12:((t%24)+24)%24; return day.w[Math.min(7,Math.floor(hod/3))]; }
  if(!S.plan) return S.weather;
  return S.plan[d%7];
}
function planMain(d){ return (S.planPreset==="week" && S.week) ? S.week.days[d%7].main : planWeather(d); }
function nextSize(v, sizes){ for(const s of sizes) if(s>=v) return s; return null; }

function recommend(){
  const c = cfg(), list = apps(), D = S.tripDays;
  // demand from a simulation with an unlimited battery, so climate-driven loads are counted too
  const big = simulate({...c, bat:100000, soc:50}, list, Math.min(D,7), planWeather);
  const nd0 = big.perDay.length;
  const dem = { wh: big.perDay.reduce((s,p)=>s+p.used,0)/nd0, peakAC: big.peakAC };
  const si = sunInfo(), pf = peakFactor(si);
  // non-solar charge per day as configured
  let other=0; for(let t=0;t<24;t+=STEP){ const hod=t; if(drivingAt(c,hod)) other+=c.dcdc*CHG_V*STEP; if(chargerAt(c,hod)) other+=c.charger*CHG_V*STEP; }
  // portable panels count as extra charge on top of the fixed solar we size
  let portWh=0; for(let t=0;t<24;t+=STEP) if(portableOut(c,t)) portWh+=c.portW*solarPerW(t)*STEP;
  // solar yield per W of panel per day, averaged over the plan
  let wfAvg=0; const nd=Math.min(D,7); for(let d=0;d<nd;d++){ let s=0; for(let b=0;b<8;b++) s+=WEATHER[planWeather(d,b*3+1.5)].f*shape(b*3+1.5,si.sr,si.ss); let n=0; for(let b=0;b<8;b++) n+=shape(b*3+1.5,si.sr,si.ss); wfAvg+= n? s/n : WEATHER[planWeather(d)].f; } wfAvg/=nd;
  other += portWh*wfAvg;
  const yieldPerW = si.psh*pvDayDerate()*wfAvg; // Wh per W per day
  const need = Math.max(0, dem.wh - other);
  let solarW = need>0 ? need*1.15/Math.max(yieldPerW,0.05) : 0;
  let panels = Math.max(0, Math.ceil(solarW / c.panelW - 0.001));
  let solarCapped=false;
  if(panels>12){ panels=12; solarCapped=true; }
  if(panels<1 && (need>0 || c.panels>0 || c.portW>0)) panels=1;   // keep at least one fixed panel: it charges while you are away or driving
  const recSolarW = panels*c.panelW;
  const mpptKey = bestCtrlKey(c, recSolarW), ctrlRec = solarCtrl({...c, mpptKey});
  const mppt = ctrlRec.a, mpptCount = 1;
  // battery search with recommended solar
  const trial = {...c, panels, mpptKey, soc:c.soc};
  let bat=null, batCapped=false;
  const ok = ah => simulate({...trial, bat:ah}, list, D, planWeather).minPct >= RESERVE*100 - 0.01;
  const HI = 5000;
  if(ok(50)) bat=50;
  else if(!ok(HI)){ bat=HI; batCapped=true; }
  else { let lo=50, hi=HI; while(hi-lo>10){ const mid=Math.round((lo+hi)/20)*10; if(ok(mid)) hi=mid; else lo=mid; } bat=hi; }
  // never below one full day of use with no charging at all (keeps the 20% reserve)
  const minAuto = Math.ceil(dem.wh/(VNOM*(1-RESERVE))/10)*10;
  if(minAuto>bat) bat=minAuto;
  // peak current the battery bank must supply (12V gear + inverter at full load)
  let peakDC=0; withEnv({wx:planWeather, week:S.planPreset==="week"?S.week:null},()=>{ for(let t=0;t<24*Math.min(D,7);t+=STEP){ let w=0; for(const a of list){ if(a.ac) continue; w+=appW(a,t,false); } if(w>peakDC) peakDC=w; } });
  const needAmps = (peakDC + (dem.peakAC>0 ? dem.peakAC/INV_EFF : 0))/VNOM;
  const pickIn = ranges => {
    let best=null;
    for(const b of BATTERIES){ if(!ranges.includes(b.r)) continue;
      for(let q=1;q<=MAX_QTY;q++){ if(b.ah*q<bat) continue; if(b.a && b.a*q < needAmps) continue;
        const cost=b.price*q + (q-1)*400; // prefer one battery unless parallel units are clearly cheaper (cabling, fusing, install)
        if(!best || cost<best.cost || (cost===best.cost && b.ah*q<best.ah)) best={b,q,ah:b.ah*q,cost}; break; } }
    return best;
  };
  const curRange = batById(c.batId).r;
  const inRange = pickIn([curRange]);
  const pref = pickIn(PREFERRED[S.scen]);
  const any = pickIn(RANGES.map(r=>r.id));
  const batPick = inRange || pref || any;
  const batAlt = pref && batPick && pref.b.id!==batPick.b.id ? pref : null;
  if(!batPick) batCapped=true;
  const inv = dem.peakAC>0 ? nextSize(dem.peakAC*1.2, INV_SIZES) : 0;
  const invCapped = dem.peakAC>0 && inv===null;
  const bankAh = batPick ? batPick.ah : bat;
  const dcdc = (S.scen!=="shed") ? (nextSize(bankAh*0.2, DCDC_SIZES) || 100) : 0;
  const chg = nextSize(bankAh*0.15, CHG_SIZES) || 40;
  return {dem, other, wfAvg, yieldPerW, panels, recSolarW, solarCapped, mppt, mpptCount, mpptKey, ctrlRec, bat, batCapped, batPick, batAlt, needAmps, bankAh, inv: invCapped?3000:inv, invCapped, dcdc, chg};
}

/* ================= SCENE (SVG) ================= */
const NS="http://www.w3.org/2000/svg";
function E(tag, attrs={}, parent){ const el=document.createElementNS(NS,tag); for(const k in attrs){ if(attrs[k]!==undefined && attrs[k]!==null) el.setAttribute(k,attrs[k]); } if(parent) parent.appendChild(el); return el; }
const world = document.getElementById("world");
let SC = null; // current scene refs

const COL = {
  body:"#FBFCFB", bodyLine:"#C9D4CF", dark:"#2A3330", darker:"#1C2321", glass:"#3A4B52", glassHi:"#56707A",
  tyre:"#1E2422", rim:"#C7D0CC", panel:"#22384D", panelLine:"#4E6B84", panelFrame:"#A9B6BC",
  trunk:"#E7E3DA", leaf1:"#9EB99A", leaf2:"#86A584", leaf3:"#B3C9AE"
};

function defs(){
  const d=E("defs",{},world);
  const g=E("linearGradient",{id:"gBrand",x1:"0",x2:"1",y1:"0",y2:"0"},d);
  E("stop",{offset:"0","stop-color":"#A1CD3A"},g); E("stop",{offset:"1","stop-color":"#06A74F"},g);
  const gr=E("linearGradient",{id:"gGround",x1:"0",x2:"0",y1:"0",y2:"1"},d);
  E("stop",{offset:"0","stop-color":"#EEE8D6"},gr); E("stop",{offset:"1","stop-color":"#E3D8BE"},gr);
  const glow=E("radialGradient",{id:"gGlow"},d);
  E("stop",{offset:"0","stop-color":"#FFE6A3","stop-opacity":".95"},glow); E("stop",{offset:"1","stop-color":"#FFE6A3","stop-opacity":"0"},glow);
  const cone=E("linearGradient",{id:"gCone",x1:"0",x2:"0",y1:"0",y2:"1"},d);
  E("stop",{offset:"0","stop-color":"#FFF2C4","stop-opacity":".75"},cone); E("stop",{offset:"1","stop-color":"#FFF2C4","stop-opacity":"0"},cone);
  const sh=E("filter",{id:"fShadow",x:"-20%",y:"-20%",width:"140%",height:"160%"},d);
  E("feDropShadow",{dx:"0",dy:"2",stdDeviation:"3","flood-color":"#0E1311","flood-opacity":".18"},sh);
  return d;
}

function tree(p, x, base, s=1, variant=0){
  const g=E("g",{transform:`translate(${x} ${base}) scale(${s})`},p);
  E("path",{d:"M-4 0 C -3 -40 -8 -70 -2 -110 L 4 -110 C 2 -80 6 -40 5 0 Z",fill:COL.trunk,stroke:"#CFC8BA","stroke-width":1},g);
  E("path",{d:"M0 -80 L -22 -112 M2 -95 L 24 -125",stroke:COL.trunk,"stroke-width":4,"stroke-linecap":"round"},g);
  const L=[COL.leaf2,COL.leaf1,COL.leaf3];
  const blobs = variant ? [[-28,-118,30,20],[22,-132,32,22],[-4,-150,34,24],[0,-120,26,18]] : [[-26,-112,28,18],[24,-128,30,20],[0,-146,32,22],[-6,-124,24,16]];
  blobs.forEach((b,i)=>E("ellipse",{cx:b[0],cy:b[1],rx:b[2],ry:b[3],fill:L[i%3]},g));
  return g;
}
function hillsPath(y0, amp, seed){
  // tileable 1200-wide hill outline starting and ending at y0
  let d=`M0 ${y0}`; const n=6;
  for(let i=0;i<n;i++){ const x0=i*200, x1=x0+200; const h=y0-amp*(0.5+0.5*Math.sin(seed+i*1.7));
    d+=` C ${x0+60} ${h}, ${x1-60} ${h}, ${x1} ${y0 - (i===n-1?0: amp*0.2*Math.cos(seed+i))}`; }
  return d+` L1200 ${y0+120} L0 ${y0+120} Z`;
}
function tiled(parent, build){ const g=E("g",{},parent); const a=E("g",{},g); build(a); for(const k of [-3,-2,-1,1,2,3,4]){ const b=a.cloneNode(true); b.setAttribute("transform",`translate(${1200*k} 0)`); g.appendChild(b); } return g; }

function wheel(p, cx, cy, r, at){
  const g=E("g",{transform:`translate(${cx} ${cy})`},p);
  E("circle",{r:r,fill:COL.tyre},g);
  const spin=E("g",{},g);
  if(at){ // chunky all-terrain tread blocks + darker off-road rim
    const n=22, circ=2*Math.PI*(r-1.5);
    E("circle",{r:r-1.5,fill:"none",stroke:"#3A4441","stroke-width":4,"stroke-dasharray":`${(circ/n*0.55).toFixed(2)} ${(circ/n*0.45).toFixed(2)}`},spin);
    E("circle",{r:r*0.78,fill:"none",stroke:"#2C3331","stroke-width":1.2},spin);
  }
  E("circle",{r:r*(at?0.52:0.58),fill:at?"#6B7672":COL.rim},g);
  for(let i=0;i<(at?6:5);i++){ const a=i*(at?60:72)*Math.PI/180; E("line",{x1:0,y1:0,x2:Math.cos(a)*r*0.46,y2:Math.sin(a)*r*0.46,stroke:at?"#3E4744":"#8E9A95","stroke-width":r*(at?0.14:0.12),"stroke-linecap":"round"},spin); }
  E("circle",{r:r*0.16,fill:at?"#2C3331":"#5F6B66"},g);
  return {g, spin};
}

/** Boxy touring 4WD wagon, facing right. x0 = rear of body. Generic design: no badges. */
function wagon(p, x0, o={}){
  const g=E("g",{},p), X=v=>x0+v;
  const body=o.color||"#F7F9F8", line=COL.bodyLine, trim="#2F3836";
  const wr=34, wy=444, rw=X(70), fw=X(276);
  // roof rack
  E("rect",{x:X(14),y:268,width:216,height:6,rx:2,fill:"#3A4441"},g);
  for(const lx of [22,82,142,202]) E("rect",{x:X(lx),y:274,width:5,height:9,fill:"#3A4441"},g);
  E("rect",{x:X(14),y:261,width:4,height:10,rx:1,fill:"#3A4441"},g); E("rect",{x:X(226),y:261,width:4,height:10,rx:1,fill:"#3A4441"},g);
  if(o.swag){ E("rect",{x:X(36),y:252,width:96,height:16,rx:8,fill:"#7A8468"},g); E("line",{x1:X(64),y1:252,x2:X(64),y2:268,stroke:"#5E6752","stroke-width":2},g); E("line",{x1:X(104),y1:252,x2:X(104),y2:268,stroke:"#5E6752","stroke-width":2},g);
    E("rect",{x:X(150),y:250,width:30,height:18,rx:3,fill:"#B8402E"},g); E("rect",{x:X(184),y:250,width:30,height:18,rx:3,fill:"#B8402E"},g); }
  // rear wheel carrier
  if(o.spare!==false){ E("rect",{x:X(-9),y:320,width:17,height:78,rx:7,fill:COL.tyre},g); E("rect",{x:X(-5),y:334,width:6,height:50,rx:3,fill:"#4A5450"},g); }
  if(o.towbar){ // square receiver out from under the rear bumper, a drop tongue down to coupling height, and the tow ball
    E("rect",{x:X(-6),y:424,width:26,height:8,rx:1.5,fill:"#2A3330"},g);           // receiver tube
    E("rect",{x:X(-9),y:422,width:5,height:12,rx:1,fill:"#3A4441"},g);             // hitch pin plate
    E("path",{d:`M${X(-6)} 426 L${X(-12)} 426 L${X(-12)} 456 L${X(-24)} 456 L${X(-24)} 449 L${X(-17)} 449 L${X(-17)} 432 L${X(-6)} 432 Z`,fill:"#3A4441"},g); // drop tongue
    E("circle",{cx:X(-20),cy:446,r:4.2,fill:"#8E9A95"},g);                          // tow ball
  }
  // body
  E("path",{d:`M${X(8)} 412 L${X(8)} 296 Q${X(8)} 282 ${X(22)} 282 L${X(222)} 282 Q${X(230)} 282 ${X(233)} 289 L${X(256)} 338 L${X(322)} 344 Q${X(336)} 346 ${X(336)} 360 L${X(336)} 410 Q${X(336)} 418 ${X(328)} 418 L${X(16)} 418 Q${X(8)} 418 ${X(8)} 410 Z`,fill:body,stroke:line,"stroke-width":1.5,"stroke-linejoin":"round"},g);
  // glasshouse with blacked-out pillars
  E("path",{d:`M${X(18)} 332 L${X(18)} 300 Q${X(18)} 293 ${X(25)} 293 L${X(225)} 293 L${X(244)} 332 Z`,fill:"#26302E"},g);
  E("rect",{x:X(23),y:297,width:62,height:31,rx:4,fill:COL.glass},g);
  E("rect",{x:X(94),y:297,width:64,height:31,rx:4,fill:COL.glass},g);
  E("path",{d:`M${X(166)} 297 L${X(221)} 297 L${X(237)} 328 L${X(166)} 328 Z`,fill:COL.glass},g);
  for(const gx of [36,108,182]) E("path",{d:`M${X(gx)} 326 L${X(gx+18)} 299`,stroke:COL.glassHi,"stroke-width":5,"stroke-linecap":"round",opacity:.55},g);
  // shut lines, crease, handles
  for(const lx of [90,162,240]) E("line",{x1:X(lx),y1:334,x2:X(lx),y2:400,stroke:line,"stroke-width":1.3},g);
  E("line",{x1:X(10),y1:368,x2:X(334),y2:368,stroke:line,"stroke-width":1},g);
  E("rect",{x:X(140),y:344,width:14,height:4,rx:2,fill:"#9AA6A1"},g); E("rect",{x:X(214),y:344,width:14,height:4,rx:2,fill:"#9AA6A1"},g);
  // lower cladding
  E("path",{d:`M${X(8)} 400 L${X(336)} 400 L${X(336)} 410 Q${X(336)} 418 ${X(328)} 418 L${X(16)} 418 Q${X(8)} 418 ${X(8)} 410 Z`,fill:"#3A4441"},g);
  // wheel flares + arches
  for(const cx of [rw,fw]){
    E("path",{d:`M${cx-50} 418 L${cx-50} 408 A50 44 0 0 1 ${cx+50} 408 L${cx+50} 418 Z`,fill:trim},g);
    E("path",{d:`M${cx-42} 422 L${cx-42} 414 A42 38 0 0 1 ${cx+42} 414 L${cx+42} 422 Z`,fill:COL.darker},g);
  }
  // rock slider + side step
  E("rect",{x:rw+48,y:418,width:fw-rw-96,height:9,rx:3,fill:"#46544E"},g);
  // mirror, headlight, indicator
  E("path",{d:`M${X(238)} 316 l11 -3 l2 13 l-11 2 z`,fill:"#26302E"},g);
  E("rect",{x:X(327),y:349,width:10,height:15,rx:3,fill:"#FFE7A3",stroke:"#C9B26A"},g);
  E("rect",{x:X(10),y:338,width:6,height:18,rx:2,fill:"#C9483A"},g);
  // snorkel up the A-pillar
  E("path",{d:`M${X(262)} 396 L${X(262)} 346 L${X(241)} 300 L${X(241)} 270`,fill:"none",stroke:"#262E2C","stroke-width":8,"stroke-linejoin":"round","stroke-linecap":"round"},g);
  E("rect",{x:X(236),y:258,width:20,height:13,rx:4,fill:"#262E2C"},g);
  // steel bull bar + driving lights
  E("path",{d:`M${X(332)} 343 L${X(352)} 347 Q${X(359)} 349 ${X(359)} 357 L${X(361)} 422 Q${X(361)} 430 ${X(353)} 430 L${X(338)} 430 Q${X(333)} 430 ${X(333)} 424 Z`,fill:trim},g);
  E("line",{x1:X(339),y1:352,x2:X(354),y2:355,stroke:"#55605C","stroke-width":2,"stroke-linecap":"round"},g);
  E("line",{x1:X(340),y1:384,x2:X(356),y2:384,stroke:"#55605C","stroke-width":2,"stroke-linecap":"round"},g);
  E("rect",{x:X(352),y:398,width:12,height:6,rx:2,fill:"#E9A93A"},g);
  const spots=[];
  E("rect",{x:X(343),y:339,width:4,height:6,fill:"#3A4441"},g);
  E("circle",{cx:X(346),cy:332,r:8,fill:"#3A4441"},g); spots.push(E("circle",{cx:X(348),cy:332,r:5,fill:"#EDE7CF"},g));
  // tyres
  const wheels=[wheel(g,rw,wy,wr,true), wheel(g,fw,wy,wr,true)];
  return {g, wheels, spots, engine:{x:X(304),y:390}, X};
}

/** solar panel on a roof plane: base line y, x, width; perspective lean */
function panel(p, x, y, w, lean=7, depth=13){
  const g=E("g",{},p);
  E("polygon",{points:`${x},${y} ${x+w},${y} ${x+w+lean},${y-depth} ${x+lean},${y-depth}`,fill:COL.panel,stroke:COL.panelFrame,"stroke-width":1.4,"stroke-linejoin":"round"},g);
  const cells=Math.max(3,Math.round(w/22));
  for(let i=1;i<cells;i++){ const fx=x+w*i/cells; E("line",{x1:fx,y1:y,x2:fx+lean,y2:y-depth,stroke:COL.panelLine,"stroke-width":.8},g); }
  E("line",{x1:x+lean/2,y1:y-depth/2,x2:x+w+lean/2,y2:y-depth/2,stroke:COL.panelLine,"stroke-width":.8},g);
  const glint=E("polygon",{points:`${x+w*0.15},${y} ${x+w*0.35},${y} ${x+w*0.35+lean},${y-depth} ${x+w*0.15+lean},${y-depth}`,fill:"#FFFFFF",opacity:0},g);
  return {g, glint};
}
/** free-standing portable/ground-mount panel */
function groundPanel(p, x, base, w=78, h=52){
  const g=E("g",{},p);
  E("line",{x1:x+w*0.75,y1:base,x2:x+w*0.62,y2:base-h*0.62,stroke:"#7D8984","stroke-width":3,"stroke-linecap":"round"},g);
  E("polygon",{points:`${x},${base} ${x+w},${base-6} ${x+w*0.8},${base-h} ${x-w*0.2+w*0.2},${base-h+6}`,fill:COL.panel,stroke:COL.panelFrame,"stroke-width":1.6,"stroke-linejoin":"round"},g);
  for(let i=1;i<4;i++){ const t=i/4; E("line",{x1:x+w*t,y1:base-6*t,x2:x+w*0.8*t+ (0)*t, y2:base-h+6-(6)*t+ (h-6)*0 ,stroke:COL.panelLine,"stroke-width":.8,opacity:0},g); }
  // cell grid via simple lines
  E("line",{x1:x+w*0.5,y1:base-3,x2:x+w*0.4,y2:base-h+3,stroke:COL.panelLine,"stroke-width":.9},g);
  E("line",{x1:x+w*0.1,y1:base-h*0.5+2,x2:x+w*0.9,y2:base-h*0.5-3,stroke:COL.panelLine,"stroke-width":.9},g);
  const glint=E("polygon",{points:`${x+w*0.2},${base-1} ${x+w*0.32},${base-2} ${x+w*0.26},${base-h+4} ${x+w*0.14},${base-h+5}`,fill:"#fff",opacity:0},g);
  return {g, glint};
}
/* scale the wordmark down evenly (never squash it) so it fits the battery face */
const BAT_LABELS=[];
function fitBatLabel(L){ try{ const ts=L.ts||[L.t]; ts.forEach(t=>t.setAttribute("font-size",L.f0)); const w=Math.max(...ts.map(t=>t.getComputedTextLength())); const f=w>L.tw ? L.f0*L.tw/w : L.f0; ts.forEach(t=>t.setAttribute("font-size",f.toFixed(2)));
    if(L.mid!==undefined){ ts[0].setAttribute("y",(L.mid-f*0.14).toFixed(2)); ts[1].setAttribute("y",(L.mid+f*0.86).toFixed(2)); } }catch(e){} }
function refitBatLabels(){ BAT_LABELS.forEach(fitBatLabel); }
function batteryBox(p, x, y, w, h, stack){
  const g=E("g",{},p);
  E("rect",{x:x-6,y:y-6,width:w+12,height:h+12,rx:10,fill:"#F6FAF8",stroke:"#06A74F","stroke-width":1.6,"stroke-dasharray":"4 4"},g);
  E("rect",{x,y,width:w,height:h,rx:5,fill:"#151B19"},g);
  E("rect",{x:x+6,y:y-4,width:8,height:4,rx:1,fill:"#5F6B66"},g);
  E("rect",{x:x+w-14,y:y-4,width:8,height:4,rx:1,fill:"#5F6B66"},g);
  if(stack){ // logo beside a stacked CUSTOM / LITHIUM wordmark
    const bh=h-21, lh=bh*0.8, lw=lh*384/326, mid=y+5+bh/2;
    const lg=E("g",{transform:`translate(${x+6} ${mid-lh/2}) scale(${lh/326})`},g); E("path",{d:LOGO_D, fill:"url(#gBrand)"},lg);
    const tx=x+6+lw+lh*0.2, tw=Math.max(16, x+w-6-tx), f0=bh*0.46;
    const t1=E("text",{x:tx,y:y+6+bh*0.44,"font-size":f0,"font-family":"Noto Sans, sans-serif",fill:"#F2F9F6","font-weight":"400"},g); t1.textContent="CUSTOM";
    const t2=E("text",{x:tx,y:y+6+bh*0.98,"font-size":f0,"font-family":"Noto Sans, sans-serif",fill:"#F2F9F6","font-weight":"700"},g); t2.textContent="LITHIUM";
    const L={ts:[t1,t2], tw, f0, mid}; BAT_LABELS.push(L); fitBatLabel(L);
  } else {
  // tiny logo mark
  const lg=E("g",{transform:`translate(${x+6} ${y+6}) scale(${(h*0.32)/326})`},g);
  E("path",{d:LOGO_D, fill:"url(#gBrand)"},lg);
  { const tx=x+6+h*0.4, tw=Math.max(20, x+w-6-tx), f0=h*0.22;
    const t=E("text",{x:tx,y:y+6+h*0.25,"font-size":f0,"font-family":"Noto Sans, sans-serif",fill:"#F2F9F6"},g);
    const a=E("tspan",{"font-weight":"400"},t); a.textContent="CUSTOM ";
    const b=E("tspan",{"font-weight":"700"},t); b.textContent="LITHIUM";
    BAT_LABELS.push({t, tw, f0}); fitBatLabel(BAT_LABELS[BAT_LABELS.length-1]); }
  }
  E("rect",{x:x+6,y:y+h-13,width:w-12,height:7,rx:3.5,fill:"#2E3835"},g);
  const fill=E("rect",{x:x+6,y:y+h-13,width:(w-12)*0.8,height:7,rx:3.5,fill:"url(#gBrand)"},g);
  return {g, fill, fw:w-12, cx:x+w/2, cy:y+h/2, top:y-6};
}
function chip(p){
  const g=E("g",{class:"chip",filter:"url(#fShadow)"},p);
  const r=E("rect",{rx:13,height:26,fill:"#FFFFFF",class:"chip-bg"},g);
  const tri=E("path",{fill:"#FFFFFF",class:"chip-bg"},g);
  const dot=E("circle",{r:4,fill:"#06A74F"},g);
  const t=E("text",{"font-size":13,"font-family":"Noto Sans, sans-serif","font-weight":"600",fill:"#0E1311",class:"chip-t"},g);
  let last="";
  const o={g, vis:true, ax:0, ay:0, w:0, dx:0, dy:0, color:"#06A74F",
    set(x,y,txt,color){ // x,y = anchor tip; geometry only, drawn by place()
      if(txt!==last){ t.textContent=txt; last=txt; }
      o.w = (t.getComputedTextLength ? t.getComputedTextLength() : txt.length*7) + 30;
      o.ax=x; o.ay=y; o.color=color||"#06A74F"; o.dx=0; o.dy=0;
    },
    side:false, // true = label sits to the left, pointer points right at the anchor
    rect(){ if(o.side) return {l:o.ax-10-o.w+o.dx, r:o.ax-10+o.dx, t:o.ay-13-o.dy, b:o.ay+13-o.dy};
            return {l:o.ax-o.w/2+o.dx, r:o.ax+o.w/2+o.dx, t:o.ay-34-o.dy, b:o.ay-8-o.dy}; },
    place(){
      const {l,t:ry}=o.rect(), x=o.ax, y=o.ay;
      r.setAttribute("x",l.toFixed(1)); r.setAttribute("y",ry.toFixed(1)); r.setAttribute("width",o.w.toFixed(1));
      if(o.side){ const rr=o.rect(); tri.setAttribute("d", `M${rr.r-2} ${ry+7} L${x} ${y} L${rr.r-2} ${ry+19} Z`); }
      else tri.setAttribute("d", o.dy>0 ? `M${x-5} ${ry+24} L${x} ${y} L${x+5} ${ry+24} Z` : `M${x-6} ${y-8.5} L${x} ${y} L${x+6} ${y-8.5} Z`);
      dot.setAttribute("cx",l+13); dot.setAttribute("cy",ry+13); dot.setAttribute("fill",o.color);
      t.setAttribute("x",l+22); t.setAttribute("y",ry+17.5);
    },
    show(v){ o.vis=!!v; g.style.display=v?"":"none"; } };
  return o;
}
function flowLine(p, d, color){
  const g=E("g",{},p);
  const base=E("path",{d,fill:"none",stroke:color,"stroke-width":7,"stroke-opacity":.18,"stroke-linecap":"round"},g);
  const dash=E("path",{d,fill:"none",stroke:color,"stroke-width":3.2,"stroke-linecap":"round","stroke-dasharray":"1 13"},g);
  return {g, dash, off:0};
}
function chair(p, x, base, color="#06A74F"){
  const g=E("g",{},p);
  E("path",{d:`M${x} ${base} L${x+26} ${base-34} M${x+30} ${base} L${x+4} ${base-34}`,stroke:"#46544E","stroke-width":2.4,"stroke-linecap":"round"},g);
  E("path",{d:`M${x-2} ${base-32} Q${x+15} ${base-26} ${x+32} ${base-32} L${x+30} ${base-62} Q${x+15} ${base-58} ${x+2} ${base-62} Z`,fill:color,opacity:.85},g);
  return g;
}
function table(p, x, base, w=46){
  const g=E("g",{},p);
  E("rect",{x:x,y:base-30,width:w,height:5,rx:2,fill:"#C9BFA7"},g);
  E("path",{d:`M${x+6} ${base-25} L${x+2} ${base} M${x+w-6} ${base-25} L${x+w-2} ${base}`,stroke:"#8F8672","stroke-width":2.4,"stroke-linecap":"round"},g);
  return g;
}
function bollard(p, x, base){
  const g=E("g",{},p);
  E("rect",{x:x-12,y:base-64,width:24,height:64,rx:4,fill:"#E9EEEC",stroke:"#B8C4BF"},g);
  E("rect",{x:x-8,y:base-56,width:16,height:12,rx:2,fill:"#06A74F"},g);
  E("path",{d:`M${x-3} ${base-52} l2 -2 l0 4 l2 -2`,stroke:"#fff","stroke-width":1.2,fill:"none"},g);
  return {g, ax:x, ay:base-64};
}
function generator(p, x, base){
  const g=E("g",{},p);
  const body=E("g",{},g);
  E("rect",{x:x-34,y:base-46,width:68,height:42,rx:8,fill:"#F2F5F3",stroke:"#A9B6B0","stroke-width":1.4},body);
  E("rect",{x:x-26,y:base-38,width:30,height:26,rx:3,fill:"#DCE3E0"},body);
  for(let i=0;i<4;i++) E("line",{x1:x+8,y1:base-36+i*7,x2:x+26,y2:base-36+i*7,stroke:"#A9B6B0","stroke-width":1.6},body);
  E("rect",{x:x-30,y:base-52,width:60,height:7,rx:3.5,fill:"#46544E"},body);
  E("rect",{x:x-30,y:base-6,width:10,height:6,fill:"#46544E"},g); E("rect",{x:x+20,y:base-6,width:10,height:6,fill:"#46544E"},g);
  const puffs=E("g",{},g);
  const pf=[0,1,2].map(i=>E("circle",{cx:x+30,cy:base-50,r:5,fill:"#C9D1CE",opacity:0},puffs));
  return {g, body, pf, ax:x, ay:base-52};
}

let LOGO_D = "";

function buildScene(){
  world.innerHTML=""; BAT_LABELS.length=0;
  defs();
  const s = {scen:S.scen, roof:[], ground:[], wheels:[], glows:[], props:[], movers:[], fans:[]};
  // ---- background ----
  s.farHills = tiled(world, g=>E("path",{d:hillsPath(372,34,1.3),fill:"#CFE0D6"},g));
  s.nearHills = tiled(world, g=>E("path",{d:hillsPath(408,26,4.2),fill:"#B8CFBC"},g));
  s.trees = tiled(world, g=>{
    tree(g,  70, 438, .92, 1); tree(g, 1135, 440, 1.05, 0); tree(g, 960, 418, .62, 1); tree(g, 600, 414, .5, 0); tree(g, 260, 420, .58, 0);
  });
  E("rect",{x:-4000,y:430,width:9200,height:1800,fill:"url(#gGround)"},world);
  // grass tufts / ground texture
  const tufts=E("g",{fill:"none",stroke:"#B9C49F","stroke-width":1.6,"stroke-linecap":"round"},world);
  for(let i=0;i<120;i++){ const x=-2400+(i*137)%6000, y=446+((i*53)%200); E("path",{d:`M${x} ${y} l-3 -7 M${x} ${y} l0 -9 M${x} ${y} l4 -7`},tufts); }
  if(S.scen!=="shed"){
    E("rect",{x:-4000,y:462,width:9200,height:40,fill:"#DDD1B4"},world);
    E("rect",{x:-4000,y:462,width:9200,height:2,fill:"#CFC2A2"},world);
    s.dashes = tiled(world, g=>{ for(let x=0;x<1200;x+=80) E("rect",{x, y:488, width:34, height:3, rx:1.5, fill:"#F4EEDD"},g); });
  } else {
    E("ellipse",{cx:620,cy:484,rx:470,ry:26,fill:"#DCD2B9"},world);
    const fence=E("g",{stroke:"#B9AF98","stroke-width":2},world);
    for(let x=-2400;x<3600;x+=46){ E("line",{x1:x,y1:446,x2:x,y2:428},fence); }
    E("line",{x1:-2400,y1:432,x2:3600,y2:432,stroke:"#C9C0AA","stroke-width":1.5},world);
  }
  s.shadowG = E("g",{},world);
  s.propsG = E("g",{},world);
  s.mainG = E("g",{},world);
  if(S.scen==="caravan") buildCaravan(s);
  else if(S.scen==="4wd") buildUte(s);
  else buildShed(s);
  // ---- overlay + glows + flows + chips ----
  s.night = E("rect",{x:-4000,y:-2000,width:9200,height:5000,fill:"#0B1A2E",opacity:0,"pointer-events":"none"},world);
  s.glowG = E("g",{},world);
  s.glows.forEach(fn=>fn(s.glowG));
  s.glowG.appendChild(s.bat.g); // battery stays readable at night
  s.flowG = E("g",{},world);
  s.fl = {
    solar: flowLine(s.flowG, s.paths.solar, "#06A74F"),
    dcdc:  flowLine(s.flowG, s.paths.dcdc,  "#06A74F"),
    chg:   flowLine(s.flowG, s.paths.chg,   "#06A74F"),
    load:  flowLine(s.flowG, s.paths.load,  "#5B63D6")
  };
  s.propFx=E("g",{},world);
  buildProps(s);
  s.chipG=E("g",{},world);
  s.chips = {solar:chip(s.chipG), bat:chip(s.chipG), load:chip(s.chipG), dcdc:chip(s.chipG), chg:chip(s.chipG)};
  if(s.loadSide) s.chips.load.side=true;
  SC = s;
  updatePanels(); updateProps(); syncProps(false); fitView(true);
}

function buildCaravan(s){
  const P=s.propsG, M=s.mainG;
  // shadows
  s.shadows=[E("ellipse",{cx:500,cy:480,rx:230,ry:9,fill:"#0E1311",opacity:.12},s.shadowG), E("ellipse",{cx:968,cy:480,rx:185,ry:8,fill:"#0E1311",opacity:.12},s.shadowG)];
  // ground panels (portable)
  s.groundSlots=[{x:18,base:492},{x:104,base:494},{x:-60,base:496}];
  s.groundG=E("g",{},P);
  // festoon pole + chairs
  s.campG=E("g",{},P);
  s.festG=E("g",{},s.campG);
  E("line",{x1:196,y1:478,x2:196,y2:292,stroke:"#8F8672","stroke-width":3},s.festG);
  s.festoon="M196 296 Q252 322 306 290";
  E("path",{d:s.festoon,fill:"none",stroke:"#5F6B66","stroke-width":1.2},s.festG);
  s.bulbs=[]; for(let i=1;i<6;i++){ const t=i/6; const x=(1-t)*(1-t)*196+2*(1-t)*t*252+t*t*306, y=(1-t)*(1-t)*296+2*(1-t)*t*322+t*t*290; s.bulbs.push(E("circle",{cx:x,cy:y+3,r:3.4,fill:"#E9E3CF",stroke:"#9BA49F","stroke-width":.8},s.festG)); }
  s.fgG=E("g",{},world); // foreground props added after main
  s.bollard=bollard(P,250,478); s.gen=generator(P,250,482);
  // ---- caravan ----
  const cv=E("g",{},M);
  const clip=E("clipPath",{id:"cvClip"},world.querySelector("defs")); E("rect",{x:300,y:280,width:400,height:168,rx:26},clip);
  E("rect",{x:300,y:280,width:400,height:168,rx:26,fill:COL.body,stroke:COL.bodyLine,"stroke-width":1.5},cv);
  const inner=E("g",{"clip-path":"url(#cvClip)"},cv);
  E("rect",{x:300,y:420,width:400,height:30,fill:COL.dark},inner);
  E("path",{d:"M300 404 C 420 404 470 372 560 366 S 660 356 700 340 L700 356 C 660 370 600 378 560 382 S 430 418 300 418 Z",fill:"url(#gBrand)"},inner);
  E("path",{d:"M300 396 C 410 396 470 366 560 359 S 660 350 700 334 L700 338 C 660 354 600 362 560 366 S 420 400 300 400 Z",fill:"#46544E",opacity:.55},inner);
  E("rect",{x:300,y:280,width:400,height:6,fill:"#E3EAE7"},inner);
  // windows
  s.win=[ [322,312,72,50], [598,306,82,54] ];
  s.win.forEach(w=>{ E("rect",{x:w[0],y:w[1],width:w[2],height:w[3],rx:8,fill:COL.glass,stroke:"#2A3330","stroke-width":2},cv); E("path",{d:`M${w[0]+10} ${w[1]+w[3]-6} L${w[0]+w[2]*0.55} ${w[1]+6}`,stroke:COL.glassHi,"stroke-width":6,"stroke-linecap":"round",opacity:.6},cv); });
  // door
  E("rect",{x:430,y:302,width:60,height:118,rx:6,fill:"#F2F6F4",stroke:COL.bodyLine,"stroke-width":1.5},cv);
  E("rect",{x:440,y:313,width:40,height:32,rx:5,fill:COL.glass},cv);
  E("rect",{x:478,y:366,width:5,height:14,rx:2,fill:"#8E9A95"},cv);
  E("rect",{x:432,y:446,width:56,height:6,rx:2,fill:"#5F6B66"},cv);
  // wheel arch + wheel
  E("path",{d:"M486 450 A34 34 0 0 1 554 450 Z",fill:COL.darker},cv);
  s.wheels.push(wheel(cv,520,452,26));
  // drawbar, gas bottles, jockey
  E("path",{d:"M698 436 L772 449 L772 456 L698 452 Z",fill:COL.dark},cv);
  E("rect",{x:708,y:404,width:16,height:34,rx:7,fill:"#E9EEEC",stroke:"#AEB9B4"},cv); E("rect",{x:727,y:404,width:16,height:34,rx:7,fill:"#E9EEEC",stroke:"#AEB9B4"},cv);
  E("line",{x1:752,y1:446,x2:752,y2:463,stroke:"#46544E","stroke-width":4},cv); E("circle",{cx:752,cy:465,r:5.5,fill:COL.tyre},cv); // jockey wheel wound up for towing
  // roof plane + aircon
  E("polygon",{points:"318,281 682,281 672,270 328,270",fill:"#DCE4E0"},cv);
  const ac=E("g",{},cv); s.acG=ac;
  E("rect",{x:462,y:250,width:96,height:28,rx:8,fill:"#EEF2F0",stroke:"#BFCAC5","stroke-width":1.4},ac);
  for(let i=0;i<5;i++) E("line",{x1:472+i*10,y1:258,x2:472+i*10,y2:272,stroke:"#BFCAC5","stroke-width":2,"stroke-linecap":"round"},ac);
  const fan=E("g",{transform:"translate(534 264)"},ac); E("circle",{r:9,fill:"#DCE4E0"},fan);
  const blades=E("g",{},fan); for(let i=0;i<3;i++) E("path",{d:"M0 0 Q 4 -4 0 -8 Q -3 -4 0 0",fill:"#7D8984",transform:`rotate(${i*120})`},blades);
  s.fans.push({g:blades, id:"aircon", a:0});
  s.roofSlots=[{x:322,y:281,w:118},{x:574,y:281,w:104}];
  s.roofG=E("g",{},cv);
  // battery cutaway (front boot)
  s.bat = batteryBox(cv, 604, 378, 86, 34);
  // ---- tow vehicle: boxy touring 4WD wagon ----
  const tow=wagon(M, 794, {color:"#E3E8E6", towbar:true, spare:false, swag:true});
  tow.wheels.forEach(w=>s.wheels.push(w));
  // coupling head sitting over the tow ball (drawn after the vehicle so it covers the ball), plus safety chains
  const cpl=E("g",{},M);
  E("path",{d:"M764 445 Q764 438 771 438 L780 438 Q786 438 786 444 L786 450 L764 453 Z",fill:COL.dark},cpl);
  E("rect",{x:768,y:434,width:10,height:4,rx:2,fill:"#3A4441"},cpl);             // coupling lever
  E("path",{d:"M766 455 Q774 470 785 456",fill:"none",stroke:"#7D8984","stroke-width":1.6,"stroke-dasharray":"2.5 1.6"},cpl);
  s.engine=tow.engine;
  // foreground chairs
  s.fg=E("g",{},world);
  chair(s.fg,358,522); table(s.fg,398,522,86); chair(s.fg,494,522,"#46544E");
  s.lantern=E("circle",{cx:476,cy:486,r:5,fill:"#E9E3CF",stroke:"#9BA49F"},s.fg);
  // glows
  s.glows.push(G=>{ s.winGlow=s.win.map(w=>E("rect",{x:w[0]+2,y:w[1]+2,width:w[2]-4,height:w[3]-4,rx:6,fill:"#FFE3A0",opacity:0},G));
    s.bulbGlow=s.bulbs.map(b=>E("circle",{cx:b.getAttribute("cx"),cy:b.getAttribute("cy"),r:14,fill:"url(#gGlow)",opacity:0},G));
    s.lanternGlow=E("circle",{cx:476,cy:486,r:26,fill:"url(#gGlow)",opacity:0},G); });
  s.paths={
    solar:"M380 268 C 380 220, 560 225, 646 300 L 646 374",
    load:"M612 396 C 540 396, 470 390, 360 352",
    dcdc:"M1098 390 C 1030 404, 830 420, 700 400",
    chg:"M250 414 C 250 380, 280 360, 304 356"
  };
  s.loadAnchor={x:362,y:392}; s.solarAnchor={x:380,y:262}; s.chgAnchor={x:250,y:412};
  s.drivable=true;
}

function buildUte(s){
  const P=s.propsG, M=s.mainG;
  s.shadows=[E("ellipse",{cx:600,cy:480,rx:195,ry:9,fill:"#0E1311",opacity:.12},s.shadowG)];
  s.groundSlots=[{x:20,base:492},{x:106,base:494},{x:-60,base:496}];
  s.groundG=E("g",{},P);
  s.campG=E("g",{},P);
  s.bollard=bollard(P,320,478); s.gen=generator(P,318,482);
  const x0=420;
  const v=wagon(M, x0, {color:"#F7F9F8"});
  const X=v.X, u=v.g;
  v.wheels.forEach(w=>s.wheels.push(w));
  // awning bag along the rack
  E("rect",{x:X(18),y:274,width:206,height:7,rx:3.5,fill:"#5E6B5C"},u);
  // rear cargo area shown as a cutaway: fridge + battery on a drawer system
  E("rect",{x:X(16),y:300,width:146,height:98,rx:6,fill:"#E6ECE9",stroke:"#06A74F","stroke-width":1.6,"stroke-dasharray":"4 4"},u);
  E("rect",{x:X(20),y:388,width:138,height:9,rx:2,fill:"#2A3330"},u);
  s.fridgeG=E("g",{},u);
  E("rect",{x:X(22),y:334,width:58,height:54,rx:6,fill:"#FBFCFB",stroke:"#BFCAC5","stroke-width":1.4},s.fridgeG);
  E("rect",{x:X(22),y:334,width:58,height:12,rx:6,fill:"#46544E"},s.fridgeG);
  s.fridgeLed=E("circle",{cx:X(71),cy:354,r:3,fill:"#B9C4BF"},s.fridgeG);
  s.roofSlots=[{x:X(20),y:268,w:98},{x:X(124),y:268,w:98}];
  s.roofG=E("g",{},u);
  s.bat = batteryBox(u, X(90), 346, 66, 42, true);
  s.engine=v.engine;
  s.fg=E("g",{},world);
  chair(s.fg,158,522); table(s.fg,196,522,86);
  s.lantern=E("circle",{cx:272,cy:486,r:5,fill:"#E9E3CF",stroke:"#9BA49F"},s.fg);
  s.bulbs=[];
  s.win=[];
  s.glows.push(G=>{ s.winGlow=[E("rect",{x:438,y:302,width:142,height:84,rx:6,fill:"#FFE3A0",opacity:0},G)];
    s.bulbGlow=[]; s.lanternGlow=E("circle",{cx:272,cy:486,r:28,fill:"url(#gGlow)",opacity:0},G);
    s.fridgeGlow=E("circle",{cx:491,cy:354,r:9,fill:"#7C83E8",opacity:0},G); });
  s.paths={
    solar:"M489 258 C 470 300, 541 314, 543 340",
    load:"M510 372 L502 372",
    dcdc:"M724 390 C 680 404, 620 398, 576 376",
    chg:"M320 430 C 345 404, 470 404, 518 382"
  };
  s.loadAnchor={x:444,y:352}; s.loadSide=true; s.solarAnchor={x:489,y:258}; s.chgAnchor={x:320,y:412};
  s.drivable=true;
}

function buildShed(s){
  const P=s.propsG, M=s.mainG;
  s.shadows=[E("ellipse",{cx:620,cy:482,rx:300,ry:10,fill:"#0E1311",opacity:.12},s.shadowG)];
  s.groundSlots=[{x:24,base:494},{x:112,base:496},{x:200,base:498},{x:-60,base:498}];
  s.groundG=E("g",{},P);
  s.campG=E("g",{},P);
  s.bollard=bollard(P,320,478); s.gen=generator(P,318,484);
  const h=E("g",{},M);
  // wall
  E("rect",{x:380,y:332,width:440,height:146,fill:"#F2F6F4",stroke:"#C2CDC8","stroke-width":1.5},h);
  for(let x=390;x<820;x+=11) E("line",{x1:x,y1:336,x2:x,y2:476,stroke:"#DCE4E0","stroke-width":1.2},h);
  // roof plane (seen from above)
  s.roofQuad=[[364,334],[836,334],[802,214],[398,214]];
  E("polygon",{points:s.roofQuad.map(p=>p.join(",")).join(" "),fill:"#9AA7A2",stroke:"#7D8984","stroke-width":1.5,"stroke-linejoin":"round"},h);
  for(let i=1;i<24;i++){ const t=i/24; const x0=364+(836-364)*t, x1=398+(802-398)*t; E("line",{x1:x0,y1:334,x2:x1,y2:214,stroke:"#8C9994","stroke-width":1},h); }
  E("rect",{x:362,y:332,width:476,height:7,rx:2,fill:"#46544E"},h);
  // roller door + PA door + window
  E("rect",{x:470,y:368,width:180,height:110,fill:"#2B3431"},h);
  E("rect",{x:470,y:368,width:180,height:110,fill:"#3A4441",opacity:.5},h);
  s.shedInside=E("g",{},h);
  // workshop inside: shelf + bench
  E("rect",{x:478,y:416,width:120,height:3,fill:"#7D6F58"},s.shedInside);
  E("rect",{x:478,y:446,width:130,height:6,rx:1,fill:"#A08B66"},s.shedInside);
  E("path",{d:"M484 452 L484 478 M602 452 L602 478",stroke:"#6E5F48","stroke-width":3},s.shedInside);
  const dc=E("clipPath",{id:"doorClip"},world.querySelector("defs")); E("rect",{x:470,y:368,width:180,height:110},dc);
  const dwrap=E("g",{"clip-path":"url(#doorClip)"},h);
  s.rollG=E("g",{class:"rolldoor"},dwrap);
  E("rect",{x:470,y:368,width:180,height:110,fill:"#E3EAE7",stroke:"#B7C3BE","stroke-width":1.4},s.rollG);
  for(let y=378;y<478;y+=9) E("line",{x1:472,y1:y,x2:648,y2:y,stroke:"#C8D3CE","stroke-width":1.2},s.rollG);
  E("rect",{x:470,y:470,width:180,height:8,fill:"#B7C3BE"},s.rollG);
  E("rect",{x:690,y:390,width:48,height:88,rx:2,fill:"#46544E"},h);
  E("circle",{cx:728,cy:436,r:3,fill:"#C9D2CE"},h);
  s.win=[[756,366,44,30]];
  E("rect",{x:756,y:366,width:44,height:30,rx:3,fill:COL.glass,stroke:"#2A3330","stroke-width":2},h);
  // floodlight
  s.floodG=E("g",{},h); E("rect",{x:552,y:346,width:18,height:10,rx:2,fill:"#46544E"},s.floodG); E("rect",{x:558,y:340,width:6,height:6,fill:"#46544E"},s.floodG);
  // battery cabinet
  E("rect",{x:386,y:372,width:84,height:84,rx:5,fill:"#DDE4E1",stroke:"#A9B6B0","stroke-width":1.4},h);
  s.bat = batteryBox(h, 393, 396, 70, 46, true);
  // water tank
  const tk=E("g",{},h);
  E("rect",{x:850,y:356,width:104,height:122,rx:10,fill:"#E6ECE9",stroke:"#B7C3BE","stroke-width":1.4},tk);
  E("ellipse",{cx:902,cy:356,rx:52,ry:9,fill:"#D6DEDA",stroke:"#B7C3BE","stroke-width":1.4},tk);
  for(let y=372;y<474;y+=10) E("line",{x1:852,y1:y,x2:952,y2:y,stroke:"#CDD6D2","stroke-width":1.4},tk);
  s.roofSlots=[]; // computed from quad
  const cols=5, rows=2;
  for(let r=0;r<rows;r++) for(let c=0;c<cols;c++) s.roofSlots.push({quad:[r,c,rows,cols]});
  s.roofG=E("g",{},h);
  s.engine=null;
  s.fg=E("g",{},world);
  s.bulbs=[];
  s.glows.push(G=>{ s.winGlow=[E("rect",{x:758,y:368,width:40,height:26,rx:2,fill:"#FFE3A0",opacity:0},G)];
    s.bulbGlow=[]; s.cone=E("path",{d:"M553 356 L569 356 L640 478 L480 478 Z",fill:"url(#gCone)",opacity:0},G);
    s.lanternGlow=null; });
  s.paths={
    solar:"M600 244 C 520 250, 430 320, 426 394",
    load:"M468 420 C 520 420, 540 420, 560 430",
    dcdc:"M0 0",
    chg:"M320 414 C 330 380, 370 372, 394 400"
  };
  s.loadAnchor={x:560,y:410}; s.solarAnchor={x:600,y:240}; s.chgAnchor={x:318,y:428};
  s.drivable=false;
}

function quadPoint(Q,u,v){ // u along x (0..1), v from front edge(0) to back(1)
  const a=Q[0],b=Q[1],c=Q[2],d=Q[3];
  const fx=a[0]+(b[0]-a[0])*u, fy=a[1]+(b[1]-a[1])*u;
  const bx=d[0]+(c[0]-d[0])*u, by=d[1]+(c[1]-d[1])*u;
  return [fx+(bx-fx)*v, fy+(by-fy)*v];
}
function roofQuadPanel(p, Q, r, c, rows, cols){
  const m=0.04, gu=0.012, gv=0.05;
  const u0=m+(1-2*m)*c/cols+gu, u1=m+(1-2*m)*(c+1)/cols-gu;
  const v0=0.08+0.84*r/rows+gv, v1=0.08+0.84*(r+1)/rows-gv;
  const pts=[quadPoint(Q,u0,v0),quadPoint(Q,u1,v0),quadPoint(Q,u1,v1),quadPoint(Q,u0,v1)];
  const g=E("g",{},p);
  E("polygon",{points:pts.map(q=>q.join(",")).join(" "),fill:COL.panel,stroke:COL.panelFrame,"stroke-width":1.3},g);
  for(let i=1;i<4;i++){ const t=u0+(u1-u0)*i/4; const A=quadPoint(Q,t,v0),B=quadPoint(Q,t,v1); E("line",{x1:A[0],y1:A[1],x2:B[0],y2:B[1],stroke:COL.panelLine,"stroke-width":.8},g); }
  const A=quadPoint(Q,u0,(v0+v1)/2),B=quadPoint(Q,u1,(v0+v1)/2); E("line",{x1:A[0],y1:A[1],x2:B[0],y2:B[1],stroke:COL.panelLine,"stroke-width":.8},g);
  const gl=[quadPoint(Q,u0+(u1-u0)*.2,v0),quadPoint(Q,u0+(u1-u0)*.38,v0),quadPoint(Q,u0+(u1-u0)*.38,v1),quadPoint(Q,u0+(u1-u0)*.2,v1)];
  const glint=E("polygon",{points:gl.map(q=>q.join(",")).join(" "),fill:"#fff",opacity:0},g);
  const cen=quadPoint(Q,(u0+u1)/2,(v0+v1)/2);
  return {g, glint, cx:cen[0], cy:cen[1]};
}

function updatePanels(){
  if(!SC) return;
  const c=cfg(); const n=c.panels;
  SC.roofG.innerHTML=""; SC.groundG.innerHTML="";
  SC.panelEls=[];
  let placed=0;
  const roofN=Math.min(n, SC.roofSlots.length);
  for(let i=0;i<roofN;i++){
    const sl=SC.roofSlots[i];
    let pe;
    if(sl.quad) pe=roofQuadPanel(SC.roofG, SC.roofQuad, ...sl.quad);
    else { pe=panel(SC.roofG, sl.x, sl.y, sl.w); pe.cx=sl.x+sl.w/2; pe.cy=sl.y-8; }
    SC.panelEls.push(pe); placed++;
  }
  // fixed panels beyond the roof space aren't drawn (the roof shows the look; the numbers carry the rest).
  // A small tag on the roof says how many more there are.
  SC.extraPanels = n-placed;
  if(SC.extraPanels>0 && SC.panelEls.length){
    const last=SC.panelEls[SC.panelEls.length-1], g=E("g",{},SC.roofG), x=(last.cx||0)+30, y=(last.cy||0)-14;
    E("rect",{x:x-17,y:y-10,width:34,height:19,rx:9.5,fill:"#0E1311",opacity:.88},g);
    E("text",{x,y:y+4,"text-anchor":"middle","font-size":11,"font-weight":700,fill:"#fff","font-family":"Noto Sans, sans-serif"},g).textContent=`+${SC.extraPanels}`;
  }
  // portable panels / blankets sit on the ground behind the van: one stand per ~200W, up to the space available
  if(c.portW>0){
    const gs=SC.groundSlots.filter(g=>g.x>=0), k=Math.min(gs.length, Math.max(1, Math.round(c.portW/200)));
    for(let i=0;i<k;i++){ const pe=groundPanel(SC.groundG, gs[i].x, gs[i].base); SC.panelEls.push(pe); }
  }
  // solar anchor = first panel
  if(SC.panelEls[0]){ SC.solarAnchor={x:SC.panelEls[0].cx||SC.solarAnchor.x, y:(SC.panelEls[0].cy||SC.solarAnchor.y)-6}; }
}
function updateProps(){
  if(!SC) return;
  const c=cfg();
  const site = c.charger>0 && c.src==="site", gen = c.charger>0 && c.src==="gen";
  SC.bollard.g.style.display = site ? "" : "none";
  SC.gen.g.style.display = gen ? "" : "none";
}

/* ---------- fit the scene into the space left between the overlay panels ---------- */
const FOCUS = { caravan:{x:-10,y:225,w:1195,h:315}, "4wd":{x:-10,y:236,w:810,h:304}, shed:{x:-10,y:200,w:990,h:340} };
const FOCUS_PHONE = { caravan:{x:170,y:240,w:1015,h:300}, "4wd":{x:190,y:246,w:610,h:294}, shed:{x:250,y:200,w:740,h:320} };
const VB={x:0,y:0,w:1200,h:600, tx:0,ty:0,tw:1200,th:600, s:1};
function fitView(snap){
  const r=sceneEl.getBoundingClientRect(); if(!r.width) return;
  const ins=safeInsets(r);
  const F=isPhone()? FOCUS_PHONE[S.scen] : FOCUS[S.scen];
  const fw=Math.max(120,r.width-ins.l-ins.r), fh=Math.max(120,r.height-ins.t-ins.b);
  const s=Math.min(fw/F.w, fh/F.h);
  const w=r.width/s, h=r.height/s;
  // centre horizontally in the free area; sit the ground near the bottom of the free area
  const x = F.x - ins.l/s - (fw/s - F.w)/2;
  const y = F.y - ins.t/s - (fh/s - F.h)*0.82;
  Object.assign(VB,{tx:x,ty:y,tw:w,th:h,s,insT:ins.t});
  if(snap){ VB.x=x; VB.y=y; VB.w=w; VB.h=h; world.setAttribute("viewBox",`${x} ${y} ${w} ${h}`); }
}
function stepView(){
  const k=0.14; let moved=false;
  for(const [a,b] of [["x","tx"],["y","ty"],["w","tw"],["h","th"]]){ const d=VB[b]-VB[a]; if(Math.abs(d)>0.05){ VB[a]+=d*k; moved=true; } else VB[a]=VB[b]; }
  if(moved) world.setAttribute("viewBox",`${VB.x.toFixed(2)} ${VB.y.toFixed(2)} ${VB.w.toFixed(2)} ${VB.h.toFixed(2)}`);
}
/** svg y -> screen y within the scene */
function svgToScreenY(y){ const r=sceneEl.clientHeight; return (y-VB.y)/VB.h*r; }

/** keep the scene labels from covering each other: slide apart sideways, then lift one with a longer pointer */
function resolveChips(list, fixed){
  const vis=list.filter(c=>c.vis && c.w>0), PAD=6;
  for(let pass=0; pass<4; pass++){
    let moved=false;
    for(let i=0;i<vis.length;i++) for(let j=i+1;j<vis.length;j++){
      const a=vis[i], b=vis[j], A=a.rect(), B=b.rect();
      const ox=Math.min(A.r,B.r)-Math.max(A.l,B.l)+PAD, oy=Math.min(A.b,B.b)-Math.max(A.t,B.t)+4;
      if(ox<=0 || oy<=0) continue;
      const left = a.ax<=b.ax ? a : b, right = left===a ? b : a;
      const room = c => Math.max(0, c.w/2-18-Math.abs(c.dx));
      const lShift=Math.min(room(left), left===fixed?0:ox/2), rShift=Math.min(room(right), right===fixed?0:ox-lShift);
      left.dx-=lShift; right.dx+=rShift;
      const rem=ox-lShift-rShift;
      if(rem>0.5){ const lift = (b===fixed ? a : (a===fixed ? b : (a.ay<b.ay ? a : b))); lift.dy += oy+2; }
      moved=true;
    }
    if(!moved) break;
  }
  list.forEach(c=>{ if(c.vis) c.place(); });
}

/* ================= SKY + WEATHER FX (canvas) ================= */
const skyC=document.getElementById("sky"), fxC=document.getElementById("fx"), sceneEl=document.getElementById("scene");
const sctx=skyC.getContext("2d"), fctx=fxC.getContext("2d");
let W=0,H=0,DPR=1;
function resize(){
  const r=sceneEl.getBoundingClientRect(); DPR=Math.min(2,window.devicePixelRatio||1);
  W=r.width; H=r.height;
  for(const c of [skyC,fxC]){ c.width=Math.round(W*DPR); c.height=Math.round(H*DPR); }
  sctx.setTransform(DPR,0,0,DPR,0,0); fctx.setTransform(DPR,0,0,DPR,0,0);
}
const hex=(h)=>[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];
const mix=(a,b,t)=>a.map((v,i)=>v+(b[i]-v)*t);
const rgb=(c,a=1)=>`rgba(${c[0]|0},${c[1]|0},${c[2]|0},${a})`;
const GREY={sunny:0, partly:.12, overcast:.62, lightrain:.72, heavyrain:.85, storm:1};
const CLOUDS_N={sunny:2, partly:8, overcast:15, lightrain:16, heavyrain:18, storm:19};
const RAIN_N={sunny:0, partly:0, overcast:0, lightrain:140, heavyrain:380, storm:480};
const PAL={
  dayT:hex("#8DCBEA"), dayH:hex("#EAF6F2"), nightT:hex("#0F1B2D"), nightH:hex("#2B3D56"),
  warmT:hex("#7F8FC0"), warmH:hex("#F7C59A"), greyT:hex("#A5B1B8"), greyH:hex("#D7DDDE"), stormT:hex("#56626B"), stormH:hex("#8D989C")
};
function light(hod){
  const si=sunInfo();
  let el;
  if(hod>si.sr && hod<si.ss) el=Math.sin(Math.PI*(hod-si.sr)/(si.ss-si.sr));
  else { const d=Math.min(Math.abs(hod-si.sr), Math.abs(hod-si.ss), Math.abs(hod+24-si.sr), Math.abs(hod-24-si.ss)); el=-Math.min(1,d/1.5); }
  return {el, day:clamp((el+0.18)/0.42,0,1), warm:Math.exp(-Math.pow((el-0.04)/0.13,2))};
}
const stars=[...Array(90)].map((_,i)=>({x:((i*97)%1000)/1000, y:((i*61)%520)/1000, r:((i*13)%10)/10*1.1+.4, tw:i}));
const clouds=[];
function seedCloud(x){
  const puffs=[...Array(5+Math.floor(Math.random()*3))].map((_,i,a)=>({dx:(i-(a.length-1)/2)*0.55+(Math.random()-.5)*.2, dy:(Math.random()-.3)*.35, r:.45+Math.random()*.4}));
  return {x: x!==undefined?x:Math.random(), y:.05+Math.random()*.33, s:.04+Math.random()*.05, v:.006+Math.random()*.01, a:0, alive:true, puffs};
}
for(let i=0;i<4;i++){ const c=seedCloud(); c.a=1; clouds.push(c); }
let sunCovered=false, sunPos={x:0,y:0};
function drawSky(hod, dt){
  const w=S.weather, g=GREY[w], L=light(hod);
  // sky gradient
  let top=mix(PAL.nightT,PAL.dayT,L.day), hor=mix(PAL.nightH,PAL.dayH,L.day);
  top=mix(top,PAL.warmT,L.warm*0.55*(1-g)); hor=mix(hor,PAL.warmH,L.warm*0.75*(1-g*0.8));
  const gT=mix(PAL.greyT,PAL.stormT,clamp((g-.6)/.4,0,1)), gH=mix(PAL.greyH,PAL.stormH,clamp((g-.6)/.4,0,1));
  const dim = 0.25+0.75*L.day;
  top=mix(top,gT.map(v=>v*dim),g*0.9); hor=mix(hor,gH.map(v=>v*dim),g*0.85);
  const horizon=svgToScreenY(404), topY=(VB.insT||80)+H*0.05;
  const grd=sctx.createLinearGradient(0,0,0,Math.max(40,horizon)); grd.addColorStop(0,rgb(top)); grd.addColorStop(1,rgb(hor));
  sctx.fillStyle=grd; sctx.fillRect(0,0,W,H);
  // stars
  const sa=(1-L.day)*(1-g);
  if(sa>0.02){ for(const s of stars){ sctx.fillStyle=`rgba(255,255,255,${sa*(0.5+0.5*Math.sin(perfNow/600+s.tw))})`; sctx.beginPath(); sctx.arc(s.x*W, s.y*H, s.r, 0, 7); sctx.fill(); } }
  // sun / moon
  const si=sunInfo(), R=clamp(H*0.04,12,34), arcH=Math.max(60,horizon-topY-R);
  if(hod>si.sr-0.4 && hod<si.ss+0.4){
    const p=(hod-si.sr)/(si.ss-si.sr), x=W*(0.08+0.84*p), y=horizon - Math.sin(Math.PI*clamp(p,0,1))*arcH + (p<0||p>1?R*2:0);
    sunPos={x,y,R};
    const a=(1-g*0.85);
    const gl=sctx.createRadialGradient(x,y,R*0.6,x,y,R*4.2); gl.addColorStop(0,`rgba(255,226,140,${0.55*a})`); gl.addColorStop(1,"rgba(255,226,140,0)");
    sctx.fillStyle=gl; sctx.beginPath(); sctx.arc(x,y,R*4.2,0,7); sctx.fill();
    sctx.fillStyle=`rgba(255,${L.warm>.5?196:214},${L.warm>.5?96:110},${a})`; sctx.beginPath(); sctx.arc(x,y,R,0,7); sctx.fill();
  } else sunPos={x:-999,y:-999,R:0};
  {
    let np = hod>=si.ss ? (hod-si.ss)/(24-si.ss+si.sr) : (hod+24-si.ss)/(24-si.ss+si.sr);
    if(hod>si.ss+0.3 || hod<si.sr-0.3){ const x=W*(0.1+0.8*np), y=horizon-Math.sin(Math.PI*np)*arcH*0.85; const a=(1-g*0.9)*(1-L.day);
      sctx.fillStyle=`rgba(242,249,246,${a})`; sctx.beginPath(); sctx.arc(x,y,R*0.75,0,7); sctx.fill();
      sctx.fillStyle=rgb(top,a); sctx.beginPath(); sctx.arc(x+R*0.32,y-R*0.18,R*0.62,0,7); sctx.fill(); }
  }
  // overcast veil
  if(g>0.5){ const v=sctx.createLinearGradient(0,0,0,horizon*0.8); const vc=gT.map(c=>c*dim*0.95); v.addColorStop(0,rgb(vc,(g-.5)*1.4)); v.addColorStop(1,rgb(vc,0)); sctx.fillStyle=v; sctx.fillRect(0,0,W,horizon); }
  // clouds
  const want=CLOUDS_N[w]; let alive=clouds.filter(c=>c.alive).length;
  if(alive<want && Math.random()<0.08){ clouds.push(seedCloud(Math.random()<.5? -0.15 : Math.random())); }
  if(alive>want){ const c=clouds.find(c=>c.alive); if(c) c.alive=false; }
  const cBase = mix([255,255,255], mix([200,208,212],[110,120,128],clamp((g-.5)/.5,0,1)), clamp(g*1.2,0,1)).map(v=>v*(0.35+0.65*L.day));
  const warmTint = mix(cBase,[250,210,180],L.warm*0.35*(1-g));
  sunCovered=false;
  const wind = w==="storm"?2.6 : w==="heavyrain"?1.6 : 1;
  for(let i=clouds.length-1;i>=0;i--){
    const c=clouds[i];
    c.a += ((c.alive?1:0)-c.a)*Math.min(1,dt*0.8);
    c.x += c.v*wind*dt*0.9;
    if(c.x>1.25){ c.x=-0.25; c.y=.05+Math.random()*.33; }
    if(!c.alive && c.a<0.02){ clouds.splice(i,1); continue; }
    const size=Math.min(c.s*(0.55+g*1.15)*W, H*0.16), cx=c.x*W, cy=(VB.insT||60)*0.6 + c.y*Math.max(80,horizon-(VB.insT||60)*0.6)*1.3;
    sctx.fillStyle=rgb(warmTint, c.a*(0.82+g*0.18));
    for(const p of c.puffs){ sctx.beginPath(); sctx.arc(cx+p.dx*size, cy+p.dy*size, p.r*size, 0, 7); sctx.fill(); }
    if(c.a>0.5 && Math.hypot(cx-sunPos.x, cy-sunPos.y) < size*1.2) sunCovered=true;
  }
}
const drops=[];
let flash=0, boltT=3, bolt=null;
function drawFx(dt){
  fctx.clearRect(0,0,W,H);
  const w=S.weather, want=RAIN_N[w];
  while(drops.length<want) drops.push({x:Math.random()*W*1.2, y:Math.random()*H, l:8+Math.random()*12, v:500+Math.random()*350});
  if(drops.length>want) drops.length=want;
  const slant = w==="storm"?0.32 : w==="heavyrain"?0.2 : 0.1;
  fctx.strokeStyle= w==="lightrain" ? "rgba(225,235,240,.55)" : "rgba(220,230,236,.6)"; fctx.lineWidth=1.1; fctx.lineCap="round";
  fctx.beginPath();
  for(const d of drops){ d.y+=d.v*dt*(H/400); d.x-=d.v*slant*dt*(H/400); if(d.y>H){ d.y=-20; d.x=Math.random()*W*1.25; }
    fctx.moveTo(d.x,d.y); fctx.lineTo(d.x+d.l*slant, d.y-d.l); }
  fctx.stroke();
  if(w==="storm"){
    boltT-=dt; if(boltT<=0){ boltT=3+Math.random()*6; flash=1; let x=W*(0.2+Math.random()*0.6), y=0; bolt=[[x,y]]; while(y<H*0.55){ y+=H*0.05+Math.random()*H*0.05; x+=(Math.random()-.5)*W*0.06; bolt.push([x,y]); } }
  }
  if(flash>0){
    fctx.fillStyle=`rgba(255,255,255,${flash*0.45})`; fctx.fillRect(0,0,W,H);
    if(bolt && flash>0.5){ fctx.strokeStyle=`rgba(255,250,220,${flash})`; fctx.lineWidth=2.4; fctx.beginPath(); bolt.forEach((p,i)=>i?fctx.lineTo(p[0],p[1]):fctx.moveTo(p[0],p[1])); fctx.stroke(); }
    flash=Math.max(0,flash-dt*2.6);
  }
}

/* ================= LIVE SIMULATION ================= */
const Lv={t:6.5, soc:0, runNow:{}, playing:true, speed:20, f:null, driveOff:0, hist:[], lastToast:{}, prevState:"normal"};
let perfNow=0;
function capWh(){ return cfg().bat*VNOM; }
function resetLive(){ const c=cfg(); Lv.t=6.5; Lv.soc=capWh()*c.soc/100; Lv.runNow={}; Lv.hist=[]; Lv.prevState="normal"; Lv.lastToast={}; }
function weekWx(t){ const d=Math.floor(t/24), hod=t-d*24; return S.week.days[Math.min(6,d)].w[Math.min(7,Math.floor(hod/3))]; }
function setLiveEnv(){ ENV.wx = Lv.weekRun ? ((d,t)=>weekWx(t)) : ((d,t)=>S.weather); ENV.week = Lv.weekRun ? S.week : null; }
function liveWF(){
  const base=WEATHER[S.weather].f;
  if(Lv.weekRun) return base*(1+0.06*Math.sin(Lv.t*9));
  if(S.weather==="partly") return sunCovered ? 0.32 : 1.0;
  if(S.weather==="sunny") return sunCovered ? 0.6 : 1.0;
  return base*(1+0.1*Math.sin(Lv.t*9));
}
function advance(hours){
  const c=cfg(), list=apps(), cap=capWh();
  let rem=hours, f=null;
  setLiveEnv();
  while(rem>1e-9){
    if(Lv.weekRun){ if(Lv.t>=168-1e-6){ finishWeek(); break; } const w=weekWx(Lv.t); if(w!==S.weather) setWeatherUI(w); }
    // step on the same 5-minute grid the report uses, so the live view and the report agree
    const k=Math.floor(Lv.t/STEP+1e-7), tq=k*STEP, next=(k+1)*STEP;
    const dt=Math.max(1e-6, Math.min(next-Lv.t, rem, Lv.weekRun? 168-Lv.t : rem));
    f=flowsAt(c,list,tq,liveWF(),Lv.soc,cap,Lv.runNow);
    Lv.soc=clamp(Lv.soc+f.net*dt,0,cap);
    if(Lv.weekRun){ const p=Lv.soc/cap*100; if(p<Lv.weekMin) Lv.weekMin=p; if(f.state==="flat" && Lv.weekFlat===null) Lv.weekFlat=Lv.t; }
    Lv.t+=dt; rem-=dt;
  }
  return f || flowsAt(c,list,Lv.t,liveWF(),Lv.soc,cap,Lv.runNow);
}
let toastTimer=null;
function toast(key,msg){
  const now=perfNow; if(Lv.lastToast[key] && now-Lv.lastToast[key]<9000) return; Lv.lastToast[key]=now;
  const el=document.getElementById("toast"); el.textContent=msg; el.classList.add("show");
  clearTimeout(toastTimer); toastTimer=setTimeout(()=>el.classList.remove("show"),3200);
}
const fmtW=(w)=>Math.round(w).toLocaleString("en-AU");
function fmtClock(t){ const hod=((t%24)+24)%24; let h=Math.floor(hod), m=Math.floor((hod-h)*60); const ap=h<12?"am":"pm"; let hh=h%12; if(hh===0) hh=12; return `${hh}:${String(m).padStart(2,"0")} ${ap}`; }
function fmtDur(h){ if(!isFinite(h)) return "—"; if(h<1) return `${Math.max(1,Math.round(h*60))} min`; if(h<48){ const hh=Math.floor(h), mm=Math.round((h-hh)*60); return mm? `${hh}h ${mm}m` : `${hh}h`; } return `${(h/24).toFixed(1)} days`; }
function batVolts(pct, charging){ const pts=[[0,11.2],[5,12.4],[10,12.8],[20,13.0],[50,13.15],[90,13.3],[100,13.45]]; let v=13.45; for(let i=1;i<pts.length;i++){ if(pct<=pts[i][0]){ const a=pts[i-1],b=pts[i]; v=a[1]+(b[1]-a[1])*(pct-a[0])/(b[0]-a[0]); break; } } return v+(charging?0.35:0); }

let hudT=0;
function frame(ts){
  const dt=Math.min(0.1, (ts-(frame.last||ts))/1000); frame.last=ts; perfNow=ts;
  const c=cfg();
  let f;
  if(Lv.playing) f=advance(dt*Lv.speed/60);
  else { setLiveEnv(); f=flowsAt(c,apps(),Lv.t,liveWF(),Lv.soc,capWh(),Lv.runNow); }
  Lv.f=f;
  const hod=((Lv.t%24)+24)%24;
  stepView(); drawSky(hod, dt); drawFx(dt);
  animateScene(f, hod, dt);
  animateFlow(f, dt);
  hudT+=dt; if(hudT>0.12){ hudT=0; updateHud(f, hod); }
  requestAnimationFrame(frame);
}

function animateScene(f, hod, dt){
  if(!SC) return;
  const c=cfg(), L=light(hod), g=GREY[S.weather];
  const dark=1-L.day;
  SC.night.setAttribute("opacity", (dark*0.52 + g*0.14).toFixed(3));
  SC.night.setAttribute("fill", dark>0.3 ? "#0B1A2E" : "#4E5C66");
  SC.shadows.forEach(s=>s.setAttribute("opacity",(0.04+0.12*L.day*(1-g)).toFixed(3)));
  const sf = f.clearW>0 ? clamp(f.solarW/Math.max(1,c.panels*c.panelW*0.7),0,1) : 0;
  (SC.panelEls||[]).forEach((p,i)=>p.glint.setAttribute("opacity",(sf*0.28*(0.6+0.4*Math.sin(perfNow/700+i))).toFixed(3)));
  const runningIds=new Set(f.running.map(a=>a.id));
  const lightsOn = runningIds.has("lights")||runningIds.has("flood");
  const glowA = lightsOn ? clamp(0.25+dark*0.75,0,1) : (runningIds.has("tv")&&dark>0.3 ? 0.35+0.1*Math.sin(perfNow/120) : 0);
  (SC.winGlow||[]).forEach(r=>r.setAttribute("opacity",(glowA*(S.scen==="4wd"?0.38:0.9)).toFixed(3)));
  (SC.bulbGlow||[]).forEach((b,i)=>b.setAttribute("opacity", runningIds.has("lights")? (0.35+dark*0.65).toFixed(3) : 0));
  (SC.bulbs||[]).forEach(b=>b.setAttribute("fill", runningIds.has("lights")? "#FFE6A3" : "#E9E3CF"));
  if(SC.lanternGlow) SC.lanternGlow.setAttribute("opacity", runningIds.has("lights")? (0.3+dark*0.7).toFixed(3) : 0);
  if(SC.lantern) SC.lantern.setAttribute("fill", runningIds.has("lights")? "#FFE6A3" : "#E9E3CF");
  if(SC.cone) SC.cone.setAttribute("opacity", runningIds.has("flood")? (0.25+dark*0.75).toFixed(3):0);
  if(SC.fridgeGlow) SC.fridgeGlow.setAttribute("opacity", runningIds.has("fridge")?0.9:0);
  for(const fan of SC.fans){ if(runningIds.has(fan.id)){ fan.a=(fan.a+dt*900)%360; fan.g.setAttribute("transform",`rotate(${fan.a})`);} }
  // generator
  const genOn = c.charger>0 && c.src==="gen" && f.chgW>0;
  if(SC.gen && SC.gen.g.style.display!=="none"){
    SC.gen.body.setAttribute("transform", genOn? `translate(${(Math.sin(perfNow/30)*0.7).toFixed(2)} 0)` : "");
    SC.gen.pf.forEach((p,i)=>{ if(!genOn){p.setAttribute("opacity",0);return;} const k=((perfNow/1400)+i/3)%1; p.setAttribute("cy",SC.gen.ay-6-k*40); p.setAttribute("cx",SC.gen.ax+30+k*14); p.setAttribute("r",4+k*9); p.setAttribute("opacity",(0.55*(1-k)).toFixed(2)); });
  }
  // driving
  const driving = SC.drivable && drivingAt(c, hod);
  if(driving){ Lv.driveOff=(Lv.driveOff+dt*260)%1200; SC.wheels.forEach(w=>{ w.a=((w.a||0)+dt*520)%360; w.spin.setAttribute("transform",`rotate(${w.a})`); }); }
  const off=Lv.driveOff;
  SC.trees.setAttribute("transform",`translate(${-off} 0)`);
  SC.nearHills.setAttribute("transform",`translate(${-(off*0.35)%1200} 0)`);
  SC.farHills.setAttribute("transform",`translate(${-(off*0.12)%1200} 0)`);
  if(SC.dashes) SC.dashes.setAttribute("transform",`translate(${-((off*1.6)%1200)} 0)`);
  const camp = !driving;
  if(SC._camp!==camp){ SC._camp=camp; [SC.campG,SC.groundG,SC.fg,SC.propsG].forEach(e=>{ if(e) e.style.opacity=camp?1:0; e && (e.style.transition="opacity .6s"); }); }
  // battery
  const cap=capWh(), pct=Lv.soc/cap;
  SC.bat.fill.setAttribute("width",(SC.bat.fw*clamp(pct,0.02,1)).toFixed(1));
  // flows
  const lines=[["solar",f.solarW],["dcdc",f.dcdcW],["chg",f.chgW],["load",f.loadW]];
  for(const [k,wv] of lines){ const fl=SC.fl[k]; const on=wv>1; fl.g.style.display=on?"":"none"; if(on){ fl.off=(fl.off - dt*(24+Math.sqrt(wv)*5))%1400; fl.dash.setAttribute("stroke-dashoffset",fl.off.toFixed(1)); } }
  // chips
  const ch=SC.chips;
  ch.solar.show(c.panels>0 && (f.solarW>1 || L.day>0.2)); const solTxt = f.state==="full" && f.solarAvail>1 ? `Solar ${fmtW(f.solarAvail)}W · battery full` : f.solarW>1 ? `Solar ${fmtW(f.solarW)}W` : "Solar idle";
  ch.solar.set(SC.solarAnchor.x, SC.solarAnchor.y, solTxt, "#E0A100");
  ch.bat.show(true); ch.bat.set(SC.bat.cx, SC.bat.top-2, `${Math.round(pct*100)}% · ${Math.round(Lv.soc/VNOM)}Ah`, pct<0.2?"#C93636":"#06A74F");
  const la = SC.loadAnchor;
  ch.load.show(f.loadW>1); ch.load.set(la.x, la.y, `Using ${fmtW(f.loadW)}W`, "#5B63D6");
  const drv = SC.drivable && drivingAt(c, hod);
  ch.dcdc.show(SC.engine && drv); if(SC.engine) ch.dcdc.set(SC.engine.x-20, SC.engine.y-26, f.dcdcW>1?`DC-DC ${fmtW(f.dcdcW)}W`:"DC-DC standby · full");
  ch.chg.show(chargerAt(c,hod)); ch.chg.set(SC.chgAnchor.x, SC.chgAnchor.y, `${c.src==="gen"?"Generator":"Mains"} ${fmtW(f.chgW)}W`);
  resolveChips([ch.bat, ch.load, ch.solar, ch.dcdc, ch.chg], ch.bat);
}

function updateHud(f, hod){
  const c=cfg(), cap=capWh(), pct=Lv.soc/cap*100;
  document.getElementById("kSoc").textContent=`${Math.round(pct)}%`;
  const bm=batById(c.batId); document.getElementById("kBatName").textContent=`${c.qty>1?c.qty+" × ":""}${bm.name}`;
  document.getElementById("kVolt").textContent=`${batVolts(pct, f.net>5).toFixed(1)}V`;
  const gg=document.getElementById("kGauge"); gg.firstElementChild.style.width=`${clamp(pct,1,100)}%`; gg.classList.toggle("low",pct<20);
  let sub;
  if(f.state==="full") sub=`Full · chargers throttled`;
  else if(f.state==="flat") sub=`Flat · gear has shut off`;
  else if(f.net>5) sub=`Charging · full in ${fmtDur((cap-Lv.soc)/f.net)}`;
  else if(f.net<-5) sub=`Draining · lasts ${fmtDur(Lv.soc/(-f.net))} at this rate`;
  else sub=`${Math.round(Lv.soc/VNOM)} of ${c.bat}Ah left`;
  document.getElementById("kSocSub").textContent=sub;
  const inW=f.solarW+f.dcdcW+f.chgW;
  // ease the readouts so they don't flicker
  Lv.dIn = Lv.dIn===undefined ? inW : Lv.dIn + (inW-Lv.dIn)*0.35; Lv.dOut = Lv.dOut===undefined ? f.loadW : Lv.dOut + (f.loadW-Lv.dOut)*0.35;
  if(Math.abs(Lv.dIn-inW)<1) Lv.dIn=inW; if(Math.abs(Lv.dOut-f.loadW)<1) Lv.dOut=f.loadW;
  document.getElementById("kIn").textContent=fmtW(Lv.dIn);
  const srcs=[]; if(f.solarW>1) srcs.push("solar"); if(f.dcdcW>1) srcs.push("DC-DC"); if(f.chgW>1) srcs.push(c.src==="gen"?"generator":"mains");
  document.getElementById("kInSub").textContent= srcs.length? `From ${srcs.join(" + ")}` : (light(hod).day<0.05 ? "No sun right now" : "Nothing charging");
  document.getElementById("kOut").textContent=fmtW(Lv.dOut);
  setLiveEnv(); const tnow=tempAt(Lv.t);
  document.getElementById("kTemp").textContent=`${Math.round(tnow)}°`;
  const cl=S.climate, run=new Set(f.running.map(a=>a.id));
  document.getElementById("kTempSub").textContent = run.has("aircon")&&isAuto(apps().find(a=>a.id==="aircon")||{}) ? "Air con on (auto)" : run.has("heater")&&isAuto(apps().find(a=>a.id==="heater")||{}) ? "Heater on (auto)" : (cl.ac||cl.heat) ? `Auto: ${[cl.heat?`heat <${cl.heatAt}°`:"", cl.ac?`AC >${cl.acAt}°`:""].filter(Boolean).join(" · ")}` : "Climate auto off";
  updateWeekBar(f);
  document.getElementById("kOutSub").textContent=`${f.running.length} running${f.unpowered.length?` · ${f.unpowered.length} blocked`:""}`;
  document.getElementById("clockDay").textContent=`DAY ${Math.floor(Lv.t/24)+1}`;
  document.getElementById("clockTime").textContent=fmtClock(Lv.t);
  const ts=document.getElementById("timeSlider"); if(document.activeElement!==ts){ ts.value=hod.toFixed(2); }
  const wf=liveWF();
  document.getElementById("weatherCap").textContent = `${WEATHER[S.weather].name} · ${light(hod).day<0.05?"night":Math.round(wf*100)+"% sun"}`;
  // running list
  const ul=document.getElementById("runList");
  const MAXR = isPhone()? 7 : 6;   // one scrollable row, so a few more fit without changing the layout
  let rows=f.unpowered.map(u=>`<li class="bad"><span class="dot"></span><span class="nm">${u.a.name}</span><span class="w">${u.why}</span></li>`)
    .concat(f.running.slice().sort((a,b)=>f.runW[b.id]-f.runW[a.id]).map(a=>`<li><span class="dot"></span><span class="nm">${a.id==="heater"&&f.runW[a.id]===110?"Diesel heater (starting)":a.id==="heater"&&f.runW[a.id]===45?"Diesel heater (cooling down)":a.name}</span><span class="w">${fmtW(f.runW[a.id])}W</span></li>`));
  if(rows.length>MAXR){ const more=rows.length-(MAXR-1); rows=rows.slice(0,MAXR-1).concat(`<li class="more">+${more} more</li>`); }
  const html = rows.length? rows.join("") : `<li class="empty">Nothing at ${fmtClock(Lv.t)}</li>`;
  if(ul._h!==html){ ul.innerHTML=html; ul._h=html; }
  // live markers in appliance list
  const live=new Set(f.running.map(a=>a.id));
  document.querySelectorAll(".app-row").forEach(r=>r.classList.toggle("live", live.has(r.dataset.id)));
  updatePropRun(live);
  // events
  if(f.state==="full" && Lv.prevState!=="full") toast("full","Battery full. Solar is throttling back.");
  if(f.state==="flat" && Lv.prevState!=="flat") toast("flat","Battery flat. Your gear has shut off until it recharges.");
  Lv.prevState=f.state;
  for(const u of f.unpowered) toast("u"+u.a.id, u.why==="Needs inverter" ? `${u.a.name} needs a 240V inverter` : `${u.a.name} (${fmtW(u.a.w)}W) needs a bigger inverter`);
  if(f.clipped) toast("clip",`Solar controller is maxed out at ${fmtW(f.mpptMax)}W`);
}

/* ================= POWER FLOW DIAGRAM (compact) ================= */
const flowSvg=document.getElementById("flow");
const FN={};
function buildFlow(){
  flowSvg.innerHTML="";
  const d=E("defs",{},flowSvg); const gr=E("linearGradient",{id:"fgBrand",x1:0,x2:1,y1:0,y2:0},d); E("stop",{offset:0,"stop-color":"#A1CD3A"},gr); E("stop",{offset:1,"stop-color":"#06A74F"},gr);
  const edge=(id,dd,cls)=>{ E("path",{d:dd,class:"fe-base"},flowSvg); const dash=E("path",{d:dd,class:"fe "+cls},flowSvg); FN["e_"+id]={dash,off:0}; };
  edge("solar","M56 56 C 56 80, 128 70, 132 92","in"); edge("dcdc","M165 56 L165 92","in"); edge("chg","M274 56 C 274 80, 202 70, 198 92","in");
  edge("dc","M140 158 C 140 180, 85 174, 85 196","out"); edge("ac","M190 158 C 190 180, 245 174, 245 196","out");
  const node=(id,x,y,w,h,icon,title)=>{
    const g=E("g",{},flowSvg);
    const r=E("rect",{x,y,width:w,height:h,rx:11,class:"fn-box"},g);
    E("use",{href:"#"+icon,x:x+8,y:y+7,width:15,height:15,class:"fn-ico"},g);
    const t=E("text",{x:x+27,y:y+18.5,class:"fn-t"},g); t.textContent=title;
    const v=E("text",{x:x+9,y:y+38,class:"fn-v"},g);
    FN[id]={g,r,v};
  };
  node("solar",6,8,100,48,"i-solar","Solar"); node("dcdc",115,8,100,48,"i-engine","DC-DC"); node("chg",224,8,100,48,"i-plug","240V charger");
  node("dc",20,196,130,48,"a-fridge","12V gear"); node("ac",180,196,130,48,"i-inverter","240V via inverter");
  const b=E("g",{},flowSvg);
  E("rect",{x:95,y:92,width:140,height:66,rx:14,class:"fn-box bat"},b);
  const lg=E("g",{transform:`translate(106 102) scale(${15/326})`},b); E("path",{d:LOGO_D,fill:"url(#fgBrand)"},lg);
  const bt=E("text",{x:126,y:114,class:"fn-t"},b); bt.textContent="Battery";
  FN.batV=E("text",{x:106,y:140,class:"fn-big"},b);
  FN.batS=E("text",{x:224,y:140,class:"fn-t","text-anchor":"end"},b);
  E("rect",{x:106,y:146,width:118,height:5,rx:2.5,class:"fn-track"},b);
  FN.batF=E("rect",{x:106,y:146,width:100,height:5,rx:2.5,fill:"url(#fgBrand)"},b);
}
function setNode(id, val, active, fitted=true){ const n=FN[id]; if(n.v.textContent!==val) n.v.textContent=val; n.g.style.opacity = fitted ? 1 : .45; n.r.classList.toggle("active", !!active); }
function animateFlow(f, dt){
  if(!FN.solar || $("flowBody").hidden) return;
  const c=cfg(), hod=((Lv.t%24)+24)%24;
  setNode("solar", c.panels? `${fmtW(f.solarW)}W`:"None", f.solarW>1, c.panels>0);
  const dcFitted = S.scen!=="shed" && c.dcdc>0;
  setNode("dcdc", dcFitted ? (f.dcdcW>1?`${fmtW(f.dcdcW)}W`:(drivingAt(c,hod)?"Standby":"Parked")) : (S.scen==="shed"?"N/A":"None"), f.dcdcW>1, dcFitted);
  setNode("chg", c.charger ? (f.chgW>1?`${fmtW(f.chgW)}W`:"Off") : "None", f.chgW>1, c.charger>0);
  setNode("dc", `${fmtW(f.dcW)}W`, f.dcW>1, true);
  setNode("ac", c.inverter? `${fmtW(f.acServed)}W${f.invW>1?` · ${fmtW(f.invW)}W in`:""}`:"No inverter", f.acServed>1, c.inverter>0);
  const pct=Lv.soc/capWh()*100;
  FN.batV.textContent=`${Math.round(pct)}%`;
  FN.batS.textContent = f.net>5?`+${fmtW(f.net)}W` : f.net<-5?`−${fmtW(-f.net)}W` : (f.state==="full"?"Full":"Steady");
  FN.batF.setAttribute("width",(118*clamp(pct/100,0.02,1)).toFixed(1));
  for(const [k,w] of [["solar",f.solarW],["dcdc",f.dcdcW],["chg",f.chgW],["dc",f.dcW],["ac",f.invW]]){ const e=FN["e_"+k]; const on=w>1; e.dash.style.opacity=on?1:0; if(on){ e.off=(e.off-dt*(14+Math.sqrt(w)*3.5))%1000; e.dash.setAttribute("stroke-dashoffset",e.off.toFixed(1)); } }
}

/* ================= CONFIG UI ================= */
const $=(id)=>document.getElementById(id);
const appEl=$("app");
function setRangeFill(el){ const p=(el.value-el.min)/(el.max-el.min)*100; el.style.setProperty("--p",p+"%"); }
function fmtHours(h){ if(h>=24) return "24h"; if(h<1){ const m=Math.round(h*60); return `${m} min`; } return (Math.round(h*100)/100)+"h"; }
function stepperFmt(key,v){ if(key==="portW") return v>0?`${v}W`:"None"; if(key==="portH") return fmtHours(v); if(key==="tripDays") return `${v} day${v===1?"":"s"}`; if(key==="driveH"||key==="genH") return v===0?"0h":fmtHours(v).replace(" min","m"); if(key==="qty") return `${v}`; return String(v); }
function getKey(key){ return key==="tripDays" ? S.tripDays : cfg()[key]; }
function setKey(key,v){ if(key==="tripDays") S.tripDays=v; else cfg()[key]=v; }
const isPhone=()=>window.matchMedia("(max-width:760px)").matches;

/** space the scene must leave free for the overlay panels */
function safeInsets(r){
  const ins={l:16,r:16,t:16,b:16};
  const kp=$("kpis").getBoundingClientRect();
  if(isPhone()){ ins.t=kp.bottom-r.top+10; ins.b=10; ins.l=ins.r=6; return ins; }
  const tb=$("topbar").getBoundingClientRect(), bb=document.querySelector(".bottombar .timebar").getBoundingClientRect();
  ins.t=Math.max(tb.bottom, kp.bottom)-r.top+10;
  ins.b=r.bottom-bb.top+10;
  // use layout widths, not on-screen rects, so the dock's slide animation doesn't skew the fit
  if(!appEl.classList.contains("full")){ ins.r=$("dock").offsetWidth+14+12;
    if(!$("flowBody").hidden){ ins.l=$("flowbox").offsetWidth+14+12; } }
  return ins;
}

/* ---------- battery picker ---------- */
function renderBattery(){
  const c=cfg(), b=applyBat(c);
  const sel=$("batRange");
  if(!sel.options.length) sel.innerHTML=RANGES.map(r=>`<option value="${r.id}">${r.name}</option>`).join("");
  sel.value=b.r;
  $("batCaps").innerHTML=BATTERIES.filter(x=>x.r===b.r).map(x=>`<button type="button" class="chip" role="radio" aria-checked="${x.id===b.id}" data-bat="${x.id}">${x.ah}Ah</button>`).join("");
  const specs=[`12.8V lithium`, `${fmtW(b.ah*VNOM)}Wh`]; if(b.a) specs.push(`${b.a}A continuous`); if(b.kg) specs.push(`${b.kg}kg`);
  $("batModel").innerHTML=`<span class="mn">${b.name}</span><span class="mp">${b.from?"<small style='font-size:11px;font-weight:600'>from </small>":""}${money(b.price)}</span><span class="ms">${specs.join(" · ")}</span><span class="ms">${RANGES.find(r=>r.id===b.r).blurb}</span>
    <a class="linkbtn" href="${b.url}" target="_blank" rel="noopener">View on customlithium.com.au<svg><use href="#i-ext"/></svg></a>`;
  const st=document.querySelector('.stepper[data-key="qty"]'); st.querySelector("output").textContent=c.qty;
  const dem=dailyDemand(c,apps());
  const peakDC=dem.peakDC;
  const amps=(peakDC + Math.min(dem.peakAC, c.inverter||0)/INV_EFF)/VNOM;
  const cont=b.a? b.a*c.qty : null;
  const warn = cont && amps>cont ? `<div class="warnline" style="flex-basis:100%">Busiest moment pulls about ${Math.round(amps)}A, more than ${c.qty>1?"these batteries":"this battery"} supply continuously (${cont}A).</div>` : "";
  $("batBank").innerHTML=`<span>${c.qty>1?`${c.qty} in parallel · `:""}${fmtW(c.bat*VNOM)}Wh<br>${money(b.price*c.qty)}${b.from?" (from)":""}</span><b>${fmtW(c.bat)}Ah</b>${warn}`;
  $("pvBattery").textContent = `${c.qty>1?c.qty+" × ":""}${b.ah}Ah`;
}

function syncControls(){
  const c=cfg(), sc=SCEN[S.scen];
  document.querySelectorAll(".scen button").forEach(b=>b.setAttribute("aria-selected", b.dataset.scen===S.scen));
  $("startSoc").value=c.soc; setRangeFill($("startSoc"));
  $("panelW").value=c.panelW; renderCtrlSelect(); if(!$("dcdc").options.length) $("dcdc").innerHTML=DCDC_OPTIONS.map(o=>`<option value="${o.k}">${o.label}</option>`).join(""); $("dcdc").value=dcdcOpt(c.dcdcKey||c.dcdc).k; $("portHRow").hidden=!(c.portW>0); $("charger").value=c.charger; $("inverter").value=c.inverter;
  document.querySelectorAll(".locsel").forEach(e=>e.value=S.loc); document.querySelectorAll(".monthsel").forEach(e=>e.value=S.month);
  document.querySelectorAll(".stepper[data-key]").forEach(st=>{ st.querySelector("output").textContent=stepperFmt(st.dataset.key, getKey(st.dataset.key)); });
  document.querySelectorAll("#srcSeg button").forEach(b=>b.setAttribute("aria-pressed", b.dataset.src===c.src));
  document.querySelector('#srcSeg [data-src="site"]').textContent = S.scen==="shed" ? "Mains power" : "Powered site";
  $("dcdcBlock").hidden = S.scen==="shed";
  $("driveLbl").textContent = sc.driveLbl;
  $("srcRow").hidden = !c.charger; $("genRow").hidden = !(c.charger && c.src==="gen");
  if(S.climate.ac) ensureApp("aircon"); if(S.climate.heat) ensureApp("heater");
  renderBattery(); updateHints(); renderClimate();
}
function renderCtrlSelect(){
  const c=cfg(), a=alphaA(c), sel=$("mppt");
  if(c.mpptKey==="alpha" && !a) c.mpptKey=bestCtrlKey(c, c.panels*c.panelW);
  sel.innerHTML=(a?`<option value="alpha">Alpha ${a} built-in</option>`:"")+MPPT_OPTIONS.map(o=>`<option value="${o.k}">${o.label.replace("SmartSolar ","")}</option>`).join("");
  const ct=solarCtrl(c); sel.value=ct.k; c.mppt=ct.a;
}
/** keep the solar controller big enough for the fixed panels, and use an Alpha's built-in MPPT when one is fitted */
function autoCtrl(reason){
  const c=cfg(), W=c.panels*c.panelW, cur=solarCtrl(c), best=bestCtrlKey(c,W);
  let msg="";
  if(W>cur.w || (c.mpptKey==="alpha" && !alphaA(c))){ c.mpptKey=best; const n=solarCtrl(c); msg = n.via ? `Solar now runs through the Alpha ${n.a}'s built-in MPPT` : `Solar controller upgraded to ${n.label} for ${fmtW(W)}W of panels`; }
  else if(reason==="dcdc" && best==="alpha" && cur.k!=="alpha"){ c.mpptKey="alpha"; msg=`Solar now runs through the Alpha ${alphaA(c)}'s built-in MPPT, so no separate controller is needed`; }
  else if(reason==="dcdc" && cur.k==="alpha" && best!=="alpha"){ c.mpptKey=best; msg=`Solar controller set to ${solarCtrl(c).label}`; }
  if(msg){ toast("ctrl"+perfNow, msg); const sh=$("solHint"); sh.classList.add("flash"); setTimeout(()=>sh.classList.remove("flash"),1600); }
  return !!msg;
}
function prodLink(p){ return p ? `<a class="linkbtn" href="${prodUrl(p)}" target="_blank" rel="noopener">${p.name}<svg><use href="#i-ext"/></svg></a>` : ""; }
function updateHints(){
  const c=cfg(), list=apps();
  $("socOut").textContent=`${c.soc}%`;
  const sw=c.panels*c.panelW; $("solOut").textContent= c.portW>0 ? `${fmtW(sw)}W + ${fmtW(c.portW)}W` : `${fmtW(sw)}W`;
  if(c.portW>0){ let wh=0; for(let t=0;t<24;t+=STEP) if(portableOut(c,t)) wh+=c.portW*solarPerW(t)*STEP; $("portHint").textContent=`Set out for ${fmtHours(c.portH)} around midday, it adds up to about ${fmtW(wh)}Wh on a clear day. Runs on its own controller, on top of the fixed panels.`; }
  else $("portHint").textContent="Panels or a solar blanket you set out at camp. They run on their own controller, on top of the fixed panels.";
  const ct=solarCtrl(c), peak=sw*PV_BASE*pvTempFactor(clim().tmax,1)*peakFactor(sunInfo());
  const sh=$("solHint");
  if(!c.panels){ sh.textContent="No fixed solar. Add panels to charge from the sun."; sh.className="hint"; }
  else if(sw>ct.w){ sh.textContent=`${fmtW(sw)}W of panels is more than ${ct.via?`the Alpha ${ct.a}'s built-in MPPT`:ct.label} handles (${fmtW(ct.w)}W). Pick a bigger controller.`; sh.className="hint warn"; }
  else if(ct.via){ sh.textContent=`Solar runs through the Redarc Alpha ${ct.a}'s built-in MPPT (up to ${fmtW(ct.w)}W), so no separate controller is needed. Solar and alternator share its ${ct.a}A.`; sh.className="hint"; }
  else { sh.textContent=`Peak output about ${fmtW(peak)}W · ${ct.label} handles up to ${fmtW(ct.w)}W of panels`; sh.className="hint"; }
  const dopt=dcdcOpt(c.dcdcKey||c.dcdc); $("dcdcLink").innerHTML = S.scen!=="shed" && dopt.p ? prodLink(DCDC_PRODUCTS[dopt.p]) + (dopt.q>1?`<span class="hint" style="margin-left:6px">× ${dopt.q}</span>`:"") : "";
  $("chgLink").innerHTML = prodLink(CHG_PRODUCTS[c.charger]);
  const ch=$("chgHint"); const parts=[];
  if(S.scen!=="shed" && c.dcdc && c.driveH) parts.push(`DC-DC adds about ${fmtW(c.dcdc*CHG_V*c.driveH)}Wh per day of driving`);
  if(S.scen!=="shed" && c.dcdc && !c.driveH) parts.push(`Add driving hours to charge from the alternator`);
  if(S.scen!=="shed" && c.dcdc>=60) parts.push(`${c.dcdc}A of DC-DC needs a strong alternator and heavy cabling. Have an auto electrician check your vehicle`);
  if(c.charger) parts.push(c.src==="site" ? `Plugged in all day at ${fmtW(c.charger*CHG_V)}W` : `Generator adds ${fmtW(c.charger*CHG_V*c.genH)}Wh from 5pm`);
  ch.textContent=parts.join(". "); ch.hidden=!parts.length;
  const pc=[]; if(S.scen!=="shed"&&c.dcdc) pc.push(`DC-DC ${c.dcdc}A`); if(c.charger) pc.push(`240V ${c.charger}A`);
  $("pvCharge").textContent = pc.join(" · ") || "None";
  $("invOut").textContent = c.inverter? `${c.inverter}W` : "None";
  const acOn=list.filter(a=>a.on&&a.ac), big=acOn.reduce((m,a)=>ratedW(a)>m.w?{w:ratedW(a),name:a.name}:m,{w:0,name:""});
  const dem=dailyDemand(c,list);
  const ih=$("invHint");
  if(!acOn.length){ ih.textContent="No 240V appliances switched on."; ih.className="hint"; }
  else if(!c.inverter){ ih.textContent=`${acOn.length} appliance${acOn.length>1?"s need":" needs"} 240V. Add an inverter to run ${acOn.length>1?"them":"it"}.`; ih.className="hint bad"; }
  else if(big.w>c.inverter){ ih.textContent=`${big.name} draws ${fmtW(big.w)}W, more than this inverter can supply.`; ih.className="hint bad"; }
  else if(dem.peakAC>c.inverter){ ih.textContent=`At busy times your 240V gear asks for ${fmtW(dem.peakAC)}W at once. Some items won't run together.`; ih.className="hint warn"; }
  else { ih.textContent=`Biggest 240V load at once: ${fmtW(dem.peakAC)}W.`; ih.className="hint"; }
  const si=sunInfo();
  const k=clim(); $("pvLoc").textContent=`${MONTHS[S.month].slice(0,3)} · ${locById(S.loc).state}`;
  $("locHint").textContent=`Sun up ${fmtClock(si.sr)} to ${fmtClock(si.ss)} · about ${si.psh} peak sun hours on a clear day · typically ${k.tmax}° / ${k.tmin}°C with ${Math.round(k.rd)} rain days in ${MONTHS[S.month]}`;
  $("dailyUse").textContent=`${fmtW(dem.wh)}Wh · ${fmtW(dem.wh/VNOM)}Ah per day`;
  $("pvApps").textContent=`${list.filter(a=>a.on).length} on · ${(dem.wh/1000).toFixed(1)}kWh`;
}

function appMeta(a){
  if(a.id==="kids") return `<span class="num">${fmtW(a.w)}W each</span>`;
  if(a.model==="fridge") return `<span class="num">${fmtW(a.w)}W running${(a.n||1)>1?" each":""}</span>`;
  if(a.model==="heater") return `<span class="num">10–34W</span>`;
  if(a.avgW) return `<span class="num">${fmtW(a.w)}W</span>`;
  return `<span class="num">${fmtW(a.w)}W</span>`;
}
function countLbl(a){ const n=a.n||1; return `${n} ${n>1?a.count[1]:a.count[0]}`; }
function renderApps(){
  const ul=$("appList"); const c=cfg();
  ul.innerHTML = apps().map(a=>{
    let flag="";
    if(a.on && a.ac && !c.inverter) flag=`<span class="flag bad">Needs inverter</span>`;
    else if(a.on && a.ac && ratedW(a)>c.inverter) flag=`<span class="flag bad">Inverter too small</span>`;
    const cnt = a.count ? `<div class="stepper" data-count="${a.id}" title="How many"><button type="button" data-d="-1" aria-label="Fewer ${a.count[1]}">−</button><output>${countLbl(a)}</output><button type="button" data-d="1" aria-label="More ${a.count[1]}">+</button></div>` : "";
    const ctl = isAuto(a) ? `<span class="tag auto">Auto by temp</span>` : a.count ? cnt : a.fixed ? `<span class="app-meta" style="font-weight:600">24h</span>` :
      `<div class="stepper" data-app="${a.id}"><button type="button" data-d="-1" aria-label="Less ${a.name}">−</button><output>${fmtHours(a.hours)}</output><button type="button" data-d="1" aria-label="More ${a.name}">+</button></div>`;
    const note = a.note ? `<div class="app-note">${a.id==="kids" && !apps().some(x=>x.model==="starlink"&&x.on) ? "Tablets & phones, about 40Wh per charge each" : a.note}</div>` : "";
    return `<li class="app-row${a.on?" on":""}${a.id==="kids"?" kids":""}" data-id="${a.id}">
      <label class="sw"><input type="checkbox" ${a.on?"checked":""} aria-label="${a.id==="kids"?"Charging kids' devices":"Use "+a.name+" each day"}"><span></span></label>
      <span class="app-ico"><svg aria-hidden="true"><use href="#${a.icon}"/></svg></span>
      <div class="app-main"><div class="app-nm">${a.name}</div><div class="app-meta"><span class="tag${a.ac?" ac":""}">${a.ac?"240V":"12V"}</span>${appMeta(a)}${a.fixed?"":`<button type="button" class="runnow" data-run="${a.id}">Run now</button>`}${flag}${isAuto(a)?`<span class="flag" style="color:var(--green-ink)">${a.id==="aircon"?"Above "+S.climate.acAt+"°C":"Below "+S.climate.heatAt+"°C"}</span>`:""}</div>${note}</div>
      <div class="app-ctl">${ctl}</div></li>`;
  }).join("");
}

let repTimer=null;
function changed(opts={}){
  updateHints();
  if(opts.bat) renderBattery();
  if(opts.apps) { renderApps(); renderBattery(); syncProps(true); }
  if(opts.panels) updatePanels();
  if(opts.props) updateProps();
  clearTimeout(repTimer); repTimer=setTimeout(()=>{ if(!$("sheet").hidden) renderReport(); }, 180);
}
function openPanel(name){
  document.querySelectorAll(".pnl").forEach(p=>{ const on = p.dataset.p===name && !p.classList.contains("open"); p.classList.toggle("open", on); p.querySelector(".pnl-h").setAttribute("aria-expanded", on); });
}
function openSheet(){ $("sheet").hidden=false; renderReport(); if(typeof track==="function") track("simulator_report_view",{scenario:S.scen, view:S.view}); $("sheet").querySelector(".sheet-close").focus(); }
function closeSheet(){ $("sheet").hidden=true; $("reportBtn").focus(); setTimeout(maybeNudge, 1200); }

function bindUI(){
  document.querySelectorAll(".scen button").forEach(b=>b.addEventListener("click",()=>{
    if(S.scen===b.dataset.scen) return; stopWeek(); S.scen=b.dataset.scen; Lv.driveOff=0; buildScene(); syncControls(); renderApps(); resetLive(); changed();
  }));
  document.querySelectorAll(".pnl-h").forEach(h=>h.addEventListener("click",()=>openPanel(h.parentElement.dataset.p)));
  $("batRange").addEventListener("change",e=>{
    const c=cfg(), cur=batById(c.batId), opts=BATTERIES.filter(x=>x.r===e.target.value);
    const pick=opts.reduce((m,x)=>Math.abs(x.ah-cur.ah)<Math.abs(m.ah-cur.ah)?x:m, opts[0]);
    const pct=Lv.soc/capWh(); c.batId=pick.id; applyBat(c); Lv.soc=capWh()*pct; changed({bat:true});
  });
  $("batCaps").addEventListener("click",e=>{
    const ch=e.target.closest("[data-bat]"); if(!ch) return; const c=cfg(); const pct=Lv.soc/capWh();
    c.batId=ch.dataset.bat; applyBat(c); Lv.soc=capWh()*pct; changed({bat:true});
  });
  $("startSoc").addEventListener("input",e=>{ cfg().soc=+e.target.value; setRangeFill(e.target); Lv.soc=capWh()*cfg().soc/100; changed(); });
  for(const id of ["panelW","mppt","dcdc","charger","inverter"]) $(id).addEventListener("change",e=>{ if(id==="dcdc"){ const o=dcdcOpt(e.target.value); cfg().dcdcKey=o.k; cfg().dcdc=o.a; autoCtrl("dcdc"); } else if(id==="mppt"){ cfg().mpptKey=e.target.value; } else { cfg()[id]=+e.target.value; if(id==="panelW") autoCtrl("panels"); } syncControls(); changed({apps:id==="inverter", props:id==="charger", panels:id==="panelW"}); });
  document.querySelectorAll(".locsel").forEach(el=>el.addEventListener("change",e=>{ S.loc=e.target.value; document.querySelectorAll(".locsel").forEach(x=>x.value=S.loc); updateHints(); changed(); if(!$("weekModal").hidden) weekWhereChanged(); }));
  document.querySelectorAll(".monthsel").forEach(el=>el.addEventListener("change",e=>{ S.month=+e.target.value; document.querySelectorAll(".monthsel").forEach(x=>x.value=S.month); updateHints(); changed(); if(!$("weekModal").hidden) weekWhereChanged(); }));
  document.querySelectorAll("#srcSeg button").forEach(b=>b.addEventListener("click",()=>{ cfg().src=b.dataset.src; syncControls(); changed({props:true}); }));
  document.addEventListener("click",e=>{
    const btn=e.target.closest(".stepper button"); if(!btn) return;
    const st=btn.closest(".stepper"), d=+btn.dataset.d;
    if(st.dataset.key){
      const key=st.dataset.key, step=+st.dataset.step, min=+st.dataset.min, max=+st.dataset.max;
      const pct=Lv.soc/capWh();
      const v=clamp(Math.round((getKey(key)+d*step)*100)/100, min, max); setKey(key,v);
      st.querySelector("output").textContent=stepperFmt(key,v);
      if(key==="qty"){ applyBat(cfg()); Lv.soc=capWh()*pct; }
      if(key==="tripDays") renderReport();
      if(key==="portW"){ $("portHRow").hidden=!(v>0); }
      if(key==="panels" && autoCtrl("panels")) renderCtrlSelect();
      changed({panels:key==="panels"||key==="portW", bat:key==="qty"});
    } else if(st.dataset.count){
      const a=apps().find(x=>x.id===st.dataset.count); a.n=clamp((a.n||1)+d,1,a.count[2]);
      st.querySelector("output").textContent=countLbl(a); changed({apps:true});
    } else if(st.dataset.app){
      const a=apps().find(x=>x.id===st.dataset.app); const step=a.step||0.5;
      a.hours=clamp(Math.round((a.hours+d*step)*1000)/1000, step, 24);
      st.querySelector("output").textContent=fmtHours(a.hours); changed();
    }
  });
  $("appList").addEventListener("change",e=>{ const li=e.target.closest(".app-row"); if(!li) return; apps().find(x=>x.id===li.dataset.id).on=e.target.checked; changed({apps:true}); });
  $("appList").addEventListener("click",e=>{
    const b=e.target.closest("[data-run]"); if(!b) return; const a=apps().find(x=>x.id===b.dataset.run);
    const len=Math.max(a.hours/a.win.length, 10/60); Lv.runNow[a.id]=Lv.t+len;
    toast("run"+a.id+Lv.t, `${a.name} on for ${fmtHours(len)}`);
  });
  document.querySelectorAll("#weatherBar button").forEach(b=>b.addEventListener("click",()=>{
    S.weather=b.dataset.w; document.querySelectorAll("#weatherBar button").forEach(x=>x.setAttribute("aria-pressed",x===b)); changed();
  }));
  $("playBtn").addEventListener("click",()=>{ Lv.playing=!Lv.playing; $("playBtn").innerHTML=`<svg><use href="#i-${Lv.playing?"pause":"play"}"/></svg>`; $("playBtn").setAttribute("aria-label",Lv.playing?"Pause":"Play"); });
  document.querySelectorAll("#speedSeg button").forEach(b=>b.addEventListener("click",()=>{ Lv.speed=+b.dataset.speed; document.querySelectorAll("#speedSeg button").forEach(x=>x.setAttribute("aria-pressed",x===b)); }));
  $("resetBtn").addEventListener("click",()=>{ stopWeek(); resetLive(); toast("reset"+perfNow,"Back to Day 1, 6:30 am"); });
  $("timeSlider").addEventListener("change",e=>{ const target=+e.target.value, hod=((Lv.t%24)+24)%24; let ahead=target-hod; if(ahead<=0) ahead+=24; advance(ahead); toast("skip"+perfNow,`Skipped ahead to ${fmtClock(Lv.t)}`); });
  $("timeSlider").addEventListener("input",e=>setRangeFill(e.target));
  $("hideBtn").addEventListener("click",()=>{ const on=!appEl.classList.contains("full"); appEl.classList.toggle("full",on); $("hideBtn").setAttribute("aria-pressed",on); $("hideBtn").setAttribute("aria-label", on?"Show panels":"Full view"); setTimeout(()=>fitView(false),30); });
  $("flowToggle").addEventListener("click",()=>{ const b=$("flowBody"); b.hidden=!b.hidden; $("flowToggle").setAttribute("aria-expanded",!b.hidden); fitView(false); });
  $("reportBtn").addEventListener("click",openSheet);
  $("sheet").addEventListener("click",e=>{ if(e.target.closest("[data-close]")) closeSheet(); });
  document.addEventListener("keydown",e=>{ if(e.key==="Escape" && !$("sheet").hidden) closeSheet(); });
  // report controls
  document.querySelectorAll("#viewSeg button").forEach(b=>b.addEventListener("click",()=>{ S.view=b.dataset.view; document.querySelectorAll("#viewSeg button").forEach(x=>x.setAttribute("aria-pressed",x===b)); renderReport(); }));
  document.querySelectorAll("#planSeg button").forEach(b=>b.addEventListener("click",()=>{
    const p=b.dataset.plan; S.planPreset=p;
    S.plan = (p==="live"||p==="week") ? null : p==="mixed" ? ["sunny","sunny","partly","overcast","lightrain","partly","sunny"] : ["partly","overcast","lightrain","heavyrain","storm","overcast","partly"];
    document.querySelectorAll("#planSeg button").forEach(x=>x.setAttribute("aria-pressed",x===b)); renderReport();
  }));
  $("planDays").addEventListener("click",e=>{
    const chipEl=e.target.closest(".daychip"); if(!chipEl) return; const d=+chipEl.dataset.d;
    if(!S.plan || S.planPreset==="week") S.plan=[...Array(7)].map((_,i)=>planMain(i));
    S.plan[d]=WKEYS[(WKEYS.indexOf(S.plan[d])+1)%WKEYS.length];
    S.planPreset="custom"; document.querySelectorAll("#planSeg button").forEach(x=>x.setAttribute("aria-pressed","false"));
    renderReport();
  });
  $("applyBtn").addEventListener("click",applyRec);
  $("copyBtn").addEventListener("click",copySummary);
  $("auditDays").addEventListener("click",e=>{ const b=e.target.closest("[data-ad]"); if(!b) return; S.auditDay=+b.dataset.ad; renderAudit(LAST.week); });
  bindExtra();
  let rt=null; window.addEventListener("resize",()=>{ resize(); fitView(true); clearTimeout(rt); rt=setTimeout(()=>{ if(!$("sheet").hidden) renderReport(); },150); });
}

/* ================= WEATHER UI HELPER ================= */
function setWeatherUI(w){ S.weather=w; document.querySelectorAll("#weatherBar button").forEach(x=>x.setAttribute("aria-pressed", x.dataset.w===w)); }

/* ================= WEEK SIMULATION ================= */
function rng(seed){ return ()=>{ seed|=0; seed=seed+0x6D2B79F5|0; let t=Math.imul(seed^seed>>>15,1|seed); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; }; }
const PATTERNS = {
  mix:{sunny:.32,partly:.30,overcast:.15,lightrain:.12,heavyrain:.06,storm:.05},
  fine:{sunny:.56,partly:.30,overcast:.09,lightrain:.05},
  wet:{partly:.12,overcast:.24,lightrain:.26,heavyrain:.2,storm:.18}
};
function pick(R, weights){ let r=R()*Object.values(weights).reduce((a,b)=>a+b,0); for(const k in weights){ r-=weights[k]; if(r<=0) return k; } return Object.keys(weights)[0]; }
/** split a day into 3-hour blocks so weather can change through the day */
function dayBlocks(main, R, k){
  const w=[];
  for(let b=0;b<8;b++){
    let x=main, r=R();
    if(main==="sunny" && b>=4 && b<=5 && r<.18) x="partly";
    else if(main==="partly" && r<.28) x = R()<.5?"sunny":"overcast";
    else if(main==="overcast" && r<.22) x="lightrain";
    else if(main==="lightrain" && r<.35) x = R()<.5?"overcast":"heavyrain";
    else if(main==="heavyrain" && r<.3) x="lightrain";
    else if(main==="storm") x = (b>=4 && b<=6) ? "storm" : (b<2||b>6 ? (k.wetSeason?"partly":"overcast") : (R()<.5?"partly":"overcast"));
    if((main==="sunny"||main==="partly") && b===5 && k.tmax>=29 && R()<(k.wetSeason?.3:.1)) x="storm"; // pop-up afternoon storm on hot days
    w.push(x);
  }
  return w;
}
function dayTempsFor(main, R, k){
  let tmax=k.tmax+WX_TMAX[main]*0.7+(R()*5-2.5), tmin=k.tmin+WX_TMIN[main]*0.7+(R()*4-2);
  if(tmax<tmin+3) tmax=tmin+3;
  return {tmax:Math.round(tmax), tmin:Math.round(tmin)};
}
/** typical week for the chosen location and month, from its rain days and wet season */
function makeTypicalWeek(seed){
  const R=rng(seed), k=clim(), days=[];
  for(let d=0; d<7; d++){
    let main;
    if(R()<k.pWet) main = k.wetSeason ? pick(R,{storm:.45,heavyrain:.3,lightrain:.25}) : pick(R,{lightrain:.6,heavyrain:.25,storm: k.tmax>=27?.15:.05});
    else { const oc=.08+k.pWet*.45; main = pick(R,{sunny:Math.max(.2,.62-oc), partly:.3, overcast:oc}); }
    days.push({main, w:dayBlocks(main,R,k), ...dayTempsFor(main,R,k)});
  }
  return {mode:"typical", seed, days};
}
function makeWeek(pattern, seed){
  const R=rng(seed), k=clim(), days=[];
  const W={...PATTERNS[pattern]}; if(k.tmax>=29){ W.storm=(W.storm||0)+.05; } if(k.tmax<17){ W.storm=(W.storm||0)*.4; }
  for(let d=0; d<7; d++){ const main=pick(R,W); days.push({main, w:dayBlocks(main,R,k), ...dayTempsFor(main,R,k)}); }
  return {mode:"random", pattern, seed, days};
}
function customFrom(week){ return {mode:"custom", days: week.days.map(d=>({main:d.main, w:Array(8).fill(d.main), tmax:d.tmax, tmin:d.tmin}))}; }
let weekDraft=null, weekMode="typical";
const WMODE_HINT={
  typical:"Weather and temperatures typical for this location and month, based on long-term averages. Generate another to see a different typical week.",
  random:"A random mix of weather, with temperatures based on the location and month.",
  custom:"Choose each day's weather and set the high and low temperatures. Click the weather icon to change it."
};
function newDraft(){ const seed=(Math.random()*1e9)|0; weekDraft = weekMode==="random" ? makeWeek(S.weekPattern, seed) : makeTypicalWeek(seed); if(weekMode==="custom") weekDraft=customFrom(weekDraft); }
function renderWeekPrev(){
  const ed = weekMode==="custom";
  $("weekPrev").innerHTML = weekDraft.days.map((d,i)=> ed
    ? `<div class="wday edit"><b>DAY ${i+1}</b><button type="button" class="wxpick" data-wd="${i}" title="Change Day ${i+1} weather"><svg><use href="#${WEATHER[d.main].icon}"/></svg><small>${WEATHER[d.main].name}</small></button>
        <label class="tin"><span>High</span><input type="number" inputmode="numeric" min="-10" max="50" step="1" data-wd="${i}" data-k="tmax" value="${d.tmax}" aria-label="Day ${i+1} high °C"><i>°</i></label>
        <label class="tin"><span>Low</span><input type="number" inputmode="numeric" min="-15" max="45" step="1" data-wd="${i}" data-k="tmin" value="${d.tmin}" aria-label="Day ${i+1} low °C"><i>°</i></label></div>`
    : `<div class="wday"><b>DAY ${i+1}</b><svg><use href="#${WEATHER[d.main].icon}"/></svg><small>${WEATHER[d.main].name}</small><span class="num">${d.tmax}° / ${d.tmin}°</span></div>`).join("");
}
function setWeekMode(m){
  const prev=weekMode; weekMode=m;
  document.querySelectorAll("#wmodeSeg button").forEach(b=>b.setAttribute("aria-pressed", b.dataset.wm===m));
  $("wmodeHint").textContent=WMODE_HINT[m];
  $("patSeg").hidden = m!=="random";
  $("rerollBtn").hidden = m==="custom";
  $("resetCustom").hidden = m!=="custom";
  if(m==="custom") weekDraft = customFrom(weekDraft && prev!=="custom" ? weekDraft : makeTypicalWeek((Math.random()*1e9)|0));
  else newDraft();
  renderWeekPrev();
}
function weekWhereChanged(){ if(weekMode!=="custom"){ newDraft(); renderWeekPrev(); } }
function openWeekModal(){
  document.querySelectorAll(".locsel").forEach(e=>e.value=S.loc); document.querySelectorAll(".monthsel").forEach(e=>e.value=S.month);
  document.querySelectorAll("#patSeg button").forEach(b=>b.setAttribute("aria-pressed", b.dataset.pat===S.weekPattern));
  weekDraft=null; setWeekMode(weekMode); renderClimate(); $("weekModal").hidden=false; $("weekStart").focus();
}
function startWeek(){ if(typeof track==="function") track("simulator_week_run",{scenario:S.scen, location:S.loc, month:S.month});
  S.week=weekDraft; S.planPreset="week"; S.plan=null;
  $("weekModal").hidden=true;
  Lv.runNow={}; Lv.t=0; Lv.soc=capWh()*cfg().soc/100; Lv.weekRun=true; Lv.weekDone=false; Lv.weekMin=100; Lv.weekFlat=null;
  Lv.playing=true; $("playBtn").innerHTML=`<svg><use href="#i-pause"/></svg>`;
  Lv.speed=180; document.querySelectorAll("#speedSeg button").forEach(x=>x.setAttribute("aria-pressed",x.dataset.speed==="180"));
  setWeatherUI(weekWx(0));
  $("planWeekBtn").hidden=false;
  toast("wk"+perfNow,"Week simulation started");
}
function finishWeek(){
  Lv.weekRun=false; Lv.weekDone=true; Lv.playing=false; $("playBtn").innerHTML=`<svg><use href="#i-play"/></svg>`;
  toast("wkdone"+perfNow,"Week complete. Open the report to see how it went.");
}
function stopWeek(){ Lv.weekRun=false; Lv.weekDone=false; $("weekbar").hidden=true; }
let _wbKey="";
function updateWeekBar(f){
  const el=$("weekbar");
  if(!Lv.weekRun && !Lv.weekDone){ if(!el.hidden) el.hidden=true; return; }
  el.hidden=false;
  const day=Math.min(7,Math.floor(Lv.t/24)+1), prog=clamp(Lv.t/168,0,1);
  let html;
  if(Lv.weekRun) html=`<span class="wb-t">WEEK SIMULATION</span><span class="wb-d">Day ${day} of 7</span><span class="wb-bar"><i style="width:${(prog*100).toFixed(1)}%"></i></span><span class="wb-s">Lowest so far ${Math.round(Lv.weekMin)}%</span><button class="btn small primary" data-wb="skip">Skip to report</button><button class="btn small" data-wb="stop"><svg width="14" height="14"><use href="#i-stop"/></svg>Stop</button>`;
  else html=`<span class="wb-t">WEEK COMPLETE</span><span class="wb-s">${Lv.weekFlat!==null?`Ran flat on Day ${Math.floor(Lv.weekFlat/24)+1}`:`Lowest battery ${Math.round(Lv.weekMin)}%`}</span><button class="btn small" data-lead="week">Get it checked</button><button class="btn small primary" data-wb="report">View week report</button><button class="iconbtn" data-wb="close" aria-label="Close"><svg><use href="#i-close"/></svg></button>`;
  const key=html.replace(/style="width:[^"]+"/,"");
  if(key!==_wbKey){ el.innerHTML=html; _wbKey=key; } else { const i=el.querySelector(".wb-bar i"); if(i) i.style.width=(prog*100).toFixed(1)+"%"; }
}

/* ================= CLIMATE CONTROLS ================= */
function renderClimate(){
  const has=id=>apps().some(a=>a.id===id), cl=S.climate;
  const row=(key,label,sub,thKey,unit,min,max)=>`<div class="clim-row">
      <label class="sw"><input type="checkbox" data-clim="${key}" ${cl[key]?"checked":""} aria-label="${label}"><span></span></label>
      <div class="clim-txt"><b>${label}</b><small>${sub}${has(key==="ac"?"aircon":"heater")?"":" · adds it to your gear"}</small></div>
      <div class="stepper" data-climkey="${thKey}" data-min="${min}" data-max="${max}"><button type="button" data-d="-1" aria-label="Lower">−</button><output>${cl[thKey]}°C</output><button type="button" data-d="1" aria-label="Higher">+</button></div></div>`;
  const html = row("ac","Air con when hot","Turns on above","acAt","°C",22,40) + row("heat","Diesel heater when cold","Turns on below","heatAt","°C",0,20);
  document.querySelectorAll(".climbox").forEach(b=>b.innerHTML=html);
}
function ensureApp(id){ if(!apps().some(a=>a.id===id)) apps().push({id, ...CATALOG[id], on:false, hours:CATALOG[id].hours, phase:25}); }
function bindClimate(){
  document.addEventListener("change",e=>{
    const k=e.target.dataset && e.target.dataset.clim; if(!k) return;
    S.climate[k]=e.target.checked; if(e.target.checked) ensureApp(k==="ac"?"aircon":"heater");
    renderClimate(); changed({apps:true});
  });
  document.addEventListener("click",e=>{
    const b=e.target.closest("[data-climkey] button"); if(!b) return;
    const st=b.closest("[data-climkey]"), k=st.dataset.climkey;
    S.climate[k]=clamp(S.climate[k]+(+b.dataset.d), +st.dataset.min, +st.dataset.max);
    renderClimate(); changed();
  });
}

/* ================= BUY THIS SYSTEM ================= */
let buyMode="mine", cartItems=[];
function buildCart(){
  const c=cfg(); if(!REC) REC=recommend();
  const items=[];
  const bat = buyMode==="mine" ? {b:batById(c.batId), q:c.qty} : (REC.batPick ? {b:REC.batPick.b, q:REC.batPick.q} : {b:batById(c.batId), q:c.qty});
  items.push({key:"bat", name:bat.b.name, url:bat.b.url, slug:bat.b.slug, vid:bat.b.vid, qty:bat.q, price:bat.b.price, from:bat.b.from, on:true, sub:`${bat.q>1?bat.q+" in parallel · ":""}${fmtW(bat.b.ah*bat.q)}Ah`});
  if(S.scen!=="shed"){
    const o = buyMode==="mine" ? dcdcOpt(c.dcdcKey||c.dcdc) : dcdcOpt(REC_DCDC_KEY[REC.dcdc]||REC.dcdc), p=o.p?DCDC_PRODUCTS[o.p]:null;
    if(p) items.push({key:"dcdc", name:p.name, url:prodUrl(p), slug:p.slug, vid:p.vid, qty:o.q||1, price:p.price, on:true, sub: o.q>1 ? `${o.q} in parallel · ${o.a}A DC-DC charging` : `${o.a}A DC-DC charger`});
  }
  { const size = buyMode==="mine" ? c.charger : REC.chg, p=CHG_PRODUCTS[30];
    items.push({key:"chg", name:p.name, url:SHOP+p.slug, slug:p.slug, vid:p.vid, qty:1, price:p.price, on: size>0 && (buyMode==="rec" ? !!c.charger : true),
      sub: size===30 ? "30A 240V battery charger" : size>0 ? `Closest charger we stock to the ${size}A in this setup` : "Optional 240V charger for powered sites or a generator"}); }
  items.push({key:"mon", name:MONITOR.name, url:SHOP+MONITOR.slug, slug:MONITOR.slug, vid:MONITOR.vid, qty:1, price:MONITOR.price, on:false, sub:"Optional battery monitor so you can see charge on your phone"});
  items.forEach(it=>it.vid0=it.vid);
  cartItems=items; renderCart(); checkStock();
}
function renderCart(){
  $("cartList").innerHTML=cartItems.map((it,i)=>`<li class="${it.on?"on":""}"><label class="sw"><input type="checkbox" data-ci="${i}" ${it.on?"checked":""} ${it.soldOut?"disabled":""} aria-label="Include ${it.name}"><span></span></label>
    <div class="ci-main"><a href="${it.url}" target="_blank" rel="noopener">${it.name}<svg width="12" height="12"><use href="#i-ext"/></svg></a><small>${it.sub}</small>${it.stock?`<span class="ci-stock">${it.stock}</span>`:""}</div>
    <span class="ci-q">× ${it.qty}</span><b class="num">${money(it.price*it.qty)}</b></li>`).join("");
  const sel=cartItems.filter(i=>i.on && !i.soldOut);
  $("cartTotal").textContent = money(sel.reduce((s,i)=>s+i.price*i.qty,0)) + (sel.some(i=>i.from)?" (from)":"");
  $("cartGo").href = sel.length ? cartLink(sel) : STORE;
  $("cartGo").classList.toggle("disabled", !sel.length);
  $("cartNote").textContent = "Solar panels, solar controllers and inverters aren't sold on customlithium.com.au, so they're not in this cart.";
}
function openBuy(){ buyMode="mine"; cartMsg(""); hideNudge();
  const go=$("cartGo"); go.classList.remove("busy"); go.querySelector("span").textContent="Add to cart";
  $("cartHint").textContent = ON_SHOPIFY ? "Adds these to your cart. Your cart shows current prices and stock." : "Opens your cart on customlithium.com.au in a new tab. Your cart shows current prices and stock."; document.querySelectorAll("#buySeg button").forEach(b=>b.setAttribute("aria-pressed",b.dataset.buy==="mine")); buildCart(); $("buyModal").hidden=false; }
function bindBuy(){
  $("buyBtn").addEventListener("click",openBuy); $("buyBtn2").addEventListener("click",openBuy);
  document.querySelectorAll("#buySeg button").forEach(b=>b.addEventListener("click",()=>{ buyMode=b.dataset.buy; document.querySelectorAll("#buySeg button").forEach(x=>x.setAttribute("aria-pressed",x===b)); buildCart(); }));
  $("cartList").addEventListener("change",e=>{ const i=e.target.dataset.ci; if(i===undefined) return; cartItems[+i].on=e.target.checked; renderCart(); });
}

/* ================= THEME ================= */
function setTheme(t){ document.documentElement.setAttribute("data-theme",t); $("themeBtn").setAttribute("aria-label", t==="dark"?"Switch to light mode":"Switch to dark mode"); if(!$("sheet").hidden) renderReport(); }

/* ================= MODALS + WEEK BINDINGS ================= */
function bindExtra(){
  $("themeBtn").addEventListener("click",()=>setTheme(document.documentElement.getAttribute("data-theme")==="dark"?"light":"dark"));
  $("weekBtn").addEventListener("click",openWeekModal);
  $("weekStart").addEventListener("click",startWeek);
  $("rerollBtn").addEventListener("click",()=>{ newDraft(); renderWeekPrev(); });
  $("resetCustom").addEventListener("click",()=>{ weekDraft=customFrom(makeTypicalWeek((Math.random()*1e9)|0)); renderWeekPrev(); });
  document.querySelectorAll("#wmodeSeg button").forEach(b=>b.addEventListener("click",()=>setWeekMode(b.dataset.wm)));
  document.querySelectorAll("#patSeg button").forEach(b=>b.addEventListener("click",()=>{ S.weekPattern=b.dataset.pat; document.querySelectorAll("#patSeg button").forEach(x=>x.setAttribute("aria-pressed",x===b)); newDraft(); renderWeekPrev(); }));
  $("weekPrev").addEventListener("click",e=>{ const b=e.target.closest(".wxpick"); if(!b) return; const d=weekDraft.days[+b.dataset.wd];
    d.main=WKEYS[(WKEYS.indexOf(d.main)+1)%WKEYS.length]; d.w=Array(8).fill(d.main); renderWeekPrev(); const nb=$("weekPrev").querySelector(`.wxpick[data-wd="${b.dataset.wd}"]`); if(nb) nb.focus(); });
  $("weekPrev").addEventListener("change",e=>{ const inp=e.target.closest("input[data-k]"); if(!inp) return; const d=weekDraft.days[+inp.dataset.wd];
    let v=Math.round(+inp.value); if(!isFinite(v)) v=d[inp.dataset.k]; v=clamp(v, inp.dataset.k==="tmax"?-10:-15, inp.dataset.k==="tmax"?50:45); d[inp.dataset.k]=v;
    if(d.tmin>d.tmax-1){ if(inp.dataset.k==="tmax") d.tmin=d.tmax-1; else d.tmax=d.tmin+1; }
    renderWeekPrev(); });
  document.querySelectorAll(".modal").forEach(m=>m.addEventListener("click",e=>{ if(e.target.closest("[data-mclose]")) m.hidden=true; }));
  document.addEventListener("keydown",e=>{ if(e.key==="Escape") document.querySelectorAll(".modal").forEach(m=>m.hidden=true); });
  $("weekbar").addEventListener("click",e=>{
    const b=e.target.closest("[data-wb]"); if(!b) return;
    if(b.dataset.wb==="stop"){ stopWeek(); toast("wkstop"+perfNow,"Week simulation stopped"); }
    if(b.dataset.wb==="close"){ stopWeek(); }
    if(b.dataset.wb==="skip"){ // finish the remaining days instantly, then show the week report
      if(Lv.weekRun) advance(Math.max(0,168-Lv.t)+0.01);
      if(Lv.weekRun) finishWeek();
      S.planPreset="week"; S.view="weekly"; document.querySelectorAll("#viewSeg button").forEach(x=>x.setAttribute("aria-pressed",x.dataset.view==="weekly")); openSheet(); return;
    }
    if(b.dataset.wb==="report"){ S.planPreset="week"; S.view="weekly"; document.querySelectorAll("#viewSeg button").forEach(x=>x.setAttribute("aria-pressed",x.dataset.view==="weekly")); openSheet(); }
  });
  bindClimate(); bindBuy();
}

/* ================= DAILY AUDIT ================= */
function auditSegments(rows, test){
  const segs=[]; let cur=null;
  rows.forEach((r,i)=>{ const v=test(r); if(v){ if(cur && cur.v===v) cur.n++; else { cur={i, n:1, v}; segs.push(cur); } } else cur=null; });
  return segs;
}
function renderAudit(sim){
  const el=$("audit"); if(!sim || !sim.audit) return;
  const nDays=Math.round(sim.audit.length*STEP/24), d=clamp(S.auditDay,0,nDays-1);
  $("auditDays").innerHTML=[...Array(nDays)].map((_,i)=>`<button type="button" class="chip" role="radio" aria-checked="${i===d}" data-ad="${i}">Day ${i+1}</button>`).join("");
  const rows=sim.audit.slice(d*288,(d+1)*288);
  const c=cfg(), list=apps();
  const W=Math.max(700, el.clientWidth||900), L=176, Rc=150, PW=W-L-Rc-8, rowH=24;
  const x=t=>L+PW*((t-d*24)/24);
  const lines=[];
  // rows definition
  const R=[];
  R.push({type:"soc", label:"Battery level", h:40});
  R.push({type:"wx", label:"Weather", h:20});
  R.push({type:"temp", label:"Temperature", h:30});
  if(c.panels) R.push({type:"area", key:"solar", label:"Solar", color:"var(--green)"});
  if(S.scen!=="shed" && c.dcdc) R.push({type:"bar", key:"dcdc", label:"DC-DC (driving)", color:"var(--green)"});
  if(c.charger) R.push({type:"bar", key:"chg", label: c.src==="gen"?"Generator charger":"240V charger", color:"var(--green)"});
  R.push({type:"sep", label:"Appliances", h:22});
  const used=new Set(); rows.forEach(r=>{ r.on.forEach(i=>used.add(i)); r.blocked.forEach(i=>used.add(i)); });
  list.filter(a=>a.on||used.has(a.id)||isAuto(a)).forEach(a=>R.push({type:"app", a, label:a.name}));
  let y=26; R.forEach(r=>{ r.y=y; r.h=r.h||rowH; y+=r.h+6; });
  const H=y+4;
  const si=sunInfo();
  let s=`<svg viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" role="img" aria-label="Timeline of appliances and chargers for Day ${d+1}">`;
  s+=`<rect class="au-night" x="${x(d*24)}" y="20" width="${x(d*24+si.sr)-x(d*24)}" height="${H-20}"/><rect class="au-night" x="${x(d*24+si.ss)}" y="20" width="${x(d*24+24)-x(d*24+si.ss)}" height="${H-20}"/>`;
  for(let hh=0;hh<=24;hh+=3){ s+=`<line class="au-grid" x1="${x(d*24+hh)}" x2="${x(d*24+hh)}" y1="20" y2="${H}"/><text class="au-ax" x="${x(d*24+hh)}" y="13" text-anchor="${hh===0?"start":hh===24?"end":"middle"}">${fmtClock(hh).replace(":00","")}</text>`; }
  const tips=[];
  const tip=(x0,y0,w,h,html,cls)=>{ tips.push(html); return `<rect class="${cls}" x="${x0.toFixed(1)}" y="${y0}" width="${Math.max(1.5,w).toFixed(1)}" height="${h}" rx="${Math.min(3,h/2)}" data-tip="${tips.length-1}"/>`; };
  const sum=(r)=>`<text class="au-sum" x="${W-Rc+6}" y="${r.y+r.h/2+4}">`;
  for(const r of R){
    if(r.type!=="sep") s+=`<text class="au-lab" x="0" y="${r.y+r.h/2+4}">${r.label}</text>`;
    if(r.type==="sep"){ s+=`<text class="au-sep" x="0" y="${r.y+15}">${r.label.toUpperCase()}</text><line class="au-grid" x1="0" x2="${W}" y1="${r.y+21}" y2="${r.y+21}"/>`; continue; }
    if(r.type==="soc"){
      let p=`M${x(rows[0].t)} ${r.y+r.h}`; rows.forEach(q=>p+=` L${x(q.t+STEP).toFixed(1)} ${(r.y+r.h-(q.soc/100)*r.h).toFixed(1)}`); p+=` L${x(d*24+24)} ${r.y+r.h} Z`;
      s+=`<path class="au-soc" d="${p}"/><line class="au-res" x1="${L}" x2="${L+PW}" y1="${r.y+r.h*0.8}" y2="${r.y+r.h*0.8}"/>`;
      const mn=Math.min(...rows.map(q=>q.soc)), end=rows[rows.length-1].soc;
      s+=sum(r)+`Low ${Math.round(mn)}% · end ${Math.round(end)}%</text>`;
      s+=`<rect x="${L}" y="${r.y}" width="${PW}" height="${r.h}" fill="transparent" data-soc="1"/>`;
      continue;
    }
    if(r.type==="wx"){
      for(let b=0;b<8;b++){ const q=rows[b*36+18]; s+=`<use href="#${WEATHER[q.w].icon}" x="${x(d*24+b*3+1.5)-9}" y="${r.y}" width="18" height="18" class="au-wx"/>`; }
      s+=sum(r)+`${WEATHER[rows[144].w].name} at midday</text>`;
      continue;
    }
    if(r.type==="temp"){
      const tmx=Math.max(...rows.map(q=>q.temp)), tmn=Math.min(...rows.map(q=>q.temp));
      const lo=Math.min(tmn, S.climate.heat?S.climate.heatAt:99)-2, hi=Math.max(tmx, S.climate.ac?S.climate.acAt:-99)+2;
      const ty=v=>r.y+r.h-((v-lo)/Math.max(1,hi-lo))*r.h;
      if(S.climate.ac && S.climate.acAt<=hi) s+=`<line class="au-th" x1="${L}" x2="${L+PW}" y1="${ty(S.climate.acAt)}" y2="${ty(S.climate.acAt)}"/><text class="au-thl" x="${L+PW-4}" y="${ty(S.climate.acAt)-3}" text-anchor="end">AC ${S.climate.acAt}°</text>`;
      if(S.climate.heat && S.climate.heatAt>=lo) s+=`<line class="au-th cold" x1="${L}" x2="${L+PW}" y1="${ty(S.climate.heatAt)}" y2="${ty(S.climate.heatAt)}"/><text class="au-thl cold" x="${L+PW-4}" y="${ty(S.climate.heatAt)+11}" text-anchor="end">Heater ${S.climate.heatAt}°</text>`;
      let p=""; rows.forEach((q,i)=>{ if(i%3) return; p+=(p?" L":"M")+`${x(q.t).toFixed(1)} ${ty(q.temp).toFixed(1)}`; });
      s+=`<path class="au-temp" d="${p}"/>`;
      s+=sum(r)+`${Math.round(tmn)}° to ${Math.round(tmx)}°C</text>`;
      s+=`<rect x="${L}" y="${r.y}" width="${PW}" height="${r.h}" fill="transparent" data-soc="1"/>`;
      continue;
    }
    if(r.type==="area"){
      const mx=Math.max(1,...rows.map(q=>q[r.key])); let p=`M${x(rows[0].t)} ${r.y+r.h}`; rows.forEach(q=>p+=` L${x(q.t+STEP/2).toFixed(1)} ${(r.y+r.h-(q[r.key]/mx)*(r.h-2)).toFixed(1)}`); p+=` L${x(d*24+24)} ${r.y+r.h} Z`;
      s+=`<path class="au-area" d="${p}"/>`;
      const wh=rows.reduce((a,q)=>a+q[r.key]*STEP,0); s+=sum(r)+`${fmtW(wh)}Wh in</text>`;
      const peak=rows.reduce((m,q)=>q[r.key]>m.v?{v:q[r.key],t:q.t}:m,{v:0,t:0});
      s+=tip(L,r.y,PW,r.h,`<b>Solar</b><br>${fmtW(wh)}Wh today · peak ${fmtW(peak.v)}W at ${fmtClock(peak.t)}`,"au-hit");
      continue;
    }
    if(r.type==="bar"){
      const segs=auditSegments(rows,q=>q[r.key]>1?1:0); let wh=0;
      segs.forEach(g=>{ const t0=rows[g.i].t, t1=t0+g.n*STEP, e=rows.slice(g.i,g.i+g.n).reduce((a,q)=>a+q[r.key]*STEP,0); wh+=e;
        s+=tip(x(t0),r.y+3,x(t1)-x(t0),r.h-6,`<b>${r.label}</b><br>${fmtClock(t0)} – ${fmtClock(t1)} · ${fmtW(e)}Wh`,"au-in"); });
      s+=sum(r)+(segs.length?`${fmtDur(segs.reduce((a,g)=>a+g.n,0)*STEP)} · ${fmtW(wh)}Wh`:"Not used")+`</text>`;
      continue;
    }
    if(r.type==="app"){
      const a=r.a, k=a.ac?1/INV_EFF:1, eW=q=>((q.ow&&q.ow[a.id])||0)*k;
      const segs=auditSegments(rows,q=>q.blocked.includes(a.id)?2:(q.on.includes(a.id)?1:0));
      let onSteps=0;
      const cycles = (a.duty && a.duty<1) || a.model==="fridge" || a.model==="aircon" || a.model==="heater";
      segs.forEach(g=>{ const t0=rows[g.i].t, t1=t0+g.n*STEP; if(g.v===1) onSteps+=g.n;
        const html = g.v===2 ? `<b>${a.name}</b><br>Wanted ${fmtClock(t0)} – ${fmtClock(t1)} but not powered<br>${rows[g.i].flat?"Battery flat":"Inverter too small or not fitted"}`
                             : (()=>{ const seg=rows.slice(g.i,g.i+g.n), e=seg.reduce((s,q)=>s+eW(q)*STEP,0), avg=e/(g.n*STEP)/k; return `<b>${a.name}</b><br>${fmtClock(t0)} – ${fmtClock(t1)} · ${fmtW(avg)}W${a.ac?" (240V)":""}${a.model?" avg":""}<br>${fmtW(e)}Wh${isAuto(a)?" · auto by temperature":""}`; })();
        s+=tip(x(t0),r.y+3,x(t1)-x(t0),r.h-6,html,g.v===2?"au-bad":"au-on"); });
      const n=segs.filter(g=>g.v===1).length;
      s+=sum(r)+(onSteps? `${cycles? "cycling" : n+" start"+(n>1?"s":"")} · ${fmtDur(onSteps*STEP)} · ${fmtW(rows.reduce((s,q)=>s+eW(q)*STEP,0))}Wh` : (segs.length?"Not powered":"Off today"))+`</text>`;
    }
  }
  s+=`<line class="au-cross" id="auCross" x1="0" x2="0" y1="20" y2="${H}" style="opacity:0"/></svg><div class="tip" id="auTip"></div>`;
  el.innerHTML=s; el.style.width=W+"px";
  const tipEl=$("auTip"), svg=el.querySelector("svg"), cross=$("auCross");
  svg.addEventListener("pointermove",ev=>{
    const rect=svg.getBoundingClientRect(), px=(ev.clientX-rect.left)*(W/rect.width), py=(ev.clientY-rect.top)*(H/rect.height);
    const tgt=ev.target.closest("[data-tip],[data-soc]");
    if(px>=L && px<=L+PW){ cross.setAttribute("x1",px); cross.setAttribute("x2",px); cross.style.opacity=1; } else cross.style.opacity=0;
    if(!tgt){ tipEl.style.opacity=0; return; }
    let html;
    if(tgt.dataset.soc){ const t=d*24+clamp((px-L)/PW,0,0.999)*24; const q=rows[Math.floor((t-d*24)/STEP)]; html=`<b>${fmtClock(t)}</b><br>Battery ${Math.round(q.soc)}% · ${Math.round(q.temp)}°C<br>${WEATHER[q.w].name}`; }
    else html=tips[+tgt.dataset.tip];
    tipEl.innerHTML=html; tipEl.style.opacity=1;
    const left=(px/W)*rect.width+14; tipEl.style.left=Math.min(rect.width-230,left)+"px"; tipEl.style.top=((py/H)*rect.height+12)+"px";
  });
  svg.addEventListener("pointerleave",()=>{ tipEl.style.opacity=0; cross.style.opacity=0; });
  $("auditSub").textContent = `Day ${d+1}${S.planPreset==="week"&&S.week?" of your simulated week":""}: when each appliance and charger runs through the day and night. Hover a bar for times and energy.`;
}

/* ================= APPLIANCE PROPS =================
   Small illustrations that pop into the scene when an appliance is switched on in the list,
   and animate (steam, signal waves, spinning fans…) while it is actually running. */
const fx = (el)=>{ el.classList.add("fx"); return el; };
const P_DRAW = {
  mug(g,x,b){ E("rect",{x,y:b-9,width:7,height:9,rx:1.5,fill:"#F4F2EC",stroke:"#9BA49F","stroke-width":.8},g); E("path",{d:`M${x+7} ${b-7} q4 0 4 2.5 q0 2.5 -4 2.5`,fill:"none",stroke:"#9BA49F","stroke-width":1.1},g); E("ellipse",{cx:x+3.5,cy:b-9,rx:3.2,ry:.9,fill:"#6B4A33"},g);
    for(let i=0;i<2;i++) fx(E("path",{d:`M${x+2+i*3} ${b-11} q-1.6 -2.4 0 -4.8 q1.6 -2.4 0 -4.8`,fill:"none",stroke:"#C9D2CE","stroke-width":1.1,"stroke-linecap":"round",class:"steam",style:`animation-delay:${i*.6}s`},g)); },
  kettle(g,x,b){ E("path",{d:`M${x} ${b} L${x+1.5} ${b-10} Q${x+6} ${b-14} ${x+10.5} ${b-10} L${x+12} ${b} Z`,fill:"#BFC8C4",stroke:"#7D8984","stroke-width":.8},g); E("path",{d:`M${x+12} ${b-6} l4 -4`,stroke:"#7D8984","stroke-width":1.6,"stroke-linecap":"round"},g); E("circle",{cx:x+6,cy:b-12.6,r:1.2,fill:"#46544E"},g);
    fx(E("path",{d:`M${x+16} ${b-11} q-1.5 -2.5 0 -5 q1.5 -2.5 0 -5`,fill:"none",stroke:"#C9D2CE","stroke-width":1.1,"stroke-linecap":"round",class:"steam"},g)); },
  laptop(g,x,b){ E("rect",{x,y:b-2,width:22,height:2,rx:1,fill:"#46544E"},g); E("path",{d:`M${x+3} ${b-2} L${x+6} ${b-16} L${x+21} ${b-16} L${x+19} ${b-2} Z`,fill:"#3A4441"},g); E("path",{d:`M${x+5} ${b-4} L${x+7.3} ${b-14} L${x+19.2} ${b-14} L${x+17.6} ${b-4} Z`,fill:"#56707A",class:"screen"},g); },
  chest(g,x,b,lid){ E("rect",{x,y:b-15,width:26,height:15,rx:2.5,fill:"#F4F6F5",stroke:"#9AA6A1","stroke-width":.9},g); E("rect",{x:x-.5,y:b-18,width:27,height:4.5,rx:2,fill:lid},g);
    E("rect",{x:x+9,y:b-11,width:8,height:2.4,rx:1.2,fill:"#9AA6A1"},g); fx(E("circle",{cx:x+22,cy:b-4,r:1.1,fill:"#06A74F",class:"blink"},g)); },
  portable(g,x,b){ groundPanel(g, x, b, 64, 42); groundPanel(g, x+56, b+2, 64, 42); },
  tablets(g,x,b){ E("rect",{x:x-4,y:b-1,width:34,height:3,rx:1.5,fill:"#C96A4A",opacity:.85},g); for(let i=0;i<2;i++){ const tx=x+i*13; E("path",{d:`M${tx} ${b} l2 -12 h9 l-2 12 z`,fill:"#1C2321",stroke:"#46544E","stroke-width":.8},g); fx(E("path",{d:`M${tx+1.4} ${b-1.4} l1.6 -9.2 h6.6 l-1.6 9.2 z`,fill:"#7FB3E0",class:"screen tvscreen"},g)); } },
  phone(g,x,b){ E("rect",{x,y:b-2.2,width:9,height:2.2,rx:1,fill:"#1C2321"},g); E("path",{d:`M${x+9} ${b-1} q5 0 6 4`,fill:"none",stroke:"#46544E","stroke-width":.9},g); fx(E("circle",{cx:x+7,cy:b-4.5,r:1.3,fill:"#06A74F",class:"blink"},g)); },
  starlink(g,x,b){ E("path",{d:`M${x} ${b} L${x} ${b-30} M${x-8} ${b} L${x} ${b-10} L${x+8} ${b}`,stroke:"#7D8984","stroke-width":2,"stroke-linecap":"round",fill:"none"},g);
    E("rect",{x:x-13,y:b-46,width:26,height:16,rx:2.5,fill:"#F4F6F5",stroke:"#9AA6A1","stroke-width":1,transform:`rotate(-28 ${x} ${b-38})`},g);
    for(let i=0;i<3;i++) fx(E("path",{d:`M${x-12-i*5} ${b-52-i*5} a${10+i*6} ${10+i*6} 0 0 1 ${14+i*7} -${6+i*3}`,fill:"none",stroke:"#5B63D6","stroke-width":1.4,"stroke-linecap":"round",class:"wave",style:`animation-delay:${i*.25}s`},g)); },
  jerry(g,x,b){ E("rect",{x,y:b-17,width:13,height:17,rx:2,fill:"#3E7CB1",stroke:"#2D5F88","stroke-width":.8},g); E("rect",{x:x+2,y:b-21,width:7,height:4,rx:1.5,fill:"none",stroke:"#2D5F88","stroke-width":1.4},g); E("path",{d:`M${x+13} ${b-6} h3 v3`,stroke:"#7D8984","stroke-width":1.5,fill:"none"},g);
    fx(E("circle",{cx:x+16,cy:b-1,r:1.3,fill:"#7FB3E0",class:"drip"},g)); },
  kitchen(g,x,b){ E("path",{d:`M${x+3} ${b} L${x+8} ${b-32} M${x+37} ${b} L${x+32} ${b-32}`,stroke:"#7D8984","stroke-width":2.2,"stroke-linecap":"round"},g); E("rect",{x,y:b-35,width:40,height:4,rx:1.5,fill:"#AEB9B4"},g);
    E("rect",{x:x+8,y:b-39,width:24,height:4,rx:1,fill:"#26302E"},g); fx(E("rect",{x:x+11,y:b-39.6,width:18,height:1.6,rx:.8,fill:"#E9733A",class:"heat"},g));
    E("path",{d:`M${x+11} ${b-40} L${x+12} ${b-46} L${x+28} ${b-46} L${x+29} ${b-40} Z M${x+29} ${b-44} h8`,fill:"#46544E",stroke:"#46544E","stroke-width":1.4},g);
    fx(E("path",{d:`M${x+18} ${b-48} q-1.5 -2.5 0 -5 q1.5 -2.5 0 -5`,fill:"none",stroke:"#C9D2CE","stroke-width":1.1,"stroke-linecap":"round",class:"steam"},g)); },
  washer(g,x,b){ E("rect",{x,y:b-30,width:24,height:30,rx:3,fill:"#F4F6F5",stroke:"#AEB9B4","stroke-width":1},g); E("rect",{x:x+3,y:b-27,width:8,height:2,rx:1,fill:"#AEB9B4"},g); E("circle",{cx:x+12,cy:b-12,r:7.5,fill:"#56707A",stroke:"#AEB9B4","stroke-width":1.4},g);
    const d=fx(E("g",{class:"spin",style:`transform-origin:${x+12}px ${b-12}px`},g)); E("path",{d:`M${x+8} ${b-14} q4 -3 8 0`,stroke:"#B9D3E3","stroke-width":1.4,fill:"none"},d); E("path",{d:`M${x+8} ${b-10} q4 3 8 0`,stroke:"#B9D3E3","stroke-width":1.4,fill:"none"},d); },
  heater(g,x,y){ E("rect",{x,y,width:18,height:9,rx:2,fill:"#3A4441"},g); E("path",{d:`M${x+18} ${y+6} h6`,stroke:"#7D8984","stroke-width":2},g);
    for(let i=0;i<2;i++) fx(E("circle",{cx:x+26,cy:y+5,r:2.6,fill:"#D8DEDB",class:"puff",style:`animation-delay:${i*.8}s`},g)); },
  compressor(g,x,b,tx,ty){ const bx=E("g",{class:"vibwrap"},g); E("rect",{x,y:b-12,width:20,height:12,rx:2,fill:"#3A4441"},bx); E("rect",{x,y:b-9,width:20,height:2.5,fill:"#E0A100"},bx); E("rect",{x:x+5,y:b-15,width:10,height:3,rx:1.5,fill:"#46544E"},bx);
    E("path",{d:`M${x+20} ${b-6} C ${x+40} ${b-6}, ${tx-10} ${ty+16}, ${tx} ${ty}`,fill:"none",stroke:"#1C2321","stroke-width":1.6},g); fx(E("g",{class:"vibmark"},g)); },
  winIcon(g,x,y,s,icon){ const u=E("use",{href:"#"+icon,x,y,width:s,height:s,class:"wicon"},g); return u; },
  tv(g,x,y,w,h){ E("rect",{x,y,width:w,height:h,rx:2,fill:"#1C2321",stroke:"#46544E","stroke-width":1},g); E("rect",{x:x+2,y:y+2,width:w-4,height:h-4,rx:1,fill:"#2E3A40",class:"screen tvscreen"},g); E("path",{d:`M${x+w/2} ${y+h} v3 M${x+w/2-5} ${y+h+3} h10`,stroke:"#46544E","stroke-width":1.4},g); },
  zzz(g,x,y){ for(let i=0;i<3;i++){ const t=fx(E("text",{x:x+i*6,y:y-i*5,"font-size":8+i*2,"font-weight":"700","font-family":"Noto Sans, sans-serif",fill:"#9DB0D6",class:"zzz",style:`animation-delay:${i*.5}s`},g)); t.textContent="z"; } },
  camera(g,x,y){ E("path",{d:`M${x} ${y} l14 4 l-2 7 l-14 -3 z`,fill:"#F4F6F5",stroke:"#7D8984","stroke-width":1},g); E("path",{d:`M${x+2} ${y+6} l-2 8`,stroke:"#7D8984","stroke-width":2},g); fx(E("circle",{cx:x+11,cy:y+6,r:1.4,fill:"#E04A3A",class:"blink"},g)); },
  radio(g,x,b){ E("rect",{x,y:b-11,width:18,height:11,rx:2,fill:"#46544E"},g); E("circle",{cx:x+5,cy:b-5.5,r:3,fill:"#26302E"},g); E("rect",{x:x+10,y:b-8,width:6,height:2,fill:"#E0A100"},g); E("path",{d:`M${x+14} ${b-11} l3 -7`,stroke:"#7D8984","stroke-width":1},g);
    for(let i=0;i<2;i++) fx(E("path",{d:`M${x+6+i*7} ${b-16} v-6 l4 -1.4 v5 M${x+6+i*7} ${b-16} a1.8 1.4 0 1 1 -0.1 0`,fill:"#9DB0D6",stroke:"#9DB0D6","stroke-width":1,class:"note",style:`animation-delay:${i*.7}s`},g)); },
  drill(g,x,b){ E("path",{d:`M${x} ${b-14} h16 v6 h-9 l-2 8 h-5 l1 -8 h-1 z`,fill:"#E0A100",stroke:"#9A7400","stroke-width":.8},g); E("path",{d:`M${x+16} ${b-11} h7`,stroke:"#7D8984","stroke-width":1.6},g);
    for(let i=0;i<3;i++) fx(E("path",{d:`M${x+24} ${b-11} l${4+i} ${-3+i*3}`,stroke:"#FFC24A","stroke-width":1.2,"stroke-linecap":"round",class:"spark",style:`animation-delay:${i*.07}s`},g)); },
  toolchg(g,x,b){ E("rect",{x,y:b-7,width:16,height:7,rx:1.5,fill:"#3A4441"},g); E("rect",{x:x+3,y:b-13,width:10,height:6,rx:1,fill:"#E0A100"},g); fx(E("circle",{cx:x+13,cy:b-3.5,r:1.2,fill:"#06A74F",class:"blink"},g)); },
  microwave(g,x,b){ E("rect",{x,y:b-15,width:26,height:15,rx:2,fill:"#E6ECE9",stroke:"#AEB9B4","stroke-width":.8},g); E("rect",{x:x+3,y:b-12,width:15,height:9,rx:1,fill:"#3A4441",class:"mwin"},g); E("rect",{x:x+20,y:b-12,width:3,height:9,rx:.5,fill:"#AEB9B4"},g); },
  barfridge(g,x,b){ E("rect",{x,y:b-36,width:26,height:36,rx:2,fill:"#F4F6F5",stroke:"#AEB9B4","stroke-width":1},g); E("rect",{x:x+20,y:b-32,width:2,height:12,rx:1,fill:"#AEB9B4"},g); fx(E("circle",{cx:x+5,cy:b-31,r:1.2,fill:"#5B63D6",class:"blink"},g)); },
  acunit(g,x,b){ E("rect",{x,y:b-32,width:46,height:32,rx:3,fill:"#F4F6F5",stroke:"#AEB9B4","stroke-width":1},g); E("circle",{cx:x+30,cy:b-16,r:11,fill:"#DCE4E0",stroke:"#AEB9B4","stroke-width":1},g);
    const f=E("g",{class:"spin",style:`transform-origin:${x+30}px ${b-16}px`},g); for(let i=0;i<3;i++) E("path",{d:`M${x+30} ${b-16} q5 -5 0 -10 q-4 5 0 10`,fill:"#7D8984",transform:`rotate(${i*120} ${x+30} ${b-16})`},f);
    for(let i=0;i<4;i++) E("line",{x1:x+4,y1:b-27+i*6,x2:x+14,y2:b-27+i*6,stroke:"#C9D2CE","stroke-width":1.4},g); },
  pumpbox(g,x,b){ E("rect",{x,y:b-10,width:16,height:10,rx:2,fill:"#3E7CB1"},g); E("path",{d:`M${x+16} ${b-6} h8 v-14`,fill:"none",stroke:"#7D8984","stroke-width":2},g); fx(E("circle",{cx:x+24,cy:b-3,r:1.3,fill:"#7FB3E0",class:"drip"},g)); },
  walllamp(g,x,y){ E("rect",{x,y,width:8,height:10,rx:2,fill:"#46544E"},g); E("rect",{x:x+1.5,y:y+2,width:5,height:6,rx:1,fill:"#E9E3CF",class:"lamp"},g); },
  ledstrip(g,x1,x2,y){ E("rect",{x:x1,y,width:x2-x1,height:2.4,rx:1.2,fill:"#E9E3CF",class:"lamp"},g); },
  cpapbox(g,x,y){ E("rect",{x,y,width:12,height:7,rx:1.5,fill:"#E6ECE9",stroke:"#9BA49F","stroke-width":.6},g); E("path",{d:`M${x+12} ${y+2} q6 -1 8 -6`,fill:"none",stroke:"#9BA49F","stroke-width":1},g); }
};
/** where each appliance appears in each setup: layer = which scene group it sits in */
const PROP_PLACES = {
  caravan:{
    coffee:{layer:"fg", d:g=>P_DRAW.mug(g,404,492)},
    kettle:{layer:"fg", d:g=>P_DRAW.kettle(g,416,492)},
    laptop:{layer:"fg", d:g=>P_DRAW.laptop(g,434,492)},
    usb:{layer:"fg", d:g=>P_DRAW.phone(g,459,492)},
    kids:{layer:"fg", d:g=>P_DRAW.tablets(g,416,514)},
    fridge2:{layer:"fg", d:g=>P_DRAW.chest(g,610,530,"#3A4441")},
    freezer:{layer:"fg", d:g=>P_DRAW.chest(g,640,530,"#3E7CB1")},
    starlink:{layer:"fg", d:g=>P_DRAW.starlink(g,676,520)},
    pump:{layer:"props", d:g=>P_DRAW.jerry(g,566,478)},
    induction:{layer:"fg", d:g=>P_DRAW.kitchen(g,566,522)},
    washer:{layer:"fg", d:g=>P_DRAW.washer(g,318,522)},
    heater:{layer:"main", d:g=>P_DRAW.heater(g,344,451)},
    tv:{layer:"main", d:g=>P_DRAW.tv(g,334,322,40,24)},
    microwave:{layer:"main", d:g=>P_DRAW.winIcon(g,441,318,17,"a-microwave")},
    hairdryer:{layer:"main", d:g=>P_DRAW.winIcon(g,460,318,17,"a-wind")},
    fan:{layer:"main", d:g=>{ const u=P_DRAW.winIcon(g,604,316,19,"a-fan"); u.classList.add("spinicon"); }},
    cpap:{layer:"main", d:g=>{ P_DRAW.cpapbox(g,628,344); P_DRAW.zzz(g,640,300); }},
    fridge:{layer:"main", d:g=>P_DRAW.winIcon(g,652,316,19,"a-fridge")},
    lights:{existing:"festG"}, aircon:{existing:"acG"}
  },
  "4wd":{
    coffee:{layer:"fg", d:g=>P_DRAW.mug(g,202,492)},
    kettle:{layer:"fg", d:g=>P_DRAW.kettle(g,213,492)},
    laptop:{layer:"fg", d:g=>P_DRAW.laptop(g,231,492)},
    usb:{layer:"fg", d:g=>P_DRAW.phone(g,255,492)},
    kids:{layer:"fg", d:g=>P_DRAW.tablets(g,214,514)},
    fridge2:{layer:"fg", d:g=>P_DRAW.chest(g,300,530,"#3A4441")},
    freezer:{layer:"fg", d:g=>P_DRAW.chest(g,330,530,"#3E7CB1")},
    starlink:{layer:"fg", d:g=>P_DRAW.starlink(g,372,516)},
    pump:{layer:"fg", d:g=>P_DRAW.jerry(g,292,510)},
    induction:{layer:"fg", d:g=>P_DRAW.kitchen(g,96,524)},
    compressor:{layer:"props", d:g=>P_DRAW.compressor(g,586,478,666,452)},
    heater:{layer:"main", d:g=>P_DRAW.heater(g,424,420)},
    lights:{layer:"main", d:g=>P_DRAW.ledstrip(g,444,640,283)},
    fan:{layer:"main", d:g=>{ const u=P_DRAW.winIcon(g,592,301,18,"a-fan"); u.classList.add("spinicon"); }},
    cpap:{layer:"main", d:g=>{ P_DRAW.winIcon(g,614,301,18,"a-moon"); P_DRAW.zzz(g,626,292); }},
    fridge:{existing:"fridgeG"}
  },
  shed:{
    tools:{layer:"inside", d:g=>P_DRAW.drill(g,488,446)},
    radio:{layer:"inside", d:g=>P_DRAW.radio(g,520,446)},
    toolchg:{layer:"inside", d:g=>P_DRAW.toolchg(g,544,446)},
    kettle:{layer:"inside", d:g=>P_DRAW.kettle(g,564,446)},
    coffee:{layer:"inside", d:g=>P_DRAW.mug(g,582,446)},
    usb:{layer:"inside", d:g=>P_DRAW.phone(g,594,446)},
    microwave:{layer:"inside", d:g=>P_DRAW.microwave(g,482,416)},
    barfridge:{layer:"inside", d:g=>P_DRAW.barfridge(g,614,478)},
    freezer:{layer:"inside", d:g=>P_DRAW.chest(g,452,478,"#3E7CB1")},
    camera:{layer:"main", d:g=>P_DRAW.camera(g,800,342)},
    starlink:{layer:"main", d:g=>{ E("path",{d:"M822 334 v-10",stroke:"#7D8984","stroke-width":2},g); P_DRAW.starlink(g,822,326); }},
    aircon:{layer:"main", d:g=>P_DRAW.acunit(g,752,478)},
    pump:{layer:"main", d:g=>P_DRAW.pumpbox(g,858,478)},
    lights:{layer:"main", d:g=>P_DRAW.walllamp(g,744,374)},
    heater:{layer:"main", d:g=>P_DRAW.winIcon(g,770,372,18,"a-flame")},
    fan:{layer:"main", d:g=>{ const u=P_DRAW.winIcon(g,770,372,18,"a-fan"); u.classList.add("spinicon"); }},
    flood:{existing:"floodG"}
  }
};
const INSIDE_APPS=["tools","radio","toolchg","kettle","coffee","usb","microwave","barfridge","freezer"];
function buildProps(s){
  s.props={};
  const places=PROP_PLACES[s.scen]||{};
  const layers={fg:s.fg, props:s.propsG, main:s.mainG, inside:s.shedInside};
  for(const id in places){
    const pl=places[id];
    let g;
    if(pl.existing){ g=s[pl.existing]; if(!g) continue; }
    else { const parent=layers[pl.layer]||s.mainG; if(!parent) continue; g=E("g",{},parent); pl.d(g); }
    g.classList.add("prop"); g.dataset.app=id;
    s.props[id]=g;
  }
}
const propShown = a => !!(a && (a.on || isAuto(a)));
function syncProps(animate){
  if(!SC || !SC.props) return;
  const list=apps();
  for(const id in SC.props){
    const g=SC.props[id], fr=list.find(x=>x.id==="fridge"), a= id==="fridge2" ? fr : list.find(x=>x.id===id), want= id==="fridge2" ? !!(fr&&fr.on&&(fr.n||1)>1) : propShown(a), was=g.classList.contains("on");
    if(want===was && g.dataset.init) continue;
    g.dataset.init="1";
    if(!animate){ g.classList.add("noanim"); g.classList.toggle("on",want); requestAnimationFrame(()=>requestAnimationFrame(()=>g.classList.remove("noanim"))); continue; }
    g.classList.toggle("on",want);
    propBurst(g, a ? a.name : id, want);
  }
  if(SC.rollG){ const open = INSIDE_APPS.some(id=>propShown(list.find(x=>x.id===id))); SC.rollG.classList.toggle("open", open); }
}
function propBurst(g, name, added){
  let bb; try{ bb=g.getBBox(); }catch(e){ return; }
  if(!bb || (!bb.width && !bb.height)) return;
  const cx=bb.x+bb.width/2, top=bb.y, cy=bb.y+bb.height/2;
  if(added){ const ring=E("circle",{cx,cy,r:clamp(Math.max(bb.width,bb.height)*0.6,10,34),class:"pburst"},SC.propFx); setTimeout(()=>ring.remove(),900); }
  const t=E("text",{x:cx,y:top-8,"text-anchor":"middle",class:"ptag"+(added?"":" off")},SC.propFx); t.textContent=(added?"+ ":"− ")+name;
  setTimeout(()=>t.remove(),1700);
}
function updatePropRun(live){ if(!SC || !SC.props) return; for(const id in SC.props) SC.props[id].classList.toggle("run", live.has(id)); }

/* ================= QUICK "HOW TO USE" TOUR ================= */
function tourSteps(){
  const drive = S.scen==="caravan"
    ? {title:"Towing & other charging", text:"Roughly how many hours a day do you tow the van? Your DC-DC charger tops up the battery while you drive. Add a 240V charger here for powered sites."}
    : S.scen==="4wd"
    ? {title:"Driving & other charging", text:"How many hours a day do you usually drive? Your DC-DC charger tops up the battery from the alternator while you're moving."}
    : {title:"Generator or mains", text:"Got a generator or mains power at the shed? Set your 240V charger and how long it runs here."};
  return [
    {target:null, title:"Welcome to the Custom Lithium 12V Battery Simulator", text:"Build your setup and watch your battery work through the day and night. Here's a quick 30-second tour.",
     note:"<b>Good to know:</b> results are an estimate and rough guide only. Please have a qualified professional check your system before you buy. Our Custom Lithium team are always happy to talk it through with you.", next:"Show me"},
    {target:".scen", title:"Choose your setup", text:"Pick a caravan, 4WD or off-grid shed."},
    {target:'.pnl[data-p="battery"]', panel:"battery", title:"Pick your battery", text:"Choose your Custom Lithium battery and size here. Add more in parallel if you need extra capacity."},
    {target:'.pnl[data-p="solar"]', panel:"solar", title:"Add solar", text:"Set how many solar panels you have, or plan to fit."},
    {target:'.pnl[data-p="charge"]', panel:"charge", ...drive},
    {target:'.pnl[data-p="apps"]', panel:"apps", title:"Your appliances", text:"Switch on the gear you'd normally use, like the fridge, lights or coffee machine, and set roughly how many hours a day."},
    {target:'.pnl[data-p="loc"]', panel:"loc", title:"Where & when", text:"Set where you're heading and the time of year. It changes the sun and the temperature."},
    {target:".bottombar .timebar", title:"Weather & time", text:"Change the weather here and watch the day play out. Drag the slider to skip ahead, or speed things up."},
    {target:"#kpis", title:"Your battery at a glance", text:"See your battery level, what's charging and what you're using, live."},
    {target:"#weekBtn", title:"Test a whole week", text:"Run seven days with typical, random or your own weather to see how your setup copes."},
    {target:"#reportBtn", title:"Get your report", text:"See how long your power lasts and what we'd recommend for your trip."},
    {target:"#expertBtn", title:"Talk to our team", text:"Not sure what you need? Send us your setup and a Custom Lithium specialist will check it and help you pick the right gear.", next:"Start planning"}
  ];
}
const TOUR={i:0, steps:[]};
function ensurePanel(name){ const p=document.querySelector(`.pnl[data-p="${name}"]`); if(p && !p.classList.contains("open")) openPanel(name); }
function startTour(){
  if(appEl.classList.contains("full")) $("hideBtn").click();
  document.querySelectorAll(".modal").forEach(m=>m.hidden=true); if(!$("sheet").hidden) closeSheet();
  TOUR.steps=tourSteps(); TOUR.i=0; $("tour").hidden=false;
  $("tourDots").innerHTML=TOUR.steps.slice(1).map(()=>"<i></i>").join("");
  showTourStep();
}
function endTour(){ if(typeof track==="function" && !$("tour").hidden) track(TOUR.i>=TOUR.steps.length-1?"simulator_tour_complete":"simulator_tour_skip",{step:TOUR.i}); $("tour").hidden=true; ensurePanel("battery"); fitView(false); }
function showTourStep(){
  const st=TOUR.steps[TOUR.i], card=$("tourCard"), spot=$("tourSpot");
  if(st.panel) ensurePanel(st.panel);
  $("tourStep").textContent = TOUR.i ? `${TOUR.i} of ${TOUR.steps.length-1}` : "";
  $("tourTitle").textContent=st.title; $("tourText").textContent=st.text;
  $("tourNote").innerHTML=st.note||""; $("tourNote").hidden=!st.note;
  $("tourNext").textContent = st.next || "Next";
  $("tourBack").hidden = TOUR.i===0; $("tourSkip").hidden = TOUR.i===TOUR.steps.length-1;
  [...$("tourDots").children].forEach((d,k)=>d.classList.toggle("on", k===TOUR.i-1));
  $("tourDots").hidden = TOUR.i===0;
  const el = st.target ? document.querySelector(st.target) : null;
  if(el && isPhone()) el.scrollIntoView({block:"center", behavior:"smooth"});
  requestAnimationFrame(()=>requestAnimationFrame(()=>placeTour(el)));
  setTimeout(()=>placeTour(el), isPhone()?450:60);
  $("tourNext").focus({preventScroll:true});
}
function placeTour(el){
  if($("tour").hidden) return;
  const card=$("tourCard"), spot=$("tourSpot"), vw=window.innerWidth, vh=window.innerHeight, pad=6, gap=14;
  card.classList.toggle("center", !el); $("tour").classList.toggle("dim", !el);
  if(!el){ spot.style.opacity=0; card.style.left=""; card.style.top=""; return; }
  const r=el.getBoundingClientRect();
  Object.assign(spot.style,{opacity:1, left:(r.left-pad)+"px", top:(r.top-pad)+"px", width:(r.width+pad*2)+"px", height:(r.height+pad*2)+"px"});
  if(isPhone()){ card.style.left=""; card.style.top=""; card.classList.add("sheet"); return; }
  card.classList.remove("sheet");
  const cw=card.offsetWidth, ch=card.offsetHeight;
  let x, y;
  if(r.left > vw*0.55){ x=r.left-pad-gap-cw; y=r.top; }                       // target on the right: card to its left
  else if(r.bottom+pad+gap+ch < vh){ x=r.left; y=r.bottom+pad+gap; }          // room below
  else { x=r.left; y=r.top-pad-gap-ch; }                                      // otherwise above
  x=clamp(x, 12, vw-cw-12); y=clamp(y, 12, vh-ch-12);
  card.style.left=x+"px"; card.style.top=y+"px";
}
function bindTour(){
  $("helpBtn").addEventListener("click",startTour);
  $("tourNext").addEventListener("click",()=>{ if(TOUR.i>=TOUR.steps.length-1) return endTour(); TOUR.i++; showTourStep(); });
  $("tourBack").addEventListener("click",()=>{ if(TOUR.i>0){ TOUR.i--; showTourStep(); } });
  $("tourSkip").addEventListener("click",endTour);
  document.addEventListener("keydown",e=>{ if($("tour").hidden) return;
    if(e.key==="Escape") endTour(); else if(e.key==="ArrowRight") $("tourNext").click(); else if(e.key==="ArrowLeft") $("tourBack").click(); });
  window.addEventListener("resize",()=>{ if(!$("tour").hidden){ const st=TOUR.steps[TOUR.i]; placeTour(st.target?document.querySelector(st.target):null); } });
  window.addEventListener("scroll",()=>{ if(!$("tour").hidden){ const st=TOUR.steps[TOUR.i]; placeTour(st.target?document.querySelector(st.target):null); } },{passive:true});
}

/* ================= SHOPIFY CART + TALK TO OUR TEAM ================= */
// When this page is served from the Shopify theme template, the template sets window.CL_ON_SHOPIFY = true
// (and Shopify's own window.Shopify object is present). Everything below then talks to the store directly.
const CL = Object.assign({
  store: "https://customlithium.com.au",
  email: "sales@customlithium.com.au",
  leadEndpoint: null          // optional: also POST each lead as JSON to a CRM / Zapier / Klaviyo webhook
}, window.CL_CONFIG || {});
const CL_STORE_RE = /^https:\/\/customlithium\.com\.au/;
const ON_SHOPIFY = !!(window.CL_ON_SHOPIFY || (window.Shopify && window.Shopify.shop));

// Sends simulator events to GA4 / Google Ads (gtag), Meta (fbq), Google Tag Manager (dataLayer) and Shopify custom pixels.
// Only flat text/number values are sent so every platform accepts them.
const META_STD = {simulator_lead:"Lead"};   // cart adds are already reported by Shopify's own Meta/Google connections
function track(name, data){
  const flat={}; Object.entries(data||{}).forEach(([k,v])=>{ if(v==null) return; flat[k]= (typeof v==="object") ? JSON.stringify(v).slice(0,100) : v; });
  flat.tool="12v_battery_simulator";
  try{ if(typeof window.gtag==="function") window.gtag("event", name, flat); else (window.dataLayer = window.dataLayer || []).push(Object.assign({event:name}, flat)); }catch(e){}
  try{ if(typeof window.fbq==="function"){ if(META_STD[name]) window.fbq("track", META_STD[name], {content_name:"12V Battery Simulator"}); else window.fbq("trackCustom", name, flat); } }catch(e){}
  try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, flat); }catch(e){}
}
function fetchT(url, ms, opt){
  const c = new AbortController(), t = setTimeout(()=>c.abort(), ms);
  return fetch(url, Object.assign({}, opt||{}, {signal:c.signal})).finally(()=>clearTimeout(t));
}

/* ---------- a fresh copy of the results, even if the report hasn't been opened ---------- */
function freshResults(){
  const c=cfg(), trip=simulate(c, apps(), S.tripDays, planWeather, {series:false});
  REC=recommend(); LAST=Object.assign({}, LAST, {trip, dem:REC.dem});
  return {c, trip};
}
function setupLine(){
  const {c, trip}=freshResults();
  return `${SCEN[S.scen].name} | ${c.qty>1?c.qty+" x ":""}${batById(c.batId).name} | ${fmtW(c.panels*c.panelW)}W solar | ${S.tripDays} days near ${locById(S.loc).name} in ${MONTHS[S.month]} | uses ${fmtW(REC.dem.wh)}Wh/day | lowest ${Math.round(trip.minPct)}%${trip.flatAt!==null?" (runs flat)":""}`;
}

/* ---------- live stock + price check against the store ---------- */
const LIVE = {};
function liveProduct(slug){
  if(!LIVE[slug]) LIVE[slug] = fetchT(`${ON_SHOPIFY?"":CL.store}/products/${slug}.js`, 5000, {credentials:"same-origin"})
    .then(r=>r.ok?r.json():null).catch(()=>null);
  return LIVE[slug];
}
async function checkStock(){
  const items=cartItems;
  await Promise.all(items.map(async it=>{
    const p=await liveProduct(it.slug); if(!p || !p.variants) return;
    const want=p.variants.find(v=>String(v.id)===String(it.vid0));
    const pick=(want && want.available) ? want : p.variants.find(v=>v.available);
    if(pick){
      it.vid=String(pick.id); it.price=pick.price/100; it.from=false;
      it.stock = pick===want ? "" : `${want?want.title:"That option"} is sold out, so we've picked ${pick.title}.`;
    } else { it.stock="Sold out right now. Talk to our team about the next best option."; it.on=false; it.soldOut=true; }
  }));
  if(items===cartItems && !$("buyModal").hidden) renderCart();
}

function cartMsg(html, ok){ const m=$("cartMsg"); m.innerHTML=html; m.classList.toggle("ok",!!ok); m.hidden=!html; }

async function goToCart(e){
  e.preventDefault();
  const sel=cartItems.filter(i=>i.on && i.qty>0 && !i.soldOut);
  if(!sel.length) return;
  track("simulator_add_to_cart", {scenario:S.scen, item_count:sel.reduce((n,i)=>n+i.qty,0), value:Math.round(sel.reduce((n,i)=>n+i.price*i.qty,0)), currency:"AUD", items:sel.map(i=>i.name).join(", ")});

  if(!ON_SHOPIFY){
    // Off the store (e.g. this preview): open a cart link on customlithium.com.au
    const url=cartLink(sel) + "&attributes[Battery Simulator]=" + encodeURIComponent(setupLine());
    let w=null; try{ w=window.open(url, "_blank"); if(w) w.opener=null; }catch(_){}
    if(!w){
      cartMsg(`Your browser didn't let us open a new tab from here. <a href="${url}" target="_blank" rel="noopener">Open your cart on customlithium.com.au</a>. Once the simulator is on the website, this button adds straight to the cart.`);
    } else cartMsg("Your cart is open in a new tab.", true);
    return;
  }

  // On the store: add with the Ajax Cart API, save the setup on the order, then go to the cart
  const go=$("cartGo"); go.classList.add("busy"); go.querySelector("span").textContent="Adding…"; cartMsg("");
  try{
    const items=sel.map(i=>({id:+i.vid, quantity:i.qty, properties:{"_Built with":"12V Battery Simulator"}}));
    const r=await fetch("/cart/add.js", {method:"POST", credentials:"same-origin",
      headers:{"Content-Type":"application/json", "Accept":"application/json"}, body:JSON.stringify({items})});
    const j=await r.json().catch(()=>({}));
    if(!r.ok) throw new Error(j.description || j.message || "We couldn't add that to your cart.");
    await fetch("/cart/update.js", {method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json", "Accept":"application/json"},
      body:JSON.stringify({attributes:{"Battery Simulator": setupLine()}})}).catch(()=>{});
    window.location.href="/cart";
  }catch(err){
    go.classList.remove("busy"); go.querySelector("span").textContent="Add to cart";
    cartMsg(`${err.message} Give us a call on <a href="tel:+61735194220">(07) 3519 4220</a> or <button class="linkbtn" data-lead="cart-error">send your setup to the team</button> and we'll sort it out.`);
  }
}

/* ---------- talk to our team (lead capture) ---------- */
let leadSrc="topbar", leadSent=false, leadPref="Phone call";
const RIG = {caravan:["Your caravan","Make, model and length"], "4wd":["Your 4WD","Make, model and year"], shed:["Your shed or cabin","Where it is and what it's for"]};
function openLead(src){
  leadSrc=src||"topbar"; hideNudge();
  document.querySelectorAll(".modal").forEach(m=>{ if(m.id!=="leadModal") m.hidden=true; });
  const {c, trip}=freshResults();
  $("leadSetup").innerHTML=[
    ["Setup", SCEN[S.scen].name],
    ["Battery", `${c.qty>1?c.qty+" × ":""}${batById(c.batId).name}`],
    ["Solar", `${fmtW(c.panels*c.panelW)}W`],
    ["Trip", `${S.tripDays} days · ${locById(S.loc).name} · ${MONTHS[S.month]}`],
    ["Result", trip.flatAt!==null ? "Runs flat" : `Lowest ${Math.round(trip.minPct)}%`]
  ].map(x=>`<span>${x[0]} <b>${x[1]}</b></span>`).join("");
  $("leadLead").textContent = leadSrc==="buy" || leadSrc==="cart-error"
    ? "Before you buy, send us your setup. A Custom Lithium specialist will check it's right for how you travel and get back to you."
    : "Send us your setup and a Custom Lithium specialist will check it, answer your questions and help you pick the right gear.";
  $("leadRigLbl").textContent=RIG[S.scen][0]; $("leadRig").placeholder=RIG[S.scen][1];
  $("leadFormWrap").hidden=false; $("leadDone").hidden=true; $("leadErr").hidden=true;
  $("leadModal").hidden=false;
  if(ON_SHOPIFY) protectedForm("contact");
  track("simulator_lead_open", {source:leadSrc, scenario:S.scen});
  setTimeout(()=>{ const f=$("leadForm").elements.name; if(!f.value) f.focus({preventScroll:true}); }, 60);
}
function leadErr(msg){ $("leadErr").textContent=msg; $("leadErr").hidden=!msg; }
function buildLeadFields(d){
  return {
    "form_type":"contact", "utf8":"✓",
    "contact[name]":d.name, "contact[email]":d.email, "contact[phone]":d.phone,
    "contact[Postcode]":d.postcode, "contact[Best way to reach]":leadPref,
    [`contact[${RIG[S.scen][0]}]`]:d.rig, "contact[Came from]":"12V Battery Simulator ("+leadSrc+")",
    "contact[body]": `${d.msg?d.msg+"\n\n":""}----- 12V Battery Simulator setup -----\n${summaryText()}`
  };
}
/* Shopify protects its contact and newsletter forms with an invisible hCaptcha check.
   We post through a real (off-screen) Shopify form so Shopify's own captcha script adds its token,
   then send that form with fetch so the customer never leaves the simulator. */
const SHOP_FORMS={};
function protectedForm(type){
  if(SHOP_FORMS[type]) return SHOP_FORMS[type];
  const f=document.createElement("form");
  f.method="post"; f.action="/contact#contact_form"; f.acceptCharset="UTF-8"; f.className="cl-shopform"; f.setAttribute("aria-hidden","true"); f.style.cssText="position:absolute;left:-10000px;top:0;width:1px;height:1px;overflow:hidden";
  f.innerHTML=`<input type="hidden" name="form_type" value="${type}"><input type="hidden" name="utf8" value="\u2713">`;
  const st={form:f, pending:null};
  // Shopify's captcha script calls form.submit() once it has added the token. We take over that final send.
  f.submit=function(){
    const p=st.pending; st.pending=null; if(!p) return;
    fetchT("/contact", 15000, {method:"POST", credentials:"same-origin", headers:{"Accept":"text/html"}, body:new URLSearchParams(new FormData(f))})
      .then(r=>p.resolve(r.ok && !/challenge/i.test(r.url) ? "ok" : "fail"), ()=>p.resolve("fail"));
  };
  document.body.appendChild(f);
  try{ if(window.Shopify && Shopify.captcha && Shopify.captcha.protect) Shopify.captcha.protect(f); }catch(e){}
  return (SHOP_FORMS[type]=st);
}
async function sendShopForm(type, fields){
  const st=protectedForm(type), f=st.form;
  f.querySelectorAll("[data-cl]").forEach(n=>n.remove());
  Object.entries(fields).forEach(([k,v])=>{ if(k==="form_type"||k==="utf8") return; const i=document.createElement("input"); i.type="hidden"; i.name=k; i.value=v; i.dataset.cl="1"; f.appendChild(i); });
  const old=f.elements["h-captcha-response"]; if(old) old.value="";
  // wait for Shopify's captcha script to finish binding to the form (normally well under a second)
  const t0=Date.now(); while(window.Shopify && Shopify.captcha && !f.dataset.hcaptchaBound && !f.dataset.recaptchaBound && Date.now()-t0<10000) await new Promise(r=>setTimeout(r,150));
  return new Promise(resolve=>{
    const timer=setTimeout(()=>{ st.pending=null; resolve("fail"); }, 30000);
    st.pending={resolve:v=>{ clearTimeout(timer); resolve(v); }};
    try{ f.submit(); }catch(e){ clearTimeout(timer); st.pending=null; resolve("fail"); }
  });
}
function mailtoLead(d){
  return `mailto:${CL.email}?subject=${encodeURIComponent("12V Battery Simulator: please check my "+SCEN[S.scen].name.toLowerCase()+" setup")}&body=${encodeURIComponent(
    `Name: ${d.name}\nEmail: ${d.email}\nPhone: ${d.phone}\nPostcode: ${d.postcode}\nBest way to reach me: ${leadPref}\n${RIG[S.scen][0]}: ${d.rig}\n\n${d.msg?d.msg+"\n\n":""}${summaryText()}`)}`;
}
async function submitLead(e){
  e.preventDefault();
  const F=$("leadForm").elements, d={};
  ["name","email","phone","postcode","rig","msg"].forEach(k=>d[k]=(F[k].value||"").trim());
  F.name.setAttribute("aria-invalid", !d.name); F.email.setAttribute("aria-invalid", !/^\S+@\S+\.\S+$/.test(d.email));
  if(!d.name) return leadErr("Please add your name so we know who to ask for."), F.name.focus();
  if(!/^\S+@\S+\.\S+$/.test(d.email)) return leadErr("Please check your email address."), F.email.focus();
  if(leadPref==="Phone call" && !d.phone) return leadErr("Add a phone number so we can call you, or choose Email."), F.phone.focus();
  leadErr(""); freshResults();
  const btn=$("leadSend"); btn.disabled=true; btn.querySelector("span").textContent="Sending…";
  const fields=buildLeadFields(d);
  if(CL.leadEndpoint){
    // Sent as a plain form post so Zapier / Make / any webhook accepts it without browser cross-site checks
    const c=cfg(), parts=d.name.split(/\s+/), t=LAST.trip||{};
    const hook=new URLSearchParams({
      email:d.email, first_name:parts[0]||"", last_name:parts.slice(1).join(" "), full_name:d.name,
      phone:d.phone, postcode:d.postcode, vehicle:d.rig, message:d.msg, contact_pref:leadPref,
      marketing_consent: F.news.checked ? "yes" : "no",
      tags:"battery-simulator", source:"12V Battery Simulator ("+leadSrc+")",
      setup:SCEN[S.scen].name, battery:`${c.qty>1?c.qty+" x ":""}${batById(c.batId).name}`, battery_ah:String(c.bat),
      solar_w:String(c.panels*c.panelW), location:locById(S.loc).name, month:MONTHS[S.month], trip_days:String(S.tripDays),
      lowest_battery_pct:String(Math.round(t.minPct||0)), runs_flat: t.flatAt!=null ? "yes" : "no",
      summary:summaryText(), page:location.href
    });
    fetch(CL.leadEndpoint, {method:"POST", mode:"no-cors", keepalive:true, body:hook}).catch(()=>{});
  }
  let ok=false;
  if(ON_SHOPIFY){
    ok = (await sendShopForm("contact", fields))==="ok";
    if(ok && F.news.checked){
      sendShopForm("customer", {"contact[email]":d.email, "contact[first_name]":d.name.split(" ")[0], "contact[tags]":"newsletter,battery-simulator"}).catch(()=>{});
    }
    if(!ok){
      btn.disabled=false; btn.querySelector("span").textContent="Send to Custom Lithium";
      $("leadErr").innerHTML=`Sorry, that didn't send. Please try again, <a href="${mailtoLead(d)}">email it to us instead</a>, or call <a href="tel:+61735194220">(07) 3519 4220</a>.`;
      $("leadErr").hidden=false;
      track("simulator_lead_error", {source:leadSrc});
      return;
    }
  } else {
    // Not on the store (e.g. this preview): open the customer's email app with everything filled in
    try{ const a=document.createElement("a"); a.href=mailtoLead(d); a.target="_blank"; a.rel="noopener"; document.body.appendChild(a); a.click(); a.remove(); }catch(_){}
    ok=true;
  }
  btn.disabled=false; btn.querySelector("span").textContent="Send to Custom Lithium";
  if(ok){
    leadSent=true; track("simulator_lead", {source:leadSrc, scenario:S.scen, pref:leadPref});
    $("leadName").textContent=(d.name.split(" ")[0]||"mate").toUpperCase();
    $("leadDoneText").textContent = ON_SHOPIFY
      ? `Your setup is with the Custom Lithium team. A specialist will ${leadPref==="Email"?"email you":"give you a call"} soon to go through it with you.`
      : `Your email app should open with your setup ready to send to ${CL.email}. Once the simulator is on the website, this goes straight to the team.`;
    $("leadFormWrap").hidden=true; $("leadDone").hidden=false;
  }
}
function bindLead(){
  document.addEventListener("click", e=>{ const b=e.target.closest("[data-lead]"); if(b){ e.preventDefault(); openLead(b.dataset.lead); } });
  $("expertBtn").addEventListener("click", ()=>openLead("topbar"));
  $("leadForm").addEventListener("submit", submitLead);
  $("leadForm").addEventListener("input", e=>{ if(e.target.getAttribute("aria-invalid")==="true") e.target.removeAttribute("aria-invalid"); });
  document.querySelectorAll("#prefSeg button").forEach(b=>b.addEventListener("click", ()=>{
    leadPref=b.dataset.pref; document.querySelectorAll("#prefSeg button").forEach(x=>x.setAttribute("aria-pressed", x===b)); }));
  $("leadBuy").addEventListener("click", ()=>{ $("leadModal").hidden=true; openBuy(); });
  $("cartGo").addEventListener("click", goToCart);
  $("nudgeX").addEventListener("click", ()=>{ hideNudge(); nudgeDone=true; });
  if(ON_SHOPIFY){ if($("captchaNote")) $("captchaNote").hidden=false; $("brandLink").href="/"; document.querySelectorAll('a[href^="https://customlithium.com.au/policies"]').forEach(a=>a.href=a.getAttribute("href").replace(CL_STORE_RE,"")); }
  if(/contact_posted=true/.test(location.search)){ // came back after Shopify's spam check
    setTimeout(()=>{ $("leadModal").hidden=false; $("leadFormWrap").hidden=true; $("leadDone").hidden=false; $("leadName").textContent="MATE";
      $("leadDoneText").textContent="Your setup is with the Custom Lithium team. A specialist will be in touch soon."; leadSent=true; }, 1200);
  }
  // one gentle nudge: after a few minutes of building, or the first time the report is closed
  setTimeout(()=>maybeNudge(), 150000);
}
let nudgeDone=false;
function maybeNudge(){
  if(nudgeDone || leadSent || !$("tour").hidden || !$("sheet").hidden || [...document.querySelectorAll(".modal")].some(m=>!m.hidden)) return;
  nudgeDone=true; $("nudge").hidden=false; track("simulator_nudge_shown", {scenario:S.scen});
}
function hideNudge(){ $("nudge").hidden=true; }

/* ================= REPORT ================= */
let REC=null, LAST={};
function renderPlan(){
  const el=$("planDays");
  const wk = S.planPreset==="week" && S.week;
  $("planWeekBtn").hidden=!S.week;
  document.querySelectorAll("#planSeg button").forEach(x=>x.setAttribute("aria-pressed", x.dataset.plan===S.planPreset));
  el.innerHTML=[...Array(7)].map((_,d)=>{ const w=planMain(d); return `<button type="button" class="daychip${S.view==="daily"&&d===0?" cur":""}" data-d="${d}" title="Click to change Day ${d+1} weather"><b>DAY ${d+1}</b><svg aria-hidden="true"><use href="#${WEATHER[w].icon}"/></svg><small>${WEATHER[w].name}</small>${wk?`<small class="num">${S.week.days[d].tmax}°/${S.week.days[d].tmin}°</small>`:""}</button>`; }).join("")
    + (S.tripDays>7?`<span class="hint" style="align-self:center">Days 8–${S.tripDays} repeat this week</span>`:"");
}
function whenStr(t){ t=Math.min(t, S.tripDays*24-1/60); return `Day ${Math.floor(t/24)+1}, ${fmtClock(t)}`; }

function renderReport(){
  const c=cfg(), list=apps(), D=S.tripDays;
  renderPlan();
  const trip=simulate(c,list,D,planWeather,{series:false});
  const week=simulate(c,list,7,planWeather,{series:true,every:2,audit:true});
  const day=simulate(c,list,1,planWeather,{series:true});
  REC=recommend();
  const dem=REC.dem;
  LAST={trip,week,day,dem};
  const tripIn = trip.perDay.reduce((s,p)=>s+p.solar+p.dcdc+p.chg,0)/D;
  // intro
  $("repIntro").textContent=`${SCEN[S.scen].name} · ${c.qty>1?c.qty+" × ":""}${batById(c.batId).name}${c.qty>1?` (${fmtW(c.bat)}Ah)`:""} · ${fmtW(c.panels*c.panelW)}W solar · ${D} day${D>1?"s":""} off-grid near ${locById(S.loc).name} in ${MONTHS[S.month]}.`;
  // verdict
  const v=$("verdict"); let cls="", icon="i-check", title, text;
  const minP=Math.round(trip.minPct);
  if(trip.flatAt!==null){ cls="bad"; icon="i-x"; title=`Your battery runs flat on ${whenStr(trip.flatAt)}`;
    text=`Your gear uses about ${fmtW(dem.wh)}Wh a day and you're putting back about ${fmtW(tripIn)}Wh. The setup below keeps you powered for all ${D} days.`; }
  else if(trip.minPct<RESERVE*100){ cls="warn"; icon="i-alert"; title=`You'll make it, but only just`;
    text=`The battery drops to ${minP}% on ${whenStr(trip.minAt)}. Lithium can go lower, but we recommend keeping 20% in reserve for bad weather.`; }
  else { title=`You're powered for all ${D} day${D>1?"s":""}`; text=`Lowest charge is ${minP}% on ${whenStr(trip.minAt)}. You finish the trip at ${Math.round(trip.endSoc/trip.capWh*100)}%.`; }
  v.className="verdict "+cls; v.querySelector(".vi").innerHTML=`<svg><use href="#${icon}"/></svg>`; $("vTitle").textContent=title; $("vText").textContent=text;
  // stats
  const other=REC.other;
  const net=dem.wh-other;
  const auto = net>0 ? (trip.capWh*(1-RESERVE))/net : Infinity;
  const avgSolar=trip.perDay.reduce((s,p)=>s+p.solar,0)/D;
  $("stats").innerHTML=[
    ["Used per day", `${fmtW(dem.wh)}<small>Wh</small>`, `${fmtW(dem.wh/VNOM)}Ah${dem.peakAC?` · up to ${fmtW(dem.peakAC)}W on 240V at once`:" · no 240V gear"}`],
    ["Put back per day", `${fmtW(tripIn)}<small>Wh</small>`, `Solar ${fmtW(avgSolar)}Wh${other?` · other chargers ${fmtW(tripIn-avgSolar)}Wh`:""}`],
    ["Lowest battery", `${minP}<small>%</small>`, whenStr(trip.minAt)],
    ["With no sun at all", isFinite(auto)?`${auto.toFixed(1)}<small>days</small>`:`∞`, isFinite(auto)?`From full, keeping 20% reserve`:`Your other chargers cover daily use`]
  ].map(s=>`<div class="stat"><div class="sl">${s[0]}</div><div class="sv">${s[1]}</div><div class="ss">${s[2]}</div></div>`).join("");
  // charts
  const r = S.view==="daily" ? day : week;
  const days = S.view==="daily" ? 1 : 7;
  $("socChartTitle").textContent = S.view==="daily" ? "Battery level · Day 1" : "Battery level · 7 days";
  $("socChartSub").textContent = S.view==="daily" ? `${WEATHER[planMain(0)].name}, starting at ${c.soc}% at midnight. Shaded bands are night.` : `Following your weather plan, starting at ${c.soc}%. Shaded bands are night.`;
  socChart(r.series, days, r.capWh);
  ioChart(r, days);
  // breakdown
  const per = days;
  const items = list.filter(a=>r.appWh[a.id]>0.5).map(a=>({n:a.name, wh:r.appWh[a.id]/per}));
  const invLoss = r.perDay.reduce((s,p)=>s+p.inv,0)/per;
  if(invLoss>1) items.push({n:"Inverter standby & losses", wh:invLoss});
  items.sort((a,b)=>b.wh-a.wh);
  const tot=items.reduce((s,i)=>s+i.wh,0)||1, max=items[0]?items[0].wh:1;
  $("bdSub").textContent = `${fmtW(tot)}Wh per day${S.view==="weekly"?" (7-day average)":""}`;
  $("breakdown").innerHTML = items.length ? items.map(i=>`<li><span class="bn" title="${i.n}">${i.n}</span><span class="bt"><i style="width:${(i.wh/max*100).toFixed(1)}%"></i></span><span class="bv">${fmtW(i.wh)}Wh<small>${Math.round(i.wh/tot*100)}%</small></span></li>`).join("") : `<li class="hint">Switch on some appliances to see where your power goes.</li>`;
  renderRecs();
  renderTable(trip, D);
  renderAudit(week);
}

function pill(cur, rec, opt){
  if(opt) return `<span class="pill opt">Optional</span>`;
  if(cur>=rec && cur<=rec*1.6) return `<span class="pill ok"><svg width="12" height="12"><use href="#i-check"/></svg>Good</span>`;
  if(cur<rec) return `<span class="pill up">Upgrade</span>`;
  return `<span class="pill down">Could go smaller</span>`;
}
function renderRecs(){
  const c=cfg(), R=REC, cards=[];
  const bp=R.batPick, cb=batById(c.batId);
  const bLine = p => `${p.q>1?p.q+" × ":""}${p.b.name}`;
  cards.push({ic:"i-battery", h:"Battery", now:`${c.qty>1?c.qty+" × ":""}${cb.ah}Ah (${fmtW(c.bat)}Ah)`, rv: bp?`${fmtW(bp.ah)}Ah`:`${fmtW(R.bat)}Ah+`, p: bp? pill(c.bat,bp.ah) : `<span class="pill up">Upgrade</span>`,
    t: bp ? `<b>${bLine(bp)}</b> · ${money(bp.b.price*bp.q)}${bp.b.from?" (from)":""}. You need at least ${fmtW(R.bat)}Ah to stay above 20% for ${S.tripDays} day${S.tripDays>1?"s":""} with the recommended solar and to cover a full day with no charging.`
         : `You need more than 4 of any battery in the range. Talk to Custom Lithium about a custom bank or add more charging.`,
    links: bp ? [`<a class="linkbtn" href="${bp.b.url}" target="_blank" rel="noopener">View ${bp.b.name}<svg><use href="#i-ext"/></svg></a>`].concat(R.batAlt?[`<span class="hint" style="margin:0">Or ${bLine(R.batAlt)}, ${money(R.batAlt.b.price*R.batAlt.q)}</span><a class="linkbtn" href="${R.batAlt.b.url}" target="_blank" rel="noopener">View<svg><use href="#i-ext"/></svg></a>`]:[]) : []});
  const sNeed=R.recSolarW;
  cards.push({ic:"i-solar", h:"Solar panels", now:`${fmtW(c.panels*c.panelW)}W`, rv:`${fmtW(sNeed)}W`, p: sNeed===0 ? `<span class="pill opt">Not needed</span>` : pill(c.panels*c.panelW, sNeed),
    t: sNeed===0 ? `Your other chargers cover your daily use.` : `${R.panels} × ${c.panelW}W panels. Covers ${fmtW(R.dem.wh)}Wh a day with ${Math.round(R.wfAvg*100)}% average sun${R.solarCapped?". Capped at 12 panels: consider bigger panels":""}.`});
  { const cur=solarCtrl(c), rc=R.ctrlRec;
    cards.push({ic:"i-sun", h:"Solar controller", now: cur.via?`Alpha ${cur.a}`:cur.label.replace("Victron SmartSolar ","").replace("× Victron ","× "), rv: rc.via?`Alpha ${rc.a}`:rc.label.replace("Victron SmartSolar ","").replace("× Victron ","× "),
      p: sNeed===0?`<span class="pill opt">Not needed</span>`:pill(cur.w,rc.w),
      t: rc.via ? `Your Redarc Alpha ${rc.a}'s built-in MPPT handles up to ${fmtW(rc.w)}W of panels, so you don't need a separate solar controller.`
                : `${rc.label} handles up to ${fmtW(rc.w)}W of panels, enough for ${fmtW(sNeed)}W so nothing gets wasted at midday.`}); }
  cards.push({ic:"i-inverter", h:"Inverter", now: c.inverter?`${c.inverter}W`:"None", rv: R.inv?`${R.inv}W`:"None", p: R.inv? pill(c.inverter,R.inv) : `<span class="pill opt">Not needed</span>`,
    t: R.inv ? `Your busiest moment needs ${fmtW(R.dem.peakAC)}W of 240V at once. Sized with 20% headroom${R.invCapped?". Over 3000W: stagger high-draw appliances":""}.` : `None of your switched-on gear needs 240V.`});
  if(S.scen!=="shed"){
    const drives=c.driveH>0;
    cards.push({ic:"i-engine", h:"DC-DC charger", now: c.dcdc?`${c.dcdc}A`:"None", rv:`${R.dcdc}A`, p: drives? pill(c.dcdc,R.dcdc) : `<span class="pill opt">Optional</span>`,
      t: drives ? `Charges from the alternator while you drive. Matched to a ${fmtW(R.bankAh)}Ah bank.` : `Add one to top up while you drive. ${R.dcdc}A suits a ${fmtW(R.bankAh)}Ah bank.`,
      links: (()=>{ const o=dcdcOpt(REC_DCDC_KEY[R.dcdc]||R.dcdc); return o.p?[prodLink(DCDC_PRODUCTS[o.p])+(o.q>1?` × ${o.q}`:"")]:[]; })()});
  }
  cards.push({ic:"i-plug", h: S.scen==="shed"?"Generator / mains charger":"240V battery charger", now: c.charger?`${c.charger}A`:"None", rv:`${R.chg}A`, p: c.charger? pill(c.charger,R.chg) : `<span class="pill opt">Optional</span>`,
    t: c.charger ? `Recharges from ${c.src==="gen"?"a generator":"mains power"} at a safe rate for a ${fmtW(R.bankAh)}Ah bank.` : `Handy backup for long stretches of bad weather. ${R.chg}A suits a ${fmtW(R.bankAh)}Ah bank.`,
    links: CHG_PRODUCTS[R.chg]?[prodLink(CHG_PRODUCTS[R.chg])]:[]});
  $("recs").innerHTML=cards.map(k=>`<div class="rec"><div class="rec-top"><span class="ci"><svg><use href="#${k.ic}"/></svg></span><h4>${k.h}</h4>${k.p}</div>
    <div class="rec-vals"><span class="rv">${k.rv}</span><span class="now">You have ${k.now}</span></div><p>${k.t}</p>${(k.links||[]).length?`<div class="rec-links">${k.links.join("")}</div>`:""}</div>`).join("");
  $("recIntro").textContent=`Sized for ${S.tripDays} day${S.tripDays>1?"s":""} with your weather plan, keeping at least 20% in the battery.`;
}
function renderTable(trip, D){
  const rows=trip.perDay.map((p,i)=>`<tr><td>Day ${i+1}</td><td style="text-align:left">${WEATHER[planMain(i)].name}</td><td>${fmtW(p.solar)}</td><td>${fmtW(p.dcdc)}</td><td>${fmtW(p.chg)}</td><td>${fmtW(p.used)}</td><td>${Math.round(p.min/trip.capWh*100)}%</td></tr>`).join("");
  $("numTable").innerHTML=`<table><thead><tr><th>Day</th><th style="text-align:left">Weather</th><th>Solar Wh</th><th>DC-DC Wh</th><th>Charger Wh</th><th>Used Wh</th><th>Lowest</th></tr></thead><tbody>${rows}</tbody></table>`;
}

/* ---------- charts ---------- */
function chartDims(el, h){ const w=Math.max(300, el.clientWidth||600); return {w, h}; }
function nightBands(days, x, top, bot){
  const si=sunInfo(); let s="";
  for(let d=0; d<days; d++){
    s+=`<rect class="ch-night" x="${x(d*24)}" y="${top}" width="${x(d*24+si.sr)-x(d*24)}" height="${bot-top}"/>`;
    s+=`<rect class="ch-night" x="${x(d*24+si.ss)}" y="${top}" width="${x((d+1)*24)-x(d*24+si.ss)}" height="${bot-top}"/>`;
  }
  return s;
}
function socChart(series, days, cap){
  const el=$("socChart"); const {w,h}=chartDims(el, 240);
  const m={l:40,r:16,t:14,b:28}, T=days*24;
  const x=t=>m.l+(w-m.l-m.r)*t/T, y=p=>m.t+(h-m.t-m.b)*(1-p/100);
  let s=`<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" role="img" aria-label="Battery level over time">`;
  s+=nightBands(days,x,m.t,h-m.b);
  for(const p of [0,25,50,75,100]) s+=`<line class="ch-grid" x1="${m.l}" x2="${w-m.r}" y1="${y(p)}" y2="${y(p)}"/><text x="${m.l-8}" y="${y(p)+4}" text-anchor="end">${p}%</text>`;
  s+=`<line class="ch-res" x1="${m.l}" x2="${w-m.r}" y1="${y(20)}" y2="${y(20)}"/><text x="${w-m.r}" y="${y(20)-5}" text-anchor="end">20% reserve</text>`;
  if(days===1){ for(const hh of [0,6,12,18,24]) s+=`<text x="${x(hh)}" y="${h-8}" text-anchor="${hh===0?"start":hh===24?"end":"middle"}">${fmtClock(hh).replace(":00","")}</text>`; }
  else { for(let d=0;d<days;d++){ s+=`<text x="${x(d*24+12)}" y="${h-8}" text-anchor="middle">Day ${d+1}</text>`; if(d) s+=`<line class="ch-grid" x1="${x(d*24)}" x2="${x(d*24)}" y1="${m.t}" y2="${h-m.b}"/>`; } }
  const pts=[[0, null]]; // starting value
  const start=series.length? series[0].soc : 0;
  let d=`M${x(0)} ${y(start)}`; for(const p of series) d+=` L${x(p.t).toFixed(1)} ${y(p.soc).toFixed(1)}`;
  const last=series[series.length-1]||{t:0,soc:0};
  s+=`<path class="ch-area" d="${d} L${x(last.t)} ${y(0)} L${x(0)} ${y(0)} Z"/>`;
  s+=`<path class="ch-line" d="${d}"/>`;
  s+=`<circle class="ch-dot" cx="${x(last.t)}" cy="${y(last.soc)}" r="4.5"/>`;
  s+=`<text class="ch-lab" x="${x(last.t)-8}" y="${y(last.soc)-10}" text-anchor="end">${Math.round(last.soc)}%</text>`;
  s+=`<line class="ch-cross" id="socCross" x1="0" x2="0" y1="${m.t}" y2="${h-m.b}" style="opacity:0"/><circle class="ch-dot" id="socHov" r="4.5" style="opacity:0"/>`;
  s+=`<rect x="${m.l}" y="${m.t}" width="${w-m.l-m.r}" height="${h-m.t-m.b}" fill="transparent" id="socHit"/></svg><div class="tip" id="socTip"></div>`;
  el.innerHTML=s;
  const hit=$("socHit"), tip=$("socTip"), cross=$("socCross"), hov=$("socHov");
  const move=(ev)=>{
    const rect=el.querySelector("svg").getBoundingClientRect(); const px=(ev.clientX-rect.left)*(w/rect.width);
    const t=clamp((px-m.l)/(w-m.l-m.r)*T,0,T); let best=series[0], bd=1e9; for(const p of series){ const dd=Math.abs(p.t-t); if(dd<bd){bd=dd;best=p;} }
    if(!best) return;
    cross.setAttribute("x1",x(best.t)); cross.setAttribute("x2",x(best.t)); cross.style.opacity=1;
    hov.setAttribute("cx",x(best.t)); hov.setAttribute("cy",y(best.soc)); hov.style.opacity=1;
    const inW=best.solar+best.dcdc+best.chg;
    tip.innerHTML=`<b>${days>1?`Day ${Math.floor((best.t-0.001)/24)+1}, `:""}${fmtClock(best.t)}</b><br><span class="k" style="background:var(--green)"></span>Battery ${Math.round(best.soc)}%<br>Charging ${fmtW(inW)}W · Using ${fmtW(best.load)}W`;
    tip.style.opacity=1; const tx=x(best.t)/w*rect.width; tip.style.left=Math.min(rect.width-170, Math.max(0,tx+12))+"px"; tip.style.top="8px";
  };
  hit.addEventListener("pointermove",move); hit.addEventListener("pointerleave",()=>{tip.style.opacity=0;cross.style.opacity=0;hov.style.opacity=0;});
}
function bar(x,y0,w,h,r=4){ if(h<=0.5) return ""; r=Math.min(r,h,w/2); const y=y0-h; return `M${x} ${y0} L${x} ${y+r} Q${x} ${y} ${x+r} ${y} L${x+w-r} ${y} Q${x+w} ${y} ${x+w} ${y+r} L${x+w} ${y0} Z`; }
function niceMax(v){ if(v<=0) return 100; const p=Math.pow(10,Math.floor(Math.log10(v))); for(const k of [1,1.5,2,2.5,3,4,5,6,8,10]) if(k*p>=v) return k*p; return 10*p; }
function ioChart(r, days){
  const el=$("ioChart"); const {w,h}=chartDims(el,240);
  const m={l:46,r:10,t:14,b:28};
  let groups=[];
  if(days===1){ for(let hh=0;hh<24;hh++) groups.push({lab:hh, inn:0, out:0}); for(const p of r.series){ const hh=Math.min(23,Math.floor((p.t-STEP/2))); groups[hh].inn+=(p.solar+p.dcdc+p.chg)*STEP; groups[hh].out+=p.load*STEP; } }
  else groups=r.perDay.map((p,i)=>({lab:i, inn:p.solar+p.dcdc+p.chg, out:p.used}));
  $("ioChartTitle").textContent = days===1 ? "Charged vs used · by hour" : "Charged vs used · by day";
  $("ioChartSub").textContent = days===1 ? "Watt-hours each hour of Day 1" : "Watt-hours each day of the week";
  const mx=niceMax(Math.max(...groups.map(g=>Math.max(g.inn,g.out)),1));
  const y=v=>m.t+(h-m.t-m.b)*(1-v/mx), base=y(0);
  const gw=(w-m.l-m.r)/groups.length, bw=Math.min(24, Math.max(3,(gw-6)/2));
  let s=`<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" role="img" aria-label="Energy charged versus used">`;
  for(let i=0;i<=4;i++){ const v=mx*i/4; s+=`<line class="ch-grid" x1="${m.l}" x2="${w-m.r}" y1="${y(v)}" y2="${y(v)}"/><text x="${m.l-8}" y="${y(v)+4}" text-anchor="end">${fmtW(v)}</text>`; }
  groups.forEach((g,i)=>{
    const cx=m.l+gw*i+gw/2;
    s+=`<path class="ch-in" d="${bar(cx-bw-1,base,bw,base-y(g.inn))}"/><path class="ch-out" d="${bar(cx+1,base,bw,base-y(g.out))}"/>`;
    if(days===1){ if(i%6===0) s+=`<text x="${cx}" y="${h-8}" text-anchor="middle">${fmtClock(i).replace(":00","")}</text>`; }
    else { s+=`<text x="${cx}" y="${h-8}" text-anchor="middle">Day ${i+1}</text>`; }
    s+=`<rect x="${m.l+gw*i}" y="${m.t}" width="${gw}" height="${h-m.t-m.b}" fill="transparent" data-i="${i}" class="io-hit"/>`;
  });
  s+=`</svg><div class="tip" id="ioTip"></div>`;
  el.innerHTML=s;
  const tip=$("ioTip");
  el.querySelectorAll(".io-hit").forEach(rc=>{
    rc.addEventListener("pointerenter",()=>{ const g=groups[+rc.dataset.i]; const rect=el.querySelector("svg").getBoundingClientRect();
      tip.innerHTML=`<b>${days===1?`${fmtClock(g.lab)} – ${fmtClock(g.lab+1)}`:`Day ${g.lab+1} · ${WEATHER[planMain(g.lab)].name}`}</b><br><span class="k" style="background:var(--green)"></span>Charged ${fmtW(g.inn)}Wh<br><span class="k" style="background:var(--used)"></span>Used ${fmtW(g.out)}Wh`;
      const cx=(m.l+gw*(+rc.dataset.i)+gw/2)/w*rect.width; tip.style.left=Math.min(rect.width-170,Math.max(0,cx+10))+"px"; tip.style.top="8px"; tip.style.opacity=1; rc.setAttribute("fill","rgba(127,127,127,.06)"); });
    rc.addEventListener("pointerleave",()=>{ tip.style.opacity=0; rc.setAttribute("fill","transparent"); });
  });
}

/* ---------- actions ---------- */
function applyRec(){
  if(!REC) return; const c=cfg(); const pct=Lv.soc/capWh();
  if(REC.batPick){ c.batId=REC.batPick.b.id; c.qty=REC.batPick.q; applyBat(c); } c.panels=REC.panels; c.mpptKey=REC.mpptKey; c.mppt=REC.mppt; if(REC.inv) c.inverter=REC.inv;
  if(S.scen!=="shed" && c.driveH>0 && !(alphaA(c) >= REC.dcdc)){ c.dcdc=REC.dcdc; c.dcdcKey=REC_DCDC_KEY[REC.dcdc]||String(REC.dcdc); } // keep an Alpha that already covers it
  if(c.mpptKey==="alpha" && !alphaA(c)) c.mpptKey=bestCtrlKey(c, c.panels*c.panelW);
  Lv.soc=capWh()*pct;
  syncControls(); renderApps(); updatePanels(); updateProps(); renderReport();
  toast("apply"+perfNow,"Recommended setup applied");
}
function summaryText(){
  const c=cfg(), R=REC, t=LAST.trip, D=S.tripDays;
  const on=apps().filter(a=>a.on).map(a=>`  - ${a.name}${a.count&&(a.n||1)>1?` x ${a.n}`:""} (${a.w}W${a.count&&(a.n||1)>1?" each":""}, ${a.fixed?"24h cycling":fmtHours(a.hours)+"/day"})`).join("\n");
  return `Custom Lithium 12V Battery Simulator: ${SCEN[S.scen].name}
Trip: ${D} days, ${locById(S.loc).name}, ${MONTHS[S.month]}
Weather plan: ${[...Array(Math.min(7,D))].map((_,d)=>WEATHER[planMain(d)].name).join(", ")}

Current setup
  Battery ${c.qty>1?c.qty+" x ":""}${batById(c.batId).name} (${c.bat}Ah) ${batById(c.batId).url}
  Solar ${c.panels} x ${c.panelW}W (${solarCtrl(c).label}) · Inverter ${c.inverter||"none"}${c.inverter?"W":""}
${c.portW>0?`  Portable solar ${c.portW}W for ${c.portH}h/day\n`:""}  ${S.scen!=="shed"?`DC-DC ${c.dcdc?dcdcOpt(c.dcdcKey||c.dcdc).label:"none"}, ${c.driveH}h driving/day · `:""}240V charger ${c.charger||"none"}${c.charger?"A":""}
Appliances
${on||"  (none)"}

Result: uses ${fmtW(LAST.dem.wh)}Wh/day, lowest battery ${Math.round(t.minPct)}%${t.flatAt!==null?`, runs flat on ${whenStr(t.flatAt)}`:""}

Recommended
  Battery ${R.batPick?`${R.batPick.q>1?R.batPick.q+" x ":""}${R.batPick.b.name} (${R.batPick.ah}Ah) ${R.batPick.b.url}`:"more than 4 batteries"}
  Solar ${fmtW(R.recSolarW)}W (${R.panels} x ${c.panelW}W) · Controller ${R.ctrlRec.label} · Inverter ${R.inv?R.inv+"W":"not needed"}${S.scen!=="shed"?` · DC-DC ${R.dcdc}A`:""} · 240V charger ${R.chg}A`;
}
function copySummary(){
  const txt=summaryText(), btn=$("copyBtn");
  const done=()=>{ btn.lastChild.textContent="Copied"; setTimeout(()=>btn.lastChild.textContent="Copy summary",1800); };
  const fallback=()=>{ const ta=document.createElement("textarea"); ta.value=txt; ta.style.position="fixed"; ta.style.opacity="0"; document.body.appendChild(ta); ta.select(); try{document.execCommand("copy"); done();}catch(e){} ta.remove(); };
  try{ navigator.clipboard.writeText(txt).then(done, fallback); }catch(e){ fallback(); }
}

/* ================= INIT ================= */
LOGO_D = document.querySelector(".brand svg path").getAttribute("d");
document.documentElement.setAttribute("data-theme","dark");
buildFlow(); syncControls(); renderApps(); bindUI(); resize(); buildScene(); resetLive();
if(isPhone()){ $("flowBody").hidden=false; $("flowToggle").setAttribute("aria-expanded","true"); }
if(document.fonts) document.fonts.ready.then(()=>{ fitView(true); refitBatLabels(); });
bindTour(); bindLead();
// quick "how to use" tour on first load. On the live store it only shows on a customer's first visit (the ? button replays it).
(function(){ let seen=false; if(ON_SHOPIFY){ try{ seen=localStorage.getItem("cl-sim-tour")==="1"; localStorage.setItem("cl-sim-tour","1"); }catch(e){} }
  if(!seen && !/contact_posted=true/.test(location.search)) setTimeout(startTour, 900); })();
requestAnimationFrame(frame);

